var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVanDamage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 494.7 322.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{isolation:isolate;}.cls-102,.cls-121,.cls-129,.cls-135,.cls-136,.cls-137,.cls-182,.cls-183,.cls-184,.cls-185,.cls-186,.cls-187,.cls-188,.cls-189,.cls-190,.cls-191,.cls-192,.cls-193,.cls-220,.cls-222,.cls-224,.cls-225,.cls-226,.cls-227,.cls-228,.cls-229,.cls-249,.cls-250,.cls-27,.cls-270,.cls-271,.cls-276,.cls-277,.cls-278,.cls-28,.cls-281,.cls-283,.cls-284,.cls-285,.cls-287,.cls-288,.cls-289,.cls-3,.cls-305,.cls-306,.cls-313,.cls-314,.cls-317,.cls-319,.cls-323,.cls-324,.cls-325,.cls-326,.cls-327,.cls-328,.cls-329,.cls-330,.cls-331,.cls-332,.cls-333,.cls-334,.cls-335,.cls-336,.cls-337,.cls-338,.cls-339,.cls-340,.cls-341,.cls-342,.cls-343,.cls-344,.cls-345,.cls-346,.cls-347,.cls-348,.cls-349,.cls-350,.cls-351,.cls-352,.cls-353,.cls-354,.cls-355,.cls-356,.cls-357,.cls-358,.cls-359,.cls-360,.cls-361,.cls-362,.cls-363,.cls-364,.cls-365,.cls-366,.cls-367,.cls-368,.cls-369,.cls-370,.cls-371,.cls-372,.cls-373,.cls-374,.cls-375,.cls-376,.cls-377,.cls-378,.cls-379,.cls-380,.cls-381,.cls-382,.cls-383,.cls-384,.cls-385,.cls-386,.cls-387,.cls-388,.cls-389,.cls-390,.cls-391,.cls-392,.cls-393,.cls-394,.cls-399,.cls-4,.cls-400,.cls-413,.cls-414,.cls-419,.cls-420,.cls-460,.cls-461,.cls-462,.cls-465,.cls-467,.cls-469,.cls-470,.cls-471,.cls-475,.cls-476,.cls-48,.cls-49,.cls-5,.cls-54,.cls-55,.cls-56,.cls-57,.cls-6,.cls-7,.cls-72,.cls-75,.cls-76,.cls-77,.cls-79,.cls-80{mix-blend-mode:multiply;}.cls-3{fill:url(#radial-gradient);}.cls-4{fill:url(#radial-gradient-2);}.cls-5{fill:url(#radial-gradient-3);}.cls-6{fill:url(#radial-gradient-4);}.cls-7{fill:url(#radial-gradient-5);}.cls-8{fill:url(#radial-gradient-6);}.cls-9{fill:url(#radial-gradient-7);}.cls-10{fill:url(#radial-gradient-8);}.cls-11{fill:url(#radial-gradient-9);}.cls-12{fill:url(#radial-gradient-10);}.cls-13{fill:url(#radial-gradient-11);}.cls-14{fill:url(#radial-gradient-12);}.cls-15{fill:url(#radial-gradient-13);}.cls-16{fill:url(#radial-gradient-14);}.cls-17{fill:url(#linear-gradient);}.cls-18{fill:url(#linear-gradient-2);}.cls-19{fill:url(#linear-gradient-3);}.cls-20{fill:url(#linear-gradient-4);}.cls-21{fill:url(#linear-gradient-5);}.cls-22{fill:url(#linear-gradient-6);}.cls-23{fill:url(#linear-gradient-7);}.cls-24{fill:url(#linear-gradient-8);}.cls-25{fill:url(#linear-gradient-9);}.cls-26{fill:url(#linear-gradient-10);}.cls-27{fill:url(#radial-gradient-15);}.cls-28{fill:url(#linear-gradient-11);}.cls-29{fill:url(#radial-gradient-16);}.cls-30{fill:url(#radial-gradient-17);}.cls-31{fill:url(#radial-gradient-18);}.cls-32{fill:url(#radial-gradient-19);}.cls-33{fill:url(#radial-gradient-20);}.cls-34{fill:url(#radial-gradient-21);}.cls-35{fill:url(#radial-gradient-22);}.cls-36{fill:url(#radial-gradient-23);}.cls-37{fill:url(#radial-gradient-24);}.cls-38{fill:url(#linear-gradient-12);}.cls-39{fill:url(#linear-gradient-13);}.cls-40{fill:url(#linear-gradient-14);}.cls-41{fill:url(#linear-gradient-15);}.cls-42{fill:url(#linear-gradient-16);}.cls-43{fill:url(#linear-gradient-17);}.cls-44{fill:url(#linear-gradient-18);}.cls-45{fill:url(#linear-gradient-19);}.cls-46{fill:url(#linear-gradient-20);}.cls-47{fill:url(#linear-gradient-21);}.cls-48{fill:url(#radial-gradient-25);}.cls-49{fill:url(#linear-gradient-22);}.cls-50{fill:url(#radial-gradient-26);}.cls-51{fill:url(#linear-gradient-23);}.cls-52{fill:url(#linear-gradient-24);}.cls-53{fill:url(#linear-gradient-25);}.cls-54{fill:url(#linear-gradient-26);}.cls-55{fill:url(#radial-gradient-27);}.cls-101,.cls-56{fill:#b8b8be;}.cls-57{fill:url(#linear-gradient-27);}.cls-58{fill:url(#linear-gradient-28);}.cls-59{fill:url(#linear-gradient-29);}.cls-60{fill:#7f7f83;}.cls-100,.cls-101,.cls-111,.cls-112,.cls-113,.cls-114,.cls-115,.cls-116,.cls-117,.cls-118,.cls-119,.cls-120,.cls-138,.cls-139,.cls-140,.cls-141,.cls-142,.cls-143,.cls-144,.cls-145,.cls-146,.cls-282,.cls-416,.cls-418,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69,.cls-70,.cls-71,.cls-73,.cls-81,.cls-82,.cls-83,.cls-84,.cls-85,.cls-86,.cls-87,.cls-88,.cls-89,.cls-90,.cls-91,.cls-92,.cls-93,.cls-94,.cls-95,.cls-96,.cls-97,.cls-98,.cls-99{mix-blend-mode:overlay;}.cls-61{fill:#868688;}.cls-62{fill:#8c8c8e;}.cls-63{fill:#939393;}.cls-64{fill:#999998;}.cls-65{fill:#a0a09e;}.cls-66{fill:#a6a6a3;}.cls-67{fill:#adada9;}.cls-68{fill:#b3b3ae;}.cls-69{fill:#babab3;}.cls-70{fill:#c0c0b9;}.cls-71{fill:#c7c7be;}.cls-72{fill:url(#linear-gradient-30);}.cls-73{fill:url(#linear-gradient-31);}.cls-106,.cls-107,.cls-108,.cls-109,.cls-110,.cls-123,.cls-125,.cls-126,.cls-127,.cls-163,.cls-164,.cls-165,.cls-166,.cls-167,.cls-168,.cls-169,.cls-170,.cls-171,.cls-172,.cls-173,.cls-174,.cls-175,.cls-176,.cls-177,.cls-178,.cls-179,.cls-292,.cls-293,.cls-294,.cls-295,.cls-296,.cls-297,.cls-298,.cls-299,.cls-300,.cls-403,.cls-404,.cls-406,.cls-440,.cls-441,.cls-442,.cls-443,.cls-444,.cls-445,.cls-452,.cls-453,.cls-454,.cls-455,.cls-456,.cls-477,.cls-478,.cls-479,.cls-74{mix-blend-mode:soft-light;}.cls-75{fill:url(#linear-gradient-32);}.cls-76{fill:url(#linear-gradient-33);}.cls-77{fill:url(#linear-gradient-34);}.cls-78{fill:url(#linear-gradient-35);}.cls-79{fill:url(#linear-gradient-36);}.cls-80{fill:url(#linear-gradient-37);}.cls-81{fill:#848488;}.cls-82{fill:#89898d;}.cls-83{fill:#8e8e93;}.cls-84{fill:#939398;}.cls-85{fill:#98989d;}.cls-86{fill:#9d9da2;}.cls-87{fill:#a2a2a7;}.cls-88{fill:#a7a7ac;}.cls-89{fill:#acacb2;}.cls-90{fill:#b1b1b7;}.cls-91{fill:#b6b6bc;}.cls-92{fill:#89898e;}.cls-93{fill:#8f8f93;}.cls-94{fill:#949498;}.cls-95{fill:#99999e;}.cls-96{fill:#9e9ea3;}.cls-97{fill:#a3a3a9;}.cls-98{fill:#a8a8ae;}.cls-99{fill:#aeaeb3;}.cls-100{fill:#b3b3b9;}.cls-102{fill:url(#linear-gradient-38);}.cls-103{fill:url(#linear-gradient-39);}.cls-104{fill:url(#linear-gradient-41);}.cls-105,.cls-128,.cls-163,.cls-164,.cls-165,.cls-166,.cls-167,.cls-168,.cls-169,.cls-170,.cls-171,.cls-172,.cls-173,.cls-174,.cls-175,.cls-176,.cls-177,.cls-178,.cls-179,.cls-182,.cls-216,.cls-445{fill:#fff;}.cls-105,.cls-445{opacity:0.52;}.cls-106{fill:url(#linear-gradient-42);}.cls-107{fill:url(#linear-gradient-43);}.cls-108{fill:url(#linear-gradient-44);}.cls-109{fill:url(#linear-gradient-45);}.cls-110{fill:url(#linear-gradient-46);}.cls-111{fill:#838387;}.cls-112{fill:#86868b;}.cls-113{fill:#8a8a8f;}.cls-114{fill:#929297;}.cls-115{fill:#95959b;}.cls-116{fill:#99999f;}.cls-117{fill:#9d9da3;}.cls-118{fill:#a1a1a7;}.cls-119{fill:#a4a4ab;}.cls-120{fill:#a8a8af;}.cls-122,.cls-129{fill:#bd0000;}.cls-123{fill:url(#linear-gradient-47);}.cls-124{fill:#e50000;}.cls-125{fill:url(#linear-gradient-48);}.cls-126{fill:url(#linear-gradient-49);}.cls-127{fill:url(#linear-gradient-50);}.cls-128{opacity:0.2;}.cls-130{fill:url(#linear-gradient-51);}.cls-131{fill:url(#linear-gradient-52);}.cls-132{fill:url(#linear-gradient-53);}.cls-133{fill:#232628;}.cls-134{fill:url(#linear-gradient-54);}.cls-135{fill:#a8b3af;}.cls-136{fill:url(#linear-gradient-55);}.cls-137{fill:url(#linear-gradient-56);}.cls-138{fill:#818186;}.cls-139{fill:#848489;}.cls-140{fill:#8b8b91;}.cls-141{fill:#8e8e94;}.cls-142{fill:#909097;}.cls-143{fill:#93939a;}.cls-144{fill:#95959c;}.cls-145{fill:#98989f;}.cls-146{fill:#9a9aa2;}.cls-147{fill:#282b2d;}.cls-148{fill:#26292b;}.cls-149{fill:#24282a;}.cls-150{fill:#212426;}.cls-151{fill:#1f2224;}.cls-152{fill:#1d2123;}.cls-153{fill:#1b1f21;}.cls-154{fill:#1a1d1f;}.cls-155{fill:#181b1d;}.cls-156{fill:#161a1c;}.cls-157{fill:#14181a;}.cls-158{fill:#121618;}.cls-159{fill:#101416;}.cls-160{fill:#0f1215;}.cls-161{fill:#0d1113;}.cls-162{fill:#0b0f11;}.cls-163{opacity:0;}.cls-164{opacity:0.06;}.cls-165{opacity:0.13;}.cls-166{opacity:0.19;}.cls-167{opacity:0.25;}.cls-168{opacity:0.31;}.cls-169{opacity:0.38;}.cls-170{opacity:0.44;}.cls-171,.cls-216,.cls-439,.cls-451,.cls-477,.cls-478,.cls-479{opacity:0.5;}.cls-172{opacity:0.56;}.cls-173{opacity:0.63;}.cls-174{opacity:0.69;}.cls-175{opacity:0.75;}.cls-176{opacity:0.81;}.cls-177{opacity:0.88;}.cls-178{opacity:0.94;}.cls-180{fill:url(#radial-gradient-28);}.cls-181{fill:url(#linear-gradient-57);}.cls-183{fill:#f1f1f1;}.cls-184{fill:#e4e4e4;}.cls-185{fill:#d6d6d6;}.cls-186{fill:#c8c8c8;}.cls-187{fill:#bbb;}.cls-188{fill:#adadad;}.cls-189{fill:#a0a0a0;}.cls-190{fill:#929292;}.cls-191{fill:#848484;}.cls-192{fill:#777;}.cls-193{fill:#696969;}.cls-194{fill:#b74700;}.cls-195{fill:#b94a00;}.cls-196{fill:#bb4d00;}.cls-197{fill:#bc5000;}.cls-198{fill:#be5300;}.cls-199{fill:#c05600;}.cls-200{fill:#c25900;}.cls-201{fill:#c45c00;}.cls-202{fill:#c55f00;}.cls-203{fill:#c76200;}.cls-204{fill:#c96500;}.cls-205{fill:#cb6800;}.cls-206{fill:#cd6b00;}.cls-207{fill:#cf6e00;}.cls-208{fill:#d07100;}.cls-209{fill:#d27400;}.cls-210{fill:#d47700;}.cls-211{fill:#d67a00;}.cls-212{fill:#d87d00;}.cls-213{fill:#d98000;}.cls-214{fill:#db8300;}.cls-215{fill:#dd8600;}.cls-217{fill:url(#linear-gradient-58);}.cls-218{fill:#637771;}.cls-219,.cls-221,.cls-223,.cls-312,.cls-315,.cls-316,.cls-318{mix-blend-mode:hard-light;}.cls-219{fill:url(#linear-gradient-59);}.cls-220{fill:url(#linear-gradient-60);}.cls-221{fill:url(#linear-gradient-61);}.cls-222{fill:url(#linear-gradient-62);}.cls-223{fill:url(#linear-gradient-63);}.cls-224{fill:url(#linear-gradient-64);}.cls-225{fill:url(#radial-gradient-29);}.cls-226{fill:url(#radial-gradient-30);}.cls-227{fill:url(#radial-gradient-31);}.cls-228{fill:url(#radial-gradient-32);}.cls-229{fill:url(#radial-gradient-33);}.cls-230{fill:url(#radial-gradient-34);}.cls-231{fill:url(#radial-gradient-35);}.cls-232{fill:url(#radial-gradient-36);}.cls-233{fill:url(#radial-gradient-37);}.cls-234{fill:url(#radial-gradient-38);}.cls-235{fill:url(#radial-gradient-39);}.cls-236{fill:url(#radial-gradient-40);}.cls-237{fill:url(#radial-gradient-41);}.cls-238{fill:url(#radial-gradient-42);}.cls-239{fill:url(#linear-gradient-65);}.cls-240{fill:url(#linear-gradient-66);}.cls-241{fill:url(#linear-gradient-67);}.cls-242{fill:url(#linear-gradient-68);}.cls-243{fill:url(#linear-gradient-69);}.cls-244{fill:url(#linear-gradient-70);}.cls-245{fill:url(#linear-gradient-71);}.cls-246{fill:url(#linear-gradient-72);}.cls-247{fill:url(#linear-gradient-73);}.cls-248{fill:url(#linear-gradient-74);}.cls-249{fill:url(#radial-gradient-43);}.cls-250{fill:url(#linear-gradient-75);}.cls-251{fill:url(#radial-gradient-44);}.cls-252{fill:url(#radial-gradient-45);}.cls-253{fill:url(#radial-gradient-46);}.cls-254{fill:url(#radial-gradient-47);}.cls-255{fill:url(#radial-gradient-48);}.cls-256{fill:url(#radial-gradient-49);}.cls-257{fill:url(#radial-gradient-50);}.cls-258{fill:url(#radial-gradient-51);}.cls-259{fill:url(#radial-gradient-52);}.cls-260{fill:url(#linear-gradient-76);}.cls-261{fill:url(#linear-gradient-77);}.cls-262{fill:url(#linear-gradient-78);}.cls-263{fill:url(#linear-gradient-79);}.cls-264{fill:url(#linear-gradient-80);}.cls-265{fill:url(#linear-gradient-81);}.cls-266{fill:url(#linear-gradient-82);}.cls-267{fill:url(#linear-gradient-83);}.cls-268{fill:url(#linear-gradient-84);}.cls-269{fill:url(#linear-gradient-85);}.cls-270{fill:url(#radial-gradient-53);}.cls-271{fill:url(#linear-gradient-86);}.cls-272{fill:url(#radial-gradient-54);}.cls-273{fill:url(#linear-gradient-87);}.cls-274{fill:url(#linear-gradient-88);}.cls-275{fill:url(#linear-gradient-89);}.cls-276{fill:url(#linear-gradient-90);}.cls-277{fill:url(#radial-gradient-55);}.cls-278{fill:url(#linear-gradient-91);}.cls-279{fill:url(#linear-gradient-92);}.cls-280{fill:url(#linear-gradient-93);}.cls-281{fill:url(#linear-gradient-94);}.cls-282{fill:url(#linear-gradient-95);}.cls-283{fill:url(#linear-gradient-96);}.cls-284{fill:url(#linear-gradient-97);}.cls-285{fill:url(#linear-gradient-98);}.cls-286{fill:url(#linear-gradient-99);}.cls-287{fill:url(#linear-gradient-100);}.cls-288{fill:url(#linear-gradient-101);}.cls-289{fill:url(#linear-gradient-102);}.cls-290{fill:url(#linear-gradient-103);}.cls-291{fill:url(#linear-gradient-105);}.cls-292{fill:url(#linear-gradient-106);}.cls-293{fill:url(#linear-gradient-107);}.cls-294{fill:url(#linear-gradient-108);}.cls-295{fill:url(#linear-gradient-109);}.cls-296{fill:url(#linear-gradient-110);}.cls-297{fill:url(#linear-gradient-111);}.cls-298{fill:url(#linear-gradient-112);}.cls-299{fill:url(#linear-gradient-113);}.cls-300{fill:url(#linear-gradient-114);}.cls-301{fill:url(#linear-gradient-115);}.cls-302{fill:url(#linear-gradient-116);}.cls-303{fill:url(#linear-gradient-117);}.cls-304{fill:url(#linear-gradient-118);}.cls-305{fill:url(#linear-gradient-119);}.cls-306{fill:url(#linear-gradient-120);}.cls-307{fill:url(#radial-gradient-56);}.cls-308{fill:url(#linear-gradient-121);}.cls-309{fill:url(#radial-gradient-57);}.cls-310{fill:url(#linear-gradient-122);}.cls-311{fill:url(#linear-gradient-123);}.cls-312{fill:url(#linear-gradient-124);}.cls-313{fill:url(#linear-gradient-125);}.cls-314{fill:url(#linear-gradient-126);}.cls-315{fill:url(#linear-gradient-127);}.cls-316{fill:url(#linear-gradient-128);}.cls-317{fill:url(#linear-gradient-129);}.cls-318{fill:url(#linear-gradient-130);}.cls-319{fill:url(#linear-gradient-131);}.cls-320{fill:url(#linear-gradient-132);}.cls-321{fill:url(#linear-gradient-133);}.cls-322{fill:url(#linear-gradient-134);}.cls-323{fill:#fefefe;}.cls-324{fill:#fdfdfd;}.cls-325{fill:#fcfcfc;}.cls-326{fill:#fbfbfb;}.cls-327{fill:#fafafa;}.cls-328{fill:#f9f9f9;}.cls-329{fill:#f8f8f8;}.cls-330{fill:#f7f7f7;}.cls-331{fill:#f6f6f6;}.cls-332{fill:#f5f5f5;}.cls-333{fill:#f4f4f4;}.cls-334{fill:#f3f3f3;}.cls-335{fill:#f2f2f2;}.cls-336{fill:#f0f0f0;}.cls-337{fill:#efefef;}.cls-338{fill:#eee;}.cls-339{fill:#edeced;}.cls-340{fill:#ecebec;}.cls-341{fill:#ebeaeb;}.cls-342{fill:#eae9ea;}.cls-343{fill:#e9e8e9;}.cls-344{fill:#e8e7e8;}.cls-345{fill:#e7e6e7;}.cls-346{fill:#e6e5e6;}.cls-347{fill:#e5e4e5;}.cls-348{fill:#e4e3e4;}.cls-349{fill:#e3e2e3;}.cls-350{fill:#e2e1e2;}.cls-351{fill:#e1e0e1;}.cls-352{fill:#e0dfe0;}.cls-353{fill:#dfdedf;}.cls-354{fill:#deddde;}.cls-355{fill:#dddcdd;}.cls-356{fill:#dcdbdc;}.cls-357{fill:#dbdadc;}.cls-358{fill:#dad9db;}.cls-359{fill:#d9d8da;}.cls-360{fill:#d8d7d9;}.cls-361{fill:#d7d6d8;}.cls-362{fill:#d6d5d7;}.cls-363{fill:#d5d4d6;}.cls-364{fill:#d4d3d5;}.cls-365{fill:#d3d2d4;}.cls-366{fill:#d2d1d3;}.cls-367{fill:#d1d0d2;}.cls-368{fill:#d0cfd1;}.cls-369{fill:#cfced0;}.cls-370{fill:#cecdcf;}.cls-371{fill:#cdccce;}.cls-372{fill:#cccbcd;}.cls-373{fill:#cbcacc;}.cls-374{fill:#cac9cb;}.cls-375{fill:#c9c7ca;}.cls-376{fill:#c8c6c9;}.cls-377{fill:#c7c5c8;}.cls-378{fill:#c6c4c7;}.cls-379{fill:#c5c3c6;}.cls-380{fill:#c4c2c5;}.cls-381{fill:#c3c1c4;}.cls-382{fill:#c2c0c3;}.cls-383{fill:#c1bfc2;}.cls-384{fill:#c0bec1;}.cls-385{fill:#bfbdc0;}.cls-386{fill:#bebcbf;}.cls-387{fill:#bdbbbe;}.cls-388{fill:#bcbabd;}.cls-389{fill:#bbb9bc;}.cls-390{fill:#bab8bb;}.cls-391{fill:#b9b7ba;}.cls-392{fill:#b8b6b9;}.cls-393{fill:url(#radial-gradient-58);}.cls-394{fill:url(#radial-gradient-59);}.cls-395{fill:#191c20;}.cls-396{fill:url(#linear-gradient-135);}.cls-397{fill:url(#linear-gradient-136);}.cls-398{fill:url(#linear-gradient-137);}.cls-399{fill:url(#linear-gradient-138);}.cls-400{fill:url(#linear-gradient-139);}.cls-401{fill:url(#linear-gradient-140);}.cls-402{fill:#e55400;}.cls-403{fill:url(#linear-gradient-141);}.cls-404{fill:#ffc94f;}.cls-405{fill:url(#linear-gradient-142);}.cls-406{fill:url(#linear-gradient-143);}.cls-407{fill:url(#radial-gradient-60);}.cls-408{fill:url(#linear-gradient-144);}.cls-409{fill:url(#radial-gradient-61);}.cls-410{fill:url(#linear-gradient-145);}.cls-411{fill:#e6e6e6;}.cls-412{fill:#727476;}.cls-413{fill:url(#linear-gradient-146);}.cls-414{fill:url(#linear-gradient-147);}.cls-415{fill:url(#linear-gradient-148);}.cls-416{fill:url(#linear-gradient-149);}.cls-417{fill:url(#linear-gradient-150);}.cls-418{fill:url(#linear-gradient-151);}.cls-419{fill:url(#radial-gradient-62);}.cls-420{fill:url(#radial-gradient-63);}.cls-421{fill:url(#linear-gradient-152);}.cls-422{fill:url(#linear-gradient-153);}.cls-423{fill:url(#linear-gradient-154);}.cls-424{fill:url(#linear-gradient-155);}.cls-425{fill:gray;}.cls-426{fill:#898888;}.cls-427{fill:#919190;}.cls-428{fill:#9a9998;}.cls-429{fill:#a3a2a0;}.cls-430{fill:#acaaa8;}.cls-431{fill:#b4b3b0;}.cls-432{fill:#bdbbb8;}.cls-433{fill:#c6c4c0;}.cls-434{fill:#cfccc8;}.cls-435{fill:#d7d5d0;}.cls-436{fill:#e0ddd8;}.cls-437{fill:url(#linear-gradient-156);}.cls-438{fill:url(#linear-gradient-157);}.cls-439{fill:url(#linear-gradient-158);}.cls-440{fill:url(#linear-gradient-159);}.cls-441{fill:url(#linear-gradient-160);}.cls-442{fill:url(#linear-gradient-161);}.cls-443{fill:url(#linear-gradient-162);}.cls-444{fill:url(#linear-gradient-163);}.cls-446{fill:url(#linear-gradient-164);}.cls-447{fill:url(#linear-gradient-165);}.cls-448{fill:url(#linear-gradient-166);}.cls-449{fill:url(#linear-gradient-167);}.cls-450{fill:url(#linear-gradient-168);}.cls-451{fill:url(#linear-gradient-169);}.cls-452{fill:url(#linear-gradient-170);}.cls-453{fill:url(#linear-gradient-171);}.cls-454{fill:url(#linear-gradient-172);}.cls-455{fill:url(#linear-gradient-173);}.cls-456{fill:url(#linear-gradient-174);}.cls-457{fill:url(#linear-gradient-175);}.cls-458{fill:url(#linear-gradient-176);}.cls-459{fill:url(#linear-gradient-177);}.cls-460{fill:url(#radial-gradient-64);}.cls-461{fill:url(#linear-gradient-178);}.cls-462{fill:url(#linear-gradient-179);}.cls-463{fill:url(#linear-gradient-180);}.cls-464{fill:url(#linear-gradient-181);}.cls-465{fill:url(#linear-gradient-182);}.cls-466{fill:url(#linear-gradient-183);}.cls-467{fill:url(#linear-gradient-184);}.cls-468{fill:url(#linear-gradient-185);}.cls-469{fill:url(#radial-gradient-65);}.cls-470{fill:url(#linear-gradient-186);}.cls-471{fill:url(#linear-gradient-187);}.cls-472{fill:url(#linear-gradient-188);}.cls-473{fill:url(#linear-gradient-189);}.cls-474{clip-path:url(#clip-path);}.cls-475{fill:#d8dddc;}.cls-476{fill:#b3b3b5;}.cls-477{fill:url(#linear-gradient-190);}.cls-478{fill:url(#linear-gradient-191);}.cls-479{fill:url(#linear-gradient-192);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 259.2,
    cy: 115.46,
    r: 22.68,
    gradientTransform: "translate(-1886.84 248.68) scale(7.98 0.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#babbb9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#bfc0be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#cdcecc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#e4e5e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 4205.68,
    cy: -243.75,
    r: 22.67,
    gradientTransform: "translate(-4132.95 374.39) scale(1 0.26)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#121411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#313230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#6e706e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#a2a3a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#cacbca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 4215.88,
    cy: -270.45,
    r: 22.67,
    gradientTransform: "translate(-4132.95 374.39) scale(1 0.26)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#343633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#6f706e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#a2a3a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#cacbca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 4395.39,
    cy: -242.77,
    r: 22.67,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 4386.82,
    cy: -259.46,
    r: 22.67,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: -6067.53,
    cy: 290.2,
    r: 17.78,
    gradientTransform: "matrix(-1, 0, 0, 1, -5989.67, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#050503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#030302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: -6067.53,
    cy: 290.2,
    r: 18.12,
    gradientTransform: "matrix(-1, 0, 0, 1, -5989.67, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#020200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#050503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#10100f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161615"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: -6067.53,
    cy: 290.2,
    r: 12.59,
    gradientTransform: "matrix(-1, 0, 0, 1, -5989.67, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d9d9d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#d6d6d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#cbcbca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#b9b9b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#a0a09e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#828280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#80807e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#787876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#6b6b69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#595957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#4f4f4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#545452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#60605f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#646463"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0c0c0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#131311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#252523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: -6183.33,
    cy: 302.49,
    r: 21.95,
    gradientTransform: "matrix(-1, 0, 0, 1, -6111.31, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#090908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#191918"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: -6118.43,
    cy: 2354.98,
    r: 18.5,
    gradientTransform: "matrix(-0.94, 0.34, 0.34, 0.94, -6483.66, 165.64)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#2b2b29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#292927"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#222221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#171715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: -6118.43,
    cy: 2354.98,
    r: 18.5,
    gradientTransform: "matrix(-0.94, 0.34, 0.34, 0.94, -6483.66, 165.64)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#282826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#2b2b29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#363635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: -6240.06,
    cy: 2354.99,
    r: 12.51,
    gradientTransform: "matrix(-0.94, 0.34, 0.34, 0.94, -6598.01, 207.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#b3b3b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#b0b0ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#a5a5a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#939392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#7a7a78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#5c5c5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#5a5a58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#525250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#454543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#333331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#292927"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#2e2e2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#3a3a39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3e3e3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: -6240.06,
    cy: 2354.99,
    r: 12.84,
    gradientTransform: "matrix(-0.94, 0.34, 0.34, 0.94, -6598.01, 207.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a2a29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#636362"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#787877"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#80807f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: -6240.06,
    cy: 2354.99,
    r: 13.76,
    gradientTransform: "matrix(-0.94, 0.34, 0.34, 0.94, -6598.01, 207.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "silver"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#b9b9b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#a5a5a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#a9a9a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#c5c5c4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2681.71,
    y1: -912.18,
    x2: 2683.79,
    y2: -912.18,
    gradientTransform: "matrix(0.94, -0.34, -0.34, -0.94, -2760.85, 353.77)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#50575c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10100f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 2682.04,
    y1: -912.18,
    x2: 2683.47,
    y2: -912.18,
    gradientTransform: "matrix(0.94, -0.34, -0.34, -0.94, -2760.85, 353.77)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#10100f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50575c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 2678.63,
    y1: -909.95,
    x2: 2680.71,
    y2: -909.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 2678.96,
    y1: -909.95,
    x2: 2680.39,
    y2: -909.95,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 2679.81,
    y1: -906.33,
    x2: 2681.89,
    y2: -906.33,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 2680.13,
    y1: -906.33,
    x2: 2681.57,
    y2: -906.33,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 2683.62,
    y1: -906.33,
    x2: 2685.7,
    y2: -906.33,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 2683.94,
    y1: -906.33,
    x2: 2685.37,
    y2: -906.33,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 2684.79,
    y1: -909.95,
    x2: 2686.87,
    y2: -909.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 2685.12,
    y1: -909.95,
    x2: 2686.55,
    y2: -909.95,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-15",
    cx: -6240.07,
    cy: 2354.88,
    r: 1.43,
    gradientTransform: "matrix(-0.94, 0.34, 0.34, 0.94, -6598.01, 207.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "silver"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#b9b9b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a5a5a4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -6183.81,
    y1: 273.56,
    x2: -6183.81,
    y2: 289.92,
    gradientTransform: "matrix(1, 0, 0, -1, 6256.3, 561.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a5a57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#6e6e6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#8a8a89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#a0a09f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#b0b0af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#b9b9b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-16",
    cx: -6247.39,
    cy: 289.9,
    r: 17.78,
    gradientTransform: "matrix(-0.92, -0.39, -0.39, 0.92, -5390.4, -2395.75)",
    xlinkHref: "#radial-gradient-6"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-17",
    cx: -6247.39,
    cy: 289.9,
    r: 18.12,
    xlinkHref: "#radial-gradient-7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-18",
    cx: -6247.39,
    cy: 289.9,
    r: 12.59,
    xlinkHref: "#radial-gradient-8"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-19",
    cx: -6378.73,
    cy: 301.35,
    r: 21.95,
    xlinkHref: "#radial-gradient-9"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-20",
    cx: -6299.74,
    cy: 2420.73,
    r: 18.5,
    xlinkHref: "#radial-gradient-10"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-21",
    cx: -6299.74,
    cy: 2420.73,
    r: 18.5,
    xlinkHref: "#radial-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-22",
    cx: -6421.37,
    cy: 2420.74,
    r: 12.51,
    xlinkHref: "#radial-gradient-12"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-23",
    cx: -6421.37,
    cy: 2420.74,
    r: 12.85,
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-24",
    cx: -6421.37,
    cy: 2420.74,
    r: 13.76,
    xlinkHref: "#radial-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 2863.03,
    y1: -977.93,
    x2: 2865.1,
    y2: -977.93,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 2863.35,
    y1: -977.93,
    x2: 2864.78,
    y2: -977.93,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 2859.95,
    y1: -975.69,
    x2: 2862.03,
    y2: -975.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 2860.27,
    y1: -975.69,
    x2: 2861.7,
    y2: -975.69,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 2861.12,
    y1: -972.07,
    x2: 2863.2,
    y2: -972.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 2861.44,
    y1: -972.07,
    x2: 2862.88,
    y2: -972.07,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 2864.93,
    y1: -972.07,
    x2: 2867.01,
    y2: -972.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 2865.25,
    y1: -972.07,
    x2: 2866.69,
    y2: -972.07,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 2866.1,
    y1: -975.69,
    x2: 2868.18,
    y2: -975.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 2866.43,
    y1: -975.69,
    x2: 2867.86,
    y2: -975.69,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-25",
    cx: -6421.39,
    cy: 2420.63,
    r: 1.43,
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -6374.67,
    y1: 275.87,
    x2: -6374.67,
    y2: 291.57,
    gradientTransform: "matrix(1, 0, 0, -1, 6638.04, 565.91)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-26",
    cx: -6313.76,
    cy: 300.05,
    r: 31.54,
    xlinkHref: "#radial-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 9053.41,
    y1: 295.98,
    x2: 9056.98,
    y2: 295.98,
    gradientTransform: "translate(-8764.07)",
    xlinkHref: "#radial-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 8856.82,
    y1: 296.92,
    x2: 8860.38,
    y2: 296.92,
    gradientTransform: "translate(-8764.07)",
    xlinkHref: "#radial-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -6292.19,
    y1: 297.29,
    x2: -6292.19,
    y2: 181.87,
    gradientTransform: "matrix(-1, 0, 0, 1, -6111.31, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#93938e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9e9f9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#acafab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#b4b8b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#b7bbb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#babeba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#cdcfcc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#d8d9d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#dcdcdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#e0e0df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#e0e2e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#e0e3e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#d6d7d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#cacac9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -6294.19,
    y1: 297.22,
    x2: -6294.19,
    y2: 258.77,
    gradientTransform: "matrix(-1, 0, 0, 1, -6111.31, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1dbe2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#efecf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#fbfafb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-27",
    cx: -6183.7,
    cy: 293.2,
    r: 39.27,
    gradientTransform: "matrix(-1, 0, 0, 1, -6111.31, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aeafaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#d9dada"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -6138.8,
    y1: 267.07,
    x2: -6147.35,
    y2: 267.07,
    gradientTransform: "matrix(-1, 0, 0, 1, -6111.31, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bac7bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#c0ccc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#e2e8e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#f7f9f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -6228.67,
    y1: 298.23,
    x2: -6228.67,
    y2: 295.32,
    gradientTransform: "matrix(1, 0, 0, -1, 6346.03, 593.61)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#444443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -6164.11,
    y1: 285.29,
    x2: -6137.96,
    y2: 285.78,
    gradientTransform: "matrix(-1, 0, 0, 1, -6111.31, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0c0f10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#1d2527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#2e3536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#5c5e5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#727271"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#707170"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#6b706f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#616563"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#464644"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -6147.32,
    y1: 295.87,
    x2: -6147.32,
    y2: 289.13,
    gradientTransform: "matrix(-1, 0, 0, 1, -6111.31, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a5a57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#5c5c59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#8e8e8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#b6b6b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#d6d6d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#ededec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fafafa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -6163.93,
    y1: 275.71,
    x2: -6138.09,
    y2: 276.2,
    gradientTransform: "matrix(-1, 0, 0, 1, -6111.31, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#959393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#999797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#a6a4a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#bbbaba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#d8d8d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#e7e7e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#e7e7e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5e5e4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -6445.79,
    y1: 240.12,
    x2: -6440.63,
    y2: 240.02,
    gradientTransform: "matrix(-1, 0, 0, 1, -6111.31, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#93927e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#aeae9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#cbcbc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#e2e2dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#f2f2f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#fcfcfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -6302.39,
    y1: 297.13,
    x2: -6302.39,
    y2: 295.2,
    gradientTransform: "matrix(-1, 0, 0, 1, -6111.31, 0)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -6418.5,
    y1: 296.68,
    x2: -6418.5,
    y2: 295.04,
    gradientTransform: "matrix(-1, 0, 0, 1, -6111.31, 0)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -6437.72,
    y1: 295.21,
    x2: -6437.34,
    y2: 278,
    gradientTransform: "matrix(-1, 0, 0, 1, -6111.31, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#444443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -6437.46,
    y1: 279.33,
    x2: -6437.46,
    y2: 277.56,
    gradientTransform: "matrix(-1, 0, 0, 1, -6111.31, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#9aa2a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#bfc4c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#e2e4e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -6445.7,
    y1: 285.62,
    x2: -6444.34,
    y2: 285.62,
    gradientTransform: "matrix(-1, 0, 0, 1, -6111.31, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#89928f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#a4aba9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#cbcfce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#e8e9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: -6161.38,
    y1: 260.26,
    x2: -6161.38,
    y2: 237.26,
    gradientTransform: "matrix(-1, 0, 0, 1, -6111.31, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bac7bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#c0ccc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#d2dbd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#f0f3f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 5206.66,
    y1: 661.22,
    x2: 5223.82,
    y2: 661.22,
    gradientTransform: "matrix(1.04, -0.06, 0.05, 0.92, -5406.81, -36.61)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d9d9d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#d6d6d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#cbcbca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#b9b9b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#a0a09e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#828280"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 5206.26,
    y1: 657.13,
    x2: 5221.58,
    y2: 663.81,
    gradientTransform: "matrix(1.04, -0.06, 0.05, 0.92, -5406.81, -36.61)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d9d9d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#d6d6d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#cbcbca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#b9b9b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#a0a09e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#80807d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5a5a57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 5085.09,
    y1: 661.1,
    x2: 5102.18,
    y2: 661.1,
    gradientTransform: "matrix(1.04, -0.06, 0.05, 0.92, -5280.7, -43.87)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d1d1b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 5090.44,
    y1: 664.01,
    x2: 5092.25,
    y2: 664.01,
    gradientTransform: "matrix(1.04, -0.06, 0.05, 0.92, -5280.7, -43.87)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 5091.34,
    y1: 663.85,
    x2: 5100.28,
    y2: 663.85,
    xlinkHref: "#linear-gradient-43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -4564.61,
    y1: 667.35,
    x2: -4562.2,
    y2: 663.27,
    gradientTransform: "matrix(-1.04, 0.06, 0.05, 0.92, -4735.79, -75.96)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5bfbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: -4576.37,
    y1: 661.58,
    x2: -4559.88,
    y2: 661.58,
    gradientTransform: "matrix(-1.04, 0.06, 0.05, 0.92, -4735.79, -75.96)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: -3913.04,
    y1: 254.56,
    x2: -3908.37,
    y2: 254.56,
    gradientTransform: "matrix(-1, 0, 0, 1, -3579.47, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878787"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: -3913.04,
    y1: 260.96,
    x2: -3908.37,
    y2: 260.96,
    xlinkHref: "#linear-gradient-47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -3913.04,
    y1: 267.37,
    x2: -3908.37,
    y2: 267.37,
    xlinkHref: "#linear-gradient-47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 4577.77,
    y1: 261.05,
    x2: 4581.14,
    y2: 261.05,
    gradientTransform: "translate(-4246.1)",
    xlinkHref: "#linear-gradient-43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -6279.89,
    y1: 285.95,
    x2: -6279.89,
    y2: 281.29,
    gradientTransform: "matrix(-1, 0, 0, 1, -6111.31, 0)",
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 13127.36,
    y1: 285.95,
    x2: 13127.36,
    y2: 281.29,
    gradientTransform: "translate(-12826.23)",
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: -6202.62,
    y1: 298.9,
    x2: -6156.81,
    y2: 272.56,
    gradientTransform: "matrix(-1, 0, 0, 1, -6111.31, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#0c0f10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#1d2527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#2e3536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#5c5e5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#727271"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#454543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#30302e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: -6244.02,
    y1: 223.13,
    x2: -6194.09,
    y2: 223.13,
    gradientTransform: "matrix(-1, 0, 0, 1, -6111.31, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#637771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93a19d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: -6217.91,
    y1: 223.55,
    x2: -6217.61,
    y2: 223.55,
    gradientTransform: "matrix(-1, 0, 0, 1, -6111.31, 0)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 10017.61,
    y1: 223.92,
    x2: 10017.92,
    y2: 223.92,
    gradientTransform: "translate(-9912.34)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-28",
    cx: 5344.16,
    cy: 249.7,
    r: 4.92,
    gradientTransform: "translate(-5216.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 5343.53,
    y1: 250.69,
    x2: 5343.53,
    y2: 248.76,
    gradientTransform: "translate(-5216.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#0b0b0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#171716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#282826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#2b2b29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#363635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: -6330.8,
    y1: 202.16,
    x2: -6330.8,
    y2: 200.68,
    gradientTransform: "matrix(-1, 0, 0, 1, -6111.31, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#444443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 876.02,
    y1: -3321.41,
    x2: 876.02,
    y2: -3322.16,
    gradientTransform: "matrix(0, -1, -1, 0, -3091.26, 1115.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7e8183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#898c8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#a7a8a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8c8c7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 876.02,
    y1: -3322.18,
    x2: 876.02,
    y2: -3322.92,
    gradientTransform: "matrix(0, -1, -1, 0, -3091.26, 1115.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aeb4b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#b7bcbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#b9bebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#d3d6d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#e6e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#f4f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 875.61,
    y1: -3236.02,
    x2: 875.61,
    y2: -3236.76,
    xlinkHref: "#linear-gradient-59"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 875.64,
    y1: -3236.78,
    x2: 875.64,
    y2: -3237.53,
    xlinkHref: "#linear-gradient-60"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 876.17,
    y1: -3408.55,
    x2: 876.17,
    y2: -3409.3,
    gradientTransform: "matrix(1, 0, 0, -1, -558.49, -3169.4)",
    xlinkHref: "#linear-gradient-59"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 876.17,
    y1: -3409.32,
    x2: 876.17,
    y2: -3410.07,
    xlinkHref: "#linear-gradient-60"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-29",
    cx: 257.05,
    cy: -221.62,
    r: 22.68,
    gradientTransform: "matrix(-7.98, 0, 0, 0.54, 2231.48, 248.68)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-30",
    cx: 4188.55,
    cy: -929.14,
    r: 22.67,
    gradientTransform: "matrix(-1, 0, 0, 0.26, 4477.59, 374.39)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-31",
    cx: 4198.75,
    cy: -955.84,
    r: 22.67,
    gradientTransform: "matrix(-1, 0, 0, 0.26, 4477.59, 374.39)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-32",
    cx: 4378.25,
    cy: -928.17,
    r: 22.67,
    gradientTransform: "matrix(-1, 0, 0, 0.26, 4477.59, 374.39)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-33",
    cx: 4369.69,
    cy: -944.85,
    r: 22.67,
    gradientTransform: "matrix(-1, 0, 0, 0.26, 4477.59, 374.39)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-34",
    cx: -6120.77,
    cy: 108.44,
    r: 17.78,
    gradientTransform: "translate(6402.53)",
    xlinkHref: "#radial-gradient-6"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-35",
    cx: -6120.77,
    cy: 108.44,
    r: 18.12,
    gradientTransform: "translate(6402.53)",
    xlinkHref: "#radial-gradient-7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-36",
    cx: -6120.77,
    cy: 108.44,
    r: 12.59,
    gradientTransform: "translate(6402.53)",
    xlinkHref: "#radial-gradient-8"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-37",
    cx: -6236.56,
    cy: 120.73,
    r: 21.95,
    gradientTransform: "translate(6524.16)",
    xlinkHref: "#radial-gradient-9"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-38",
    cx: -6230.44,
    cy: 2202.26,
    r: 18.5,
    gradientTransform: "translate(6229.9 3004.85) rotate(45.43)",
    xlinkHref: "#radial-gradient-10"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-39",
    cx: -6230.44,
    cy: 2202.26,
    r: 18.5,
    gradientTransform: "translate(6896.51 165.64) rotate(19.93)",
    xlinkHref: "#radial-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-40",
    cx: -6352.07,
    cy: 2202.27,
    r: 12.51,
    gradientTransform: "translate(7010.86 207.1) rotate(19.93)",
    xlinkHref: "#radial-gradient-12"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-41",
    cx: -6352.07,
    cy: 2202.27,
    r: 12.84,
    gradientTransform: "translate(7010.86 207.1) rotate(19.93)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-42",
    cx: -6352.07,
    cy: 2202.27,
    r: 13.76,
    gradientTransform: "translate(7010.86 207.1) rotate(19.93)",
    xlinkHref: "#radial-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 2793.73,
    y1: -759.46,
    x2: 2795.8,
    y2: -759.46,
    gradientTransform: "translate(3173.7 353.77) rotate(-160.07)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 2794.05,
    y1: -759.46,
    x2: 2795.48,
    y2: -759.46,
    gradientTransform: "translate(3173.7 353.77) rotate(-160.07)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 2790.65,
    y1: -757.22,
    x2: 2792.73,
    y2: -757.22,
    gradientTransform: "translate(3173.7 353.77) rotate(-160.07)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 2790.97,
    y1: -757.22,
    x2: 2792.4,
    y2: -757.22,
    gradientTransform: "translate(3173.7 353.77) rotate(-160.07)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 2791.82,
    y1: -753.6,
    x2: 2793.9,
    y2: -753.6,
    gradientTransform: "translate(3173.7 353.77) rotate(-160.07)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 2792.14,
    y1: -753.6,
    x2: 2793.58,
    y2: -753.6,
    gradientTransform: "translate(3173.7 353.77) rotate(-160.07)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 2795.63,
    y1: -753.6,
    x2: 2797.71,
    y2: -753.6,
    gradientTransform: "translate(3173.7 353.77) rotate(-160.07)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 2795.95,
    y1: -753.6,
    x2: 2797.39,
    y2: -753.6,
    gradientTransform: "translate(3173.7 353.77) rotate(-160.07)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 2796.8,
    y1: -757.22,
    x2: 2798.88,
    y2: -757.22,
    gradientTransform: "translate(3173.7 353.77) rotate(-160.07)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 2797.13,
    y1: -757.22,
    x2: 2798.56,
    y2: -757.22,
    gradientTransform: "translate(3173.7 353.77) rotate(-160.07)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-43",
    cx: -6352.09,
    cy: 2202.15,
    r: 1.43,
    gradientTransform: "translate(7010.86 207.1) rotate(19.93)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: -6237.04,
    y1: 91.8,
    x2: -6237.04,
    y2: 108.16,
    gradientTransform: "translate(6524.16)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-44",
    cx: -6300.63,
    cy: 108.14,
    r: 17.78,
    gradientTransform: "translate(6402.53)",
    xlinkHref: "#radial-gradient-6"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-45",
    cx: -6300.63,
    cy: 108.14,
    r: 18.12,
    gradientTransform: "translate(6402.53)",
    xlinkHref: "#radial-gradient-7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-46",
    cx: -6300.63,
    cy: 108.14,
    r: 12.59,
    gradientTransform: "translate(6402.53)",
    xlinkHref: "#radial-gradient-8"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-47",
    cx: -6431.97,
    cy: 119.59,
    r: 21.95,
    gradientTransform: "translate(6524.16)",
    xlinkHref: "#radial-gradient-9"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-48",
    cx: -6411.75,
    cy: 2268.01,
    r: 18.5,
    gradientTransform: "translate(6896.51 165.64) rotate(19.93)",
    xlinkHref: "#radial-gradient-10"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-49",
    cx: -6411.75,
    cy: 2268.01,
    r: 18.5,
    gradientTransform: "translate(6896.51 165.64) rotate(19.93)",
    xlinkHref: "#radial-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-50",
    cx: -6533.39,
    cy: 2268.01,
    r: 12.51,
    gradientTransform: "translate(7010.86 207.1) rotate(19.93)",
    xlinkHref: "#radial-gradient-12"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-51",
    cx: -6533.39,
    cy: 2268.01,
    r: 12.85,
    gradientTransform: "translate(7010.86 207.1) rotate(19.93)",
    xlinkHref: "#radial-gradient-13"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-52",
    cx: -6533.39,
    cy: 2268.01,
    r: 13.76,
    gradientTransform: "translate(7010.86 207.1) rotate(19.93)",
    xlinkHref: "#radial-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 2975.04,
    y1: -825.21,
    x2: 2977.12,
    y2: -825.21,
    gradientTransform: "translate(3173.7 353.77) rotate(-160.07)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 2975.36,
    y1: -825.21,
    x2: 2976.79,
    y2: -825.21,
    gradientTransform: "translate(3173.7 353.77) rotate(-160.07)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 2971.96,
    y1: -822.97,
    x2: 2974.04,
    y2: -822.97,
    gradientTransform: "translate(3173.7 353.77) rotate(-160.07)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 2972.28,
    y1: -822.97,
    x2: 2973.71,
    y2: -822.97,
    gradientTransform: "translate(3173.7 353.77) rotate(-160.07)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 2973.13,
    y1: -819.35,
    x2: 2975.21,
    y2: -819.35,
    gradientTransform: "translate(3173.7 353.77) rotate(-160.07)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 2973.46,
    y1: -819.35,
    x2: 2974.89,
    y2: -819.35,
    gradientTransform: "translate(3173.7 353.77) rotate(-160.07)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 2976.94,
    y1: -819.35,
    x2: 2979.02,
    y2: -819.35,
    gradientTransform: "translate(3173.7 353.77) rotate(-160.07)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 2977.26,
    y1: -819.35,
    x2: 2978.7,
    y2: -819.35,
    gradientTransform: "translate(3173.7 353.77) rotate(-160.07)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 2978.12,
    y1: -822.97,
    x2: 2980.2,
    y2: -822.97,
    gradientTransform: "translate(3173.7 353.77) rotate(-160.07)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 2978.44,
    y1: -822.97,
    x2: 2979.87,
    y2: -822.97,
    gradientTransform: "translate(3173.7 353.77) rotate(-160.07)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-53",
    cx: -6533.4,
    cy: 2267.9,
    r: 1.43,
    gradientTransform: "translate(7010.86 207.1) rotate(19.93)",
    xlinkHref: "#radial-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: -6427.91,
    y1: 94.11,
    x2: -6427.91,
    y2: 109.81,
    gradientTransform: "translate(6524.16)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-54",
    cx: -6367,
    cy: 118.29,
    r: 31.54,
    gradientTransform: "translate(6524.16)",
    xlinkHref: "#radial-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 9106.65,
    y1: 114.22,
    x2: 9110.21,
    y2: 114.22,
    gradientTransform: "matrix(-1, 0, 0, 1, 9176.92, 0)",
    xlinkHref: "#radial-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 8910.06,
    y1: 115.16,
    x2: 8913.62,
    y2: 115.16,
    gradientTransform: "matrix(-1, 0, 0, 1, 9176.92, 0)",
    xlinkHref: "#radial-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: -6345.43,
    y1: 115.53,
    x2: -6345.43,
    y2: 0.11,
    gradientTransform: "translate(6524.16)",
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: -6347.43,
    y1: 115.46,
    x2: -6347.43,
    y2: 77.01,
    gradientTransform: "translate(6524.16)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-55",
    cx: -6236.94,
    cy: 111.44,
    r: 39.27,
    gradientTransform: "translate(6524.16)",
    xlinkHref: "#radial-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: -6192.04,
    y1: 85.31,
    x2: -6200.58,
    y2: 85.31,
    gradientTransform: "translate(6524.16)",
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: -6281.91,
    y1: 116.47,
    x2: -6281.91,
    y2: 113.56,
    gradientTransform: "translate(6524.16)",
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: -6217.35,
    y1: 103.53,
    x2: -6191.2,
    y2: 104.02,
    gradientTransform: "translate(6524.16)",
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: -6200.56,
    y1: 114.11,
    x2: -6200.56,
    y2: 107.37,
    gradientTransform: "translate(6524.16)",
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: -6217.17,
    y1: 93.95,
    x2: -6191.33,
    y2: 94.44,
    gradientTransform: "translate(6524.16)",
    xlinkHref: "#linear-gradient-31"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: -6499.03,
    y1: 58.36,
    x2: -6493.87,
    y2: 58.26,
    gradientTransform: "translate(6524.16)",
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: -6355.62,
    y1: 115.37,
    x2: -6355.62,
    y2: 113.44,
    gradientTransform: "translate(6524.16)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: -6471.74,
    y1: 114.92,
    x2: -6471.74,
    y2: 113.28,
    gradientTransform: "translate(6524.16)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: -6490.96,
    y1: 113.45,
    x2: -6490.58,
    y2: 96.24,
    gradientTransform: "translate(6524.16)",
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: -6490.7,
    y1: 97.57,
    x2: -6490.7,
    y2: 95.8,
    gradientTransform: "translate(6524.16)",
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: -6498.94,
    y1: 103.86,
    x2: -6497.58,
    y2: 103.86,
    gradientTransform: "translate(6524.16)",
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: -6214.62,
    y1: 78.5,
    x2: -6214.62,
    y2: 55.5,
    gradientTransform: "translate(6524.16)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 5267.91,
    y1: 468.3,
    x2: 5285.07,
    y2: 468.3,
    gradientTransform: "matrix(-1.04, -0.06, -0.05, 0.92, 5819.66, -36.61)",
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 5267.5,
    y1: 464.21,
    x2: 5282.83,
    y2: 470.89,
    gradientTransform: "matrix(-1.04, -0.06, -0.05, 0.92, 5819.66, -36.61)",
    xlinkHref: "#linear-gradient-41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 5146.34,
    y1: 468.18,
    x2: 5163.43,
    y2: 468.18,
    gradientTransform: "matrix(-1.04, -0.06, -0.05, 0.92, 5693.55, -43.87)",
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 5151.69,
    y1: 471.09,
    x2: 5153.49,
    y2: 471.09,
    gradientTransform: "matrix(-1.04, -0.06, -0.05, 0.92, 5693.55, -43.87)",
    xlinkHref: "#linear-gradient-43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 5152.59,
    y1: 470.93,
    x2: 5161.53,
    y2: 470.93,
    gradientTransform: "matrix(-1.04, -0.06, -0.05, 0.92, 5693.55, -43.87)",
    xlinkHref: "#linear-gradient-43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: -4625.86,
    y1: 474.43,
    x2: -4623.44,
    y2: 470.35,
    gradientTransform: "matrix(1.04, 0.06, -0.05, 0.92, 5148.64, -75.96)",
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: -4637.62,
    y1: 468.66,
    x2: -4621.12,
    y2: 468.66,
    gradientTransform: "matrix(1.04, 0.06, -0.05, 0.92, 5148.64, -75.96)",
    xlinkHref: "#linear-gradient-46"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: -3966.27,
    y1: 72.8,
    x2: -3961.61,
    y2: 72.8,
    gradientTransform: "translate(3992.32)",
    xlinkHref: "#linear-gradient-47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: -3966.27,
    y1: 79.2,
    x2: -3961.61,
    y2: 79.2,
    gradientTransform: "translate(3992.32)",
    xlinkHref: "#linear-gradient-47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: -3966.27,
    y1: 85.61,
    x2: -3961.61,
    y2: 85.61,
    gradientTransform: "translate(3992.32)",
    xlinkHref: "#linear-gradient-47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 4631.01,
    y1: 79.29,
    x2: 4634.38,
    y2: 79.29,
    gradientTransform: "matrix(1, 0, 0, -1, -4606.44, 158.58)",
    xlinkHref: "#linear-gradient-43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: -6333.13,
    y1: 104.19,
    x2: -6333.13,
    y2: 99.53,
    gradientTransform: "translate(6524.16)",
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 13180.6,
    y1: 104.19,
    x2: 13180.6,
    y2: 99.53,
    gradientTransform: "matrix(-1, 0, 0, 1, 13239.08, 0)",
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: -6255.85,
    y1: 117.14,
    x2: -6210.05,
    y2: 90.8,
    gradientTransform: "translate(6524.16)",
    xlinkHref: "#linear-gradient-53"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: -6297.26,
    y1: 41.37,
    x2: -6247.33,
    y2: 41.37,
    gradientTransform: "translate(6524.16)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: -6271.15,
    y1: 41.79,
    x2: -6270.85,
    y2: 41.79,
    gradientTransform: "translate(6524.16)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 10070.85,
    y1: 42.16,
    x2: 10071.15,
    y2: 42.16,
    gradientTransform: "matrix(-1, 0, 0, 1, 10325.2, 0)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-56",
    cx: 5397.4,
    cy: 67.94,
    r: 4.92,
    gradientTransform: "matrix(-1, 0, 0, 1, 5628.92, 0)",
    xlinkHref: "#radial-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 5396.76,
    y1: 68.93,
    x2: 5396.76,
    y2: 67,
    gradientTransform: "matrix(-1, 0, 0, 1, 5628.92, 0)",
    xlinkHref: "#linear-gradient-57"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-57",
    cx: 5430.89,
    cy: 67.94,
    r: 4.92,
    gradientTransform: "matrix(-1, 0, 0, 1, 5628.92, 0)",
    xlinkHref: "#radial-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 5430.25,
    y1: 68.93,
    x2: 5430.25,
    y2: 67,
    gradientTransform: "matrix(-1, 0, 0, 1, 5628.92, 0)",
    xlinkHref: "#linear-gradient-57"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: -6384.04,
    y1: 20.4,
    x2: -6384.04,
    y2: 18.92,
    gradientTransform: "translate(6524.16)",
    xlinkHref: "#linear-gradient-58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 1057.37,
    y1: -3289.26,
    x2: 1057.37,
    y2: -3290,
    gradientTransform: "translate(3504.12 1115.7) rotate(-90)",
    xlinkHref: "#linear-gradient-59"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 1057.4,
    y1: -3290.02,
    x2: 1057.4,
    y2: -3290.77,
    gradientTransform: "translate(3504.12 1115.7) rotate(-90)",
    xlinkHref: "#linear-gradient-60"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 85.11,
    y1: 66.81,
    x2: 85.11,
    y2: 64.48,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-60"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 85.11,
    y1: 73.76,
    x2: 85.11,
    y2: 71.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7e8183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#808385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#898b8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#97999a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#abacac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#c5c5c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8c8c7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 1057.78,
    y1: -3374.65,
    x2: 1057.78,
    y2: -3375.4,
    gradientTransform: "translate(3504.12 1115.7) rotate(-90)",
    xlinkHref: "#linear-gradient-59"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 1057.78,
    y1: -3375.42,
    x2: 1057.78,
    y2: -3376.16,
    gradientTransform: "translate(3504.12 1115.7) rotate(-90)",
    xlinkHref: "#linear-gradient-60"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 1057.93,
    y1: -3461.79,
    x2: 1057.93,
    y2: -3462.54,
    gradientTransform: "translate(-1015.99 3519.95)",
    xlinkHref: "#linear-gradient-59"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 1057.93,
    y1: -3462.56,
    x2: 1057.93,
    y2: -3463.3,
    gradientTransform: "translate(3504.12 1115.7) rotate(-90)",
    xlinkHref: "#linear-gradient-60"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 85.69,
    y1: 67.66,
    x2: 85.69,
    y2: 70.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9c9c9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#b4b4b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#cfcfce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#dfdfde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#e5e5e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#d6d6d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#b6b6b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#a3a3a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#9c9c9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#b0b3b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#b7bbb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#b0b4b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#9ea19b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#7f817a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#55554c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#515148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#54544b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#5d5d55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#6d6d66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#82827e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c9c9a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 43.38,
    y1: 66.72,
    x2: 43.38,
    y2: 70.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#444443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 126.85,
    y1: 66.72,
    x2: 126.85,
    y2: 70.94,
    xlinkHref: "#linear-gradient-133"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-58",
    cx: 4082.75,
    cy: -1438.89,
    r: 13.7,
    gradientTransform: "matrix(-1, 0, 0, 0.18, 4477.59, 574.98)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#343633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#606260"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#909190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#b8b9b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#d7d7d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ededed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#fafbfa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-59",
    cx: 4004.3,
    cy: -1438.89,
    r: 13.7,
    xlinkHref: "#radial-gradient-58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 473.9,
    y1: 280.93,
    x2: 473.9,
    y2: 311.96,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 395.12,
    y1: 280.93,
    x2: 395.12,
    y2: 311.96,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 433.28,
    y1: 296,
    x2: 433.28,
    y2: 182.23,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 384.42,
    y1: 235.64,
    x2: 397.71,
    y2: 235.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4d7d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#dcdfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#f0f1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 482.4,
    y1: 235.66,
    x2: 469.26,
    y2: 235.66,
    xlinkHref: "#linear-gradient-138"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 433.28,
    y1: 296.36,
    x2: 433.28,
    y2: 283.2,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: -7362.22,
    y1: 104.2,
    x2: -7358.48,
    y2: 104.2,
    gradientTransform: "matrix(1, 0, 0, -1, 7749.46, 364.8)",
    xlinkHref: "#linear-gradient-43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 433.28,
    y1: 296.54,
    x2: 433.28,
    y2: 291.65,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: -7483.54,
    y1: 104.2,
    x2: -7479.79,
    y2: 104.2,
    gradientTransform: "translate(7959.12 156.41)",
    xlinkHref: "#linear-gradient-43"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-60",
    cx: 5207.4,
    cy: 250.62,
    r: 3.66,
    gradientTransform: "matrix(-1, 0, 0, 1, 5628.92, 0)",
    xlinkHref: "#radial-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 5206.93,
    y1: 251.35,
    x2: 5206.93,
    y2: 249.91,
    gradientTransform: "matrix(-1, 0, 0, 1, 5628.92, 0)",
    xlinkHref: "#linear-gradient-57"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-61",
    cx: 5305.21,
    cy: 250.62,
    r: 3.66,
    gradientTransform: "translate(-4860.29)",
    xlinkHref: "#radial-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 5304.73,
    y1: 251.35,
    x2: 5304.73,
    y2: 249.91,
    gradientTransform: "translate(-4860.29)",
    xlinkHref: "#linear-gradient-57"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 391.6,
    y1: 287.6,
    x2: 397.28,
    y2: 287.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7c8585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#9fa5a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#c1c6c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#dcdfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#f0f1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 249.43,
    y1: 287.6,
    x2: 255.11,
    y2: 287.34,
    gradientTransform: "matrix(1, 0, 0, -1, 220.26, 574.96)",
    xlinkHref: "#linear-gradient-146"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 387.89,
    y1: 296.94,
    x2: 387.89,
    y2: 278.53,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 384.35,
    y1: 287.94,
    x2: 392.02,
    y2: 287.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#959393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#999797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#a6a4a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#bbbaba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#d8d8d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#e7e7e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ebebea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 266.58,
    y1: 296.94,
    x2: 266.58,
    y2: 278.53,
    gradientTransform: "matrix(-1, 0, 0, 1, 745.25, 0)",
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: 262.98,
    y1: 287.9,
    x2: 270.59,
    y2: 287.55,
    gradientTransform: "matrix(-1, 0, 0, 1, 745.25, 0)",
    xlinkHref: "#linear-gradient-149"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-62",
    cx: 4083.29,
    cy: -2434.52,
    r: 13.7,
    xlinkHref: "#radial-gradient-58"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-63",
    cx: 4004.84,
    cy: -2434.52,
    r: 13.7,
    xlinkHref: "#radial-gradient-58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: 434.07,
    y1: 113.67,
    x2: 434.07,
    y2: -0.44,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: 473.36,
    y1: 98.6,
    x2: 473.36,
    y2: 129.64,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: 394.58,
    y1: 98.6,
    x2: 394.58,
    y2: 129.64,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: 430.42,
    y1: 74.96,
    x2: 437.74,
    y2: 74.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#828281"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#b3aeb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#9b969c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#726f73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#4f4c4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#323133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#1c1b1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#0c0c0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#141312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#2c2a27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#4d4b46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#79746d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#ada79c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#c1baae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#a8a49c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#93918d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#868684"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#828281"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: 378.79,
    y1: 54.78,
    x2: 381.62,
    y2: 46.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#444443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: 382.57,
    y1: 80.4,
    x2: 410.9,
    y2: 80.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#979795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#c3c3c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#d9d9d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#d7d7d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#cfcfce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#c2c2c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#b0b0ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a4a4a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: 384.17,
    y1: 80.44,
    x2: 409.12,
    y2: 80.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#979795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#adadab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#c6c6c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#d8d8d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#e3e3e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#e6e6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#e4e4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#dcdcdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#cfcfce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#bcbcbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a5a5a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a4a4a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: 399.29,
    y1: 83.11,
    x2: 405.22,
    y2: 83.11,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: 400.43,
    y1: 83.11,
    x2: 404.08,
    y2: 83.11,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: 387.54,
    y1: 81.37,
    x2: 397.79,
    y2: 81.37,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: 383.93,
    y1: 77.39,
    x2: 387.98,
    y2: 77.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: 383.97,
    y1: 79.32,
    x2: 409.92,
    y2: 79.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#dadada"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#aeaead"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#878786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#666665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#4b4b4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#373735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#282826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#20201e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d1d1b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: 433.97,
    y1: 91.19,
    x2: 433.97,
    y2: 80.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#39393a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2b2e32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1b1d20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: 387.54,
    y1: 39.7,
    x2: 480.6,
    y2: 39.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#191c20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#24272b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#343639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#3d3f42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#404245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#3d3f42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#34363a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#24272b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191c20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: 388.96,
    y1: 40.47,
    x2: 479.18,
    y2: 40.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#637771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#93a19d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93a19d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: 486.46,
    y1: 46.8,
    x2: 489.03,
    y2: 53.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#444443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: 268.14,
    y1: 80.38,
    x2: 296.47,
    y2: 80.38,
    gradientTransform: "matrix(-1, 0, 0, 1, 753.71, 0)",
    xlinkHref: "#linear-gradient-157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-169",
    x1: 269.73,
    y1: 80.42,
    x2: 294.69,
    y2: 80.42,
    gradientTransform: "matrix(-1, 0, 0, 1, 753.71, 0)",
    xlinkHref: "#linear-gradient-158"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-170",
    x1: 284.85,
    y1: 83.09,
    x2: 290.78,
    y2: 83.09,
    gradientTransform: "matrix(-1, 0, 0, 1, 753.71, 0)",
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-171",
    x1: 286,
    y1: 83.09,
    x2: 289.64,
    y2: 83.09,
    gradientTransform: "matrix(-1, 0, 0, 1, 753.71, 0)",
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-172",
    x1: 273.11,
    y1: 81.36,
    x2: 283.36,
    y2: 81.36,
    gradientTransform: "matrix(-1, 0, 0, 1, 753.71, 0)",
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-173",
    x1: 269.49,
    y1: 77.38,
    x2: 273.55,
    y2: 77.38,
    gradientTransform: "matrix(-1, 0, 0, 1, 753.71, 0)",
    xlinkHref: "#linear-gradient-162"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-174",
    x1: 269.54,
    y1: 79.3,
    x2: 295.48,
    y2: 79.3,
    gradientTransform: "matrix(-1, 0, 0, 1, 753.71, 0)",
    xlinkHref: "#linear-gradient-163"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-175",
    x1: 433.97,
    y1: 86.77,
    x2: 433.97,
    y2: 83.71,
    xlinkHref: "#linear-gradient-133"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-176",
    x1: 433.97,
    y1: 83.6,
    x2: 433.97,
    y2: 80.54,
    xlinkHref: "#linear-gradient-133"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-177",
    x1: 433.97,
    y1: 89.94,
    x2: 433.97,
    y2: 86.89,
    xlinkHref: "#linear-gradient-133"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-64",
    cx: 433.75,
    cy: 91.44,
    r: 23.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#f3f3f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#e4e4e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#cfcfd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#b3b4b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#919293"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#686a6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3a3c3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#2a2c2f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-178",
    x1: 383.91,
    y1: 57.22,
    x2: 403.37,
    y2: 57.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bfc3c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#d0d3d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#e5e6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#fcfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-179",
    x1: 484.21,
    y1: 57.22,
    x2: 465.52,
    y2: 57.22,
    xlinkHref: "#linear-gradient-178"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-180",
    x1: 434.08,
    y1: 101.09,
    x2: 434.08,
    y2: 95.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#696a6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#5b5d60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#2a2c2f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-181",
    x1: 434.07,
    y1: 113.23,
    x2: 434.07,
    y2: 93.39,
    xlinkHref: "#linear-gradient-156"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-182",
    x1: 400.36,
    y1: 107.65,
    x2: 400.36,
    y2: 102.52,
    xlinkHref: "#linear-gradient-180"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-183",
    x1: 319.64,
    y1: 101.08,
    x2: 319.64,
    y2: 95.74,
    gradientTransform: "matrix(-1, 0, 0, 1, 753.71, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-184",
    x1: 285.92,
    y1: 107.64,
    x2: 285.92,
    y2: 102.51,
    gradientTransform: "matrix(-1, 0, 0, 1, 753.71, 0)",
    xlinkHref: "#linear-gradient-180"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-185",
    x1: 434.07,
    y1: 98.79,
    x2: 434.07,
    y2: 95.73,
    xlinkHref: "#linear-gradient-133"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-65",
    cx: 320.09,
    cy: 101.57,
    r: 18.74,
    gradientTransform: "matrix(-1, 0, 0, 1, 753.71, 0)",
    xlinkHref: "#radial-gradient-64"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-186",
    x1: 484.2,
    y1: 103.46,
    x2: 478.26,
    y2: 103.46,
    xlinkHref: "#linear-gradient-146"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-187",
    x1: 383.81,
    y1: 103.47,
    x2: 389.32,
    y2: 103.47,
    xlinkHref: "#linear-gradient-146"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-188",
    x1: 387.33,
    y1: 22.12,
    x2: 392.64,
    y2: 22.12,
    xlinkHref: "#linear-gradient-165"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-189",
    x1: 238.2,
    y1: 22.12,
    x2: 243.51,
    y2: 22.12,
    gradientTransform: "matrix(-1, 0, 0, 1, 718.84, 0)",
    xlinkHref: "#linear-gradient-165"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M479.18,54.46s-1.16-19.13-5-29.71H432.6v0H393.94c-3.82,10.58-5,29.71-5,29.71s32.9,1.69,43.88,1.7C444.43,56.19,479.18,54.46,479.18,54.46Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-190",
    x1: 455.63,
    y1: 40.13,
    x2: 475.47,
    y2: 40.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ababab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-191",
    x1: 408.83,
    y1: 40.45,
    x2: 436.77,
    y2: 40.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ababab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-192",
    x1: 392.34,
    y1: 40.09,
    x2: 406.57,
    y2: 40.09,
    xlinkHref: "#linear-gradient-190"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 180.89,
    cy: 310.64,
    rx: 180.89,
    ry: 12.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M95.4,310.07c0,3.3-10.15,6-22.67,6s-22.68-2.68-22.68-6,10.16-6,22.68-6S95.4,306.76,95.4,310.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M105.61,303c0,3.3-10.16,6-22.68,6s-22.67-2.68-22.67-6,10.15-6,22.67-6S105.61,299.72,105.61,303Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M285.11,310.32c0,3.31-10.15,6-22.67,6s-22.68-2.68-22.68-6,10.15-6,22.68-6S285.11,307,285.11,310.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M276.54,305.92c0,3.31-10.15,6-22.67,6s-22.68-2.67-22.68-6,10.16-6,22.68-6S276.54,302.62,276.54,305.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M77.86,272.42A17.78,17.78,0,1,1,60.08,290.2,17.78,17.78,0,0,1,77.86,272.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M62.16,288.49l-2.35-.27.41-2.33,2.31.55c.06-.22.11-.44.17-.65l-2.28-.67.81-2.23,2.18.94c.09-.2.19-.4.29-.6l-2.13-1.06,1.19-2.05,2,1.3c.13-.19.27-.36.4-.54l-1.92-1.42,1.53-1.81,1.73,1.63.47-.48-1.64-1.72,1.82-1.52,1.42,1.91c.18-.13.35-.27.54-.4l-1.31-2,2-1.19L70.89,276l.61-.29-1-2.17,2.22-.81.68,2.27.66-.17-.56-2.31,2.33-.41.27,2.35.67,0-.14-2.38H79l-.14,2.38.67,0,.27-2.35,2.33.41-.55,2.31.65.17.68-2.27,2.22.81-1,2.17.61.29,1.07-2.13,2,1.19-1.31,2c.19.13.36.27.54.4l1.42-1.91,1.82,1.52-1.64,1.72.47.48L91,277.65l1.53,1.81-1.92,1.42c.13.18.27.35.4.54l2-1.3,1.19,2.05L92,283.23c.1.2.2.4.29.6l2.18-.94.81,2.23-2.28.67c.06.21.11.43.17.65l2.31-.55.42,2.33-2.36.27c0,.22,0,.44,0,.67L96,289v2.37l-2.38-.15c0,.22,0,.45,0,.67l2.36.27-.42,2.34L93.19,294c0,.22-.11.43-.17.65l2.28.68-.81,2.22-2.18-.94c-.09.2-.19.4-.29.6l2.13,1.07L93,300.29,91,299c-.12.19-.26.36-.4.54L92.51,301,91,302.76l-1.72-1.64-.48.48,1.64,1.73-1.82,1.52-1.41-1.92c-.18.13-.36.28-.54.4l1.3,2-2,1.18-1.06-2.13-.61.29.94,2.18-2.22.81-.68-2.28c-.21.07-.43.12-.65.17l.55,2.32-2.33.41-.26-2.36c-.23,0-.46,0-.68.05l.14,2.38H76.68l.14-2.38c-.23,0-.45,0-.68-.05l-.26,2.36-2.33-.41.55-2.32c-.22,0-.44-.1-.65-.17l-.68,2.28-2.22-.81.94-2.18-.61-.29-1.06,2.13-2-1.18,1.3-2c-.18-.12-.36-.27-.54-.4l-1.41,1.92-1.82-1.52,1.64-1.73-.48-.48-1.72,1.64L63.21,301l1.92-1.43c-.14-.18-.28-.35-.4-.54l-2,1.31-1.19-2.05,2.13-1.07c-.1-.2-.2-.4-.29-.6l-2.18.94-.81-2.22,2.28-.68c-.06-.22-.12-.43-.17-.65l-2.31.56-.41-2.34,2.35-.27c0-.22,0-.45,0-.67l-2.38.15V289l2.38.14C62.13,288.93,62.14,288.71,62.16,288.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M77.86,277.61A12.6,12.6,0,1,1,65.27,290.2,12.59,12.59,0,0,1,77.86,277.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M98.22,293.16l-1.28,2.49A4.35,4.35,0,0,1,92.77,298l-47.72-3.56L50.87,270,88,266.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M64.79,276.39a18.5,18.5,0,1,1-11.09,23.7A18.52,18.52,0,0,1,64.79,276.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M55.43,297.6l-2.35.57-.42-2.38,2.42-.28c0-.23,0-.46-.07-.69l-2.42.15v-2.42l2.41.15c0-.23.05-.46.07-.68l-2.41-.28.42-2.38,2.35.56c.06-.22.13-.44.2-.66l-2.34-.69.83-2.27,2.23,1c.09-.21.19-.42.29-.62l-2.17-1.09,1.21-2.09,2,1.34c.13-.19.25-.39.38-.57l-1.94-1.44L57.72,281l1.76,1.67c.16-.16.31-.33.48-.49l-1.67-1.75,1.86-1.56,1.44,1.95.57-.39-1.34-2,2.09-1.21L64,279.31l.62-.27-1-2.23,2.27-.83.69,2.34c.22-.07.44-.14.66-.19l-.56-2.36,2.38-.42.27,2.42.69-.07-.14-2.42h2.42l-.16,2.41.68.07.29-2.41,2.38.42L75,278.13l.66.19.7-2.32,2.27.82-1,2.23.63.29,1.09-2.17,2.09,1.21-1.35,2c.19.12.39.24.57.38l1.45-1.94,1.85,1.56-1.68,1.76c.17.15.33.31.49.48L84.5,281l1.56,1.85-2,1.44c.14.18.26.37.39.56l2-1.33,1.21,2.09-2.17,1.08c.1.2.19.42.28.63l2.23-1,.83,2.28-2.34.68c.07.22.14.44.19.66l2.36-.55.41,2.38-2.41.27c0,.22,0,.45.07.68l2.42-.14V295l-2.41-.16c0,.23-.05.46-.07.69l2.41.28-.42,2.38-2.35-.57c-.06.22-.13.44-.19.66l2.32.7-.82,2.27-2.23-1c-.09.21-.19.41-.29.62L87.71,302,86.5,304.1l-2-1.35c-.12.19-.24.39-.38.57L86,304.77l-1.56,1.85-1.76-1.68c-.15.17-.31.33-.48.49l1.66,1.77L82,308.75,80.6,306.8l-.56.38,1.33,2-2.09,1.2-1.08-2.17c-.2.11-.42.19-.63.28l1,2.24-2.28.82-.69-2.33-.66.19.56,2.35-2.38.42-.27-2.42-.69.07.15,2.42H69.86l.15-2.41-.69-.07-.27,2.41-2.38-.42.56-2.35-.66-.2-.69,2.34-2.27-.83,1-2.23-.63-.29-1.08,2.17-2.09-1.21,1.34-2c-.19-.13-.39-.25-.57-.38l-1.44,1.94-1.85-1.56,1.67-1.76c-.16-.16-.33-.31-.49-.48l-1.76,1.67-1.55-1.86,1.95-1.44c-.14-.19-.26-.38-.39-.57l-2,1.34L54.46,302l2.16-1.08c-.1-.21-.18-.42-.27-.63l-2.24,1L53.29,299l2.33-.7C55.56,298,55.49,297.82,55.43,297.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M59.33,298.05a12.51,12.51,0,1,0,7.5-16A12.53,12.53,0,0,0,59.33,298.05Zm1.57-.57A10.84,10.84,0,1,1,74.79,304,10.86,10.86,0,0,1,60.9,297.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M59.08,298.22a12.69,12.69,0,0,0,5.41,6.56l0,0,.26.1.12.05a12.66,12.66,0,0,0,5.59,1.62l.13,0,.26.05v-.06a12.62,12.62,0,0,0,8.71-3.22l0,.1.51-.62.05-.06a12.92,12.92,0,0,0,1.51-1.86l0,0h0a14.08,14.08,0,0,0,.9-1.61.17.17,0,0,1,0-.05l.7-1.24-.2,0a12.64,12.64,0,0,0-.07-8.43c-.1-.28-.21-.54-.33-.8l.28-.05-1.81-2.8h0l-2.26-2.44a2.72,2.72,0,0,1-.14.3,12.73,12.73,0,0,0-8.85-2.56c0-.2,0-.31,0-.31l-3.22.85h0l-3,1.4a2.23,2.23,0,0,1,.21.19,12.74,12.74,0,0,0-5.26,7.6l-.16-.08-.08,1.35v.06a12.8,12.8,0,0,0,.18,4.31s0,.05,0,.08l.09.82.11-.06C58.9,297.69,59,298,59.08,298.22Zm4.41-14a1,1,0,0,1,1.35.14A12.78,12.78,0,0,1,66.58,287c.27.55.57,1.22.88,1.94a2.31,2.31,0,0,1-2.18,3.23c-.78,0-1.51-.06-2.12-.1a12.51,12.51,0,0,1-3.22-.64,1,1,0,0,1-.63-1.22A12.4,12.4,0,0,1,63.49,284.18Zm14.3-.57a1,1,0,0,1,.3,1.35,13.08,13.08,0,0,1-2,2.43c-.44.42-1,.91-1.57,1.43a2.3,2.3,0,0,1-3.74-1.08c-.22-.74-.42-1.45-.57-2a12.9,12.9,0,0,1-.38-3.13,1,1,0,0,1,1-1A12.28,12.28,0,0,1,77.79,283.61ZM82.93,297a1,1,0,0,1-1.18.71,13,13,0,0,1-3.06-1.17c-.54-.29-1.18-.66-1.85-1.05a2.31,2.31,0,0,1-.13-3.9c.64-.44,1.25-.84,1.77-1.17a13,13,0,0,1,2.9-1.35,1,1,0,0,1,1.22.59h0A12.21,12.21,0,0,1,82.93,297Zm-11.29,9.15a1,1,0,0,1-1-.9,12.62,12.62,0,0,1,.16-3.42c.11-.6.26-1.32.42-2.08a2.31,2.31,0,0,1,3.67-1.33c.61.47,1.19.93,1.65,1.32a12.82,12.82,0,0,1,2.29,2.48,1,1,0,0,1-.2,1.35,12.24,12.24,0,0,1-7,2.58Zm-6.28-2.41A1,1,0,0,1,64,304a12.24,12.24,0,0,1-4.53-5.89h0a1,1,0,0,1,.55-1.23,12.69,12.69,0,0,1,3.26-.89c.6-.08,1.33-.16,2.1-.24a2.31,2.31,0,0,1,2.4,3.08c-.26.73-.52,1.42-.74,2A12.74,12.74,0,0,1,65.36,303.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M58,298.05a13.76,13.76,0,1,0,8-17A13.76,13.76,0,0,0,58,298.05Zm6.74-15a.73.73,0,0,1,1,.21,33.64,33.64,0,0,1,3.36,6.55l.62,1.62a1.3,1.3,0,0,1-1.19,1.75l-1.74,0a32.52,32.52,0,0,1-7.44-.7.73.73,0,0,1-.54-.84A12.5,12.5,0,0,1,64.75,283Zm6.38,10.64Zm8.12-9.34a.72.72,0,0,1,.11,1,33.29,33.29,0,0,1-5.17,5.19c-.27.23-.8.65-1.35,1.09a1.3,1.3,0,0,1-2-.59c-.24-.66-.46-1.3-.57-1.65a33.75,33.75,0,0,1-1.62-7.14.73.73,0,0,1,.62-.78A12.53,12.53,0,0,1,79.25,284.31Zm3.41,14.22a.73.73,0,0,1-.9.42,33,33,0,0,1-6.67-3.37c-.31-.18-.87-.55-1.46-.94a1.31,1.31,0,0,1-.07-2.12c.57-.43,1.1-.84,1.4-1a34.15,34.15,0,0,1,6.32-3.76.74.74,0,0,1,.93.34,12.08,12.08,0,0,1,.64,1.47A12.42,12.42,0,0,1,82.66,298.53Zm-7.3,7a12.53,12.53,0,0,1-5.31.7.74.74,0,0,1-.67-.73A32.35,32.35,0,0,1,70.52,298c.08-.35.26-1,.45-1.67a1.3,1.3,0,0,1,2-.72c.58.4,1.14.78,1.43,1a32.14,32.14,0,0,1,5.64,5,.73.73,0,0,1,0,1A12.63,12.63,0,0,1,75.36,305.55Zm-16-7.5a14.72,14.72,0,0,1-.45-1.57.73.73,0,0,1,.49-.84,32,32,0,0,1,7.43-1.22c.36,0,1-.06,1.73-.09a1.3,1.3,0,0,1,1.3,1.67c-.2.68-.4,1.33-.51,1.67a31.72,31.72,0,0,1-3,6.95.72.72,0,0,1-1,.26A12.48,12.48,0,0,1,59.33,298.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M73.15,296.41a1,1,0,1,0-.62,1.33A1,1,0,0,0,73.15,296.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M71.93,296.09a.71.71,0,0,0-.43.92.72.72,0,1,0,1.35-.49A.71.71,0,0,0,71.93,296.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M69.15,296.53a1,1,0,1,0-1.27-1.64,1,1,0,0,0,1.27,1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M69.08,295.27a.72.72,0,0,0-1-.13.73.73,0,0,0-.12,1,.72.72,0,0,0,1.13-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M67.8,292.76a1,1,0,1,0-.27-1.44A1,1,0,0,0,67.8,292.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M69,292.31a.72.72,0,1,0-1,.19A.72.72,0,0,0,69,292.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M71,290.32a1,1,0,1,0,1.28-.71A1,1,0,0,0,71,290.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M71.77,291.3a.72.72,0,1,0,.39-1.38.71.71,0,0,0-.88.49A.72.72,0,0,0,71.77,291.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M74.27,292.57a1,1,0,1,0,1.07,1A1,1,0,0,0,74.27,292.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M73.59,293.63a.72.72,0,1,0,.69-.74A.72.72,0,0,0,73.59,293.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M69.72,294.17a1.43,1.43,0,1,0,.86-1.84A1.43,1.43,0,0,0,69.72,294.17Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 47.85,
    y: 271.61,
    width: 49.29,
    height: 18.68,
    transform: "translate(145 561.89) rotate(180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 257.72,
    cy: 289.9,
    r: 17.78,
    transform: "translate(-92.13 122.36) rotate(-22.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M242,288.19l-2.36-.27.41-2.33,2.32.55c.06-.22.11-.44.17-.65l-2.28-.68.81-2.22,2.18.94c.09-.21.19-.4.29-.61l-2.13-1.06,1.18-2.05,2,1.31c.13-.19.27-.37.4-.55l-1.92-1.41,1.53-1.82,1.73,1.64c.15-.17.31-.32.47-.48l-1.64-1.72,1.82-1.52,1.42,1.91c.18-.14.35-.28.54-.4l-1.31-2,2.05-1.19,1.07,2.13.61-.29-1-2.18,2.22-.81.68,2.28.65-.17-.55-2.31,2.33-.41.27,2.35.66,0-.13-2.38h2.36l-.14,2.38.67,0,.27-2.35,2.33.41-.56,2.31.66.17.68-2.28,2.22.81-.95,2.18.61.29,1.07-2.13,2.05,1.19-1.31,2c.18.12.36.26.54.4l1.42-1.91,1.82,1.52-1.64,1.72c.16.16.32.31.47.48l1.73-1.64,1.52,1.82-1.91,1.41c.13.18.27.36.4.55l2-1.31,1.19,2.05-2.13,1.06c.1.21.2.4.29.61l2.18-.94.81,2.22-2.28.68c.06.21.11.43.17.65l2.31-.55.41,2.33-2.35.27c0,.22,0,.44,0,.67l2.38-.14v2.37l-2.38-.15c0,.22,0,.45,0,.67l2.35.27-.41,2.33-2.31-.55c-.06.21-.11.43-.17.65l2.28.68-.81,2.22-2.18-.95c-.09.21-.19.41-.29.61l2.13,1.07L272.82,300l-2-1.31c-.12.19-.26.36-.4.54l1.91,1.42-1.52,1.82-1.72-1.64-.48.48,1.64,1.72-1.82,1.53-1.41-1.92-.54.4,1.3,2-2.05,1.18-1.06-2.13-.61.29.94,2.18-2.22.81-.68-2.28-.65.17.55,2.32-2.33.41-.27-2.36c-.22,0-.45,0-.67,0l.14,2.38h-2.36l.13-2.38c-.22,0-.45,0-.67,0l-.26,2.36-2.33-.41.55-2.32-.66-.17-.67,2.28-2.22-.81.94-2.18-.61-.29-1.06,2.13L247.63,305l1.3-2-.54-.4L247,304.55,245.16,303l1.63-1.72-.47-.48-1.72,1.64-1.53-1.82,1.92-1.42c-.14-.18-.28-.35-.4-.54l-2,1.31-1.18-2.05,2.13-1.07c-.1-.2-.2-.4-.29-.61l-2.18.95-.81-2.22,2.28-.68c-.06-.22-.12-.44-.17-.65l-2.32.55-.41-2.33,2.36-.27c0-.22,0-.45-.05-.67l-2.38.15v-2.37l2.38.14C242,288.63,242,288.41,242,288.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M257.72,277.31a12.59,12.59,0,1,1-12.59,12.59A12.59,12.59,0,0,1,257.72,277.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M293.63,292l-1.29,2.48a4.33,4.33,0,0,1-4.17,2.33l-47.72-3.55,5.82-24.47L283.41,265Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M257.65,276.39a18.5,18.5,0,1,1-11.08,23.7A18.51,18.51,0,0,1,257.65,276.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M248.3,297.6l-2.36.57-.41-2.38,2.41-.28c0-.23-.05-.46-.06-.69l-2.42.15v-2.42l2.42.15c0-.23,0-.46.07-.68l-2.42-.28.42-2.38,2.36.56c.05-.22.13-.44.19-.66l-2.33-.69.83-2.27,2.22,1c.1-.21.19-.42.3-.62l-2.18-1.09,1.21-2.09,2,1.34c.13-.19.25-.39.39-.57L249,282.8l1.56-1.85,1.76,1.67.48-.49-1.66-1.75,1.85-1.56,1.45,1.95.56-.39-1.34-2,2.1-1.21,1.08,2.16c.2-.1.41-.18.62-.27l-1-2.23,2.27-.83.68,2.34c.22-.07.44-.14.66-.19l-.55-2.36,2.38-.42.27,2.42.68-.07-.14-2.42h2.42L265,277.7l.68.07.28-2.41,2.38.42-.57,2.35.66.19.7-2.32,2.27.82-1,2.23.62.29,1.09-2.17,2.09,1.21-1.34,2c.19.12.38.24.57.38l1.44-1.94,1.85,1.56-1.68,1.76c.17.15.34.31.5.48l1.76-1.66,1.55,1.85L277,284.28l.39.56,2-1.33,1.2,2.09-2.16,1.08c.1.2.18.42.27.63l2.24-1,.82,2.28-2.33.68c.06.22.13.44.19.66l2.35-.55.42,2.38-2.42.27c0,.22,0,.45.07.68l2.42-.14V295l-2.42-.16c0,.23,0,.46-.07.69l2.41.28-.42,2.38-2.35-.57c-.05.22-.13.44-.19.66l2.33.7-.83,2.27-2.23-1c-.09.21-.18.41-.29.62l2.17,1.09-1.21,2.09-2-1.35c-.13.19-.25.39-.38.57l1.93,1.45-1.55,1.85-1.76-1.68-.48.49,1.66,1.77-1.85,1.55-1.44-1.95-.57.38,1.34,2-2.1,1.2-1.07-2.17c-.21.11-.43.19-.64.28l1,2.24-2.27.82-.7-2.33-.66.19.57,2.35-2.38.42-.28-2.42-.68.07.14,2.42h-2.41l.14-2.41-.68-.07-.28,2.41-2.38-.42.56-2.35-.65-.2-.7,2.34-2.27-.83,1-2.23-.62-.29-1.09,2.17-2.09-1.21,1.34-2-.57-.38L253,308.72l-1.84-1.56,1.67-1.76c-.17-.16-.34-.31-.5-.48l-1.75,1.67L249,304.73l1.94-1.44-.38-.57-2,1.34L247.32,302l2.17-1.08c-.1-.21-.19-.42-.28-.63l-2.23,1-.83-2.27,2.34-.7C248.42,298,248.35,297.82,248.3,297.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M252.2,298.05a12.51,12.51,0,1,0,7.49-16A12.53,12.53,0,0,0,252.2,298.05Zm1.57-.57a10.84,10.84,0,1,1,13.88,6.5A10.85,10.85,0,0,1,253.77,297.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M252,298.22a12.62,12.62,0,0,0,5.4,6.56l0,0,.26.1.12.05a12.7,12.7,0,0,0,5.59,1.62l.13,0,.27.05,0-.06a12.58,12.58,0,0,0,8.71-3.22l.06.1.5-.62.05-.06a12.28,12.28,0,0,0,1.51-1.86l0,0h0a12.71,12.71,0,0,0,.9-1.61l0-.05.69-1.24-.19,0a12.64,12.64,0,0,0-.08-8.43c-.1-.28-.21-.54-.32-.8l.27-.05-1.8-2.8h0l-2.25-2.44-.14.3a12.74,12.74,0,0,0-8.85-2.56c0-.2,0-.31,0-.31l-3.21.85h0l-3,1.4a2.23,2.23,0,0,1,.21.19,12.76,12.76,0,0,0-5.25,7.6l-.17-.08-.07,1.35a.13.13,0,0,1,0,.06,12.56,12.56,0,0,0,.19,4.31s0,.05,0,.08l.1.82.1-.06C251.77,297.69,251.85,298,252,298.22Zm4.4-14a1,1,0,0,1,1.36.14,13.19,13.19,0,0,1,1.74,2.69c.26.55.56,1.22.88,1.94a2.31,2.31,0,0,1-2.19,3.23c-.77,0-1.51-.06-2.11-.1a12.33,12.33,0,0,1-3.22-.64,1,1,0,0,1-.63-1.22A12.38,12.38,0,0,1,256.35,284.18Zm14.31-.57A1,1,0,0,1,271,285a13,13,0,0,1-2,2.43c-.44.42-1,.91-1.57,1.43a2.31,2.31,0,0,1-3.75-1.08c-.21-.74-.41-1.45-.56-2a13,13,0,0,1-.39-3.13,1,1,0,0,1,1-1A12.28,12.28,0,0,1,270.66,283.61ZM275.8,297a1,1,0,0,1-1.19.71,13.18,13.18,0,0,1-3.06-1.17c-.53-.29-1.18-.66-1.85-1.05a2.31,2.31,0,0,1-.13-3.9c.64-.44,1.26-.84,1.77-1.17a13,13,0,0,1,2.91-1.35,1,1,0,0,1,1.22.59h0A12.21,12.21,0,0,1,275.8,297Zm-11.3,9.15a1,1,0,0,1-1-.9,13,13,0,0,1,.16-3.42c.11-.6.26-1.32.43-2.08a2.3,2.3,0,0,1,3.66-1.33c.61.47,1.19.93,1.66,1.32a13.05,13.05,0,0,1,2.28,2.48,1,1,0,0,1-.2,1.35,12.19,12.19,0,0,1-3.36,1.86A12.38,12.38,0,0,1,264.5,306.17Zm-6.28-2.41a1,1,0,0,1-1.35.21,12.22,12.22,0,0,1-4.52-5.89h0a1,1,0,0,1,.56-1.23,12.49,12.49,0,0,1,3.25-.89c.6-.08,1.33-.16,2.1-.24a2.31,2.31,0,0,1,2.41,3.08c-.27.73-.52,1.42-.75,2A12.74,12.74,0,0,1,258.22,303.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M250.88,298.05a13.76,13.76,0,1,0,8-17A13.75,13.75,0,0,0,250.88,298.05Zm6.73-15a.74.74,0,0,1,1,.21,33.16,33.16,0,0,1,3.35,6.55c.14.33.38,1,.62,1.62a1.3,1.3,0,0,1-1.18,1.75l-1.75,0a32.42,32.42,0,0,1-7.43-.7.74.74,0,0,1-.55-.84A12.56,12.56,0,0,1,257.61,283ZM264,293.65Zm8.12-9.34a.73.73,0,0,1,.11,1,33.74,33.74,0,0,1-5.17,5.19l-1.36,1.09a1.3,1.3,0,0,1-2-.59c-.23-.66-.46-1.3-.56-1.65a33.28,33.28,0,0,1-1.63-7.14.73.73,0,0,1,.62-.78A12.55,12.55,0,0,1,272.12,284.31Zm3.4,14.22a.73.73,0,0,1-.9.42,33,33,0,0,1-6.67-3.37c-.3-.18-.86-.55-1.45-.94a1.31,1.31,0,0,1-.07-2.12l1.39-1a34.15,34.15,0,0,1,6.32-3.76.73.73,0,0,1,.93.34,12.13,12.13,0,0,1,.65,1.47A12.42,12.42,0,0,1,275.52,298.53Zm-7.3,7a12.48,12.48,0,0,1-5.3.7.73.73,0,0,1-.67-.73,32.22,32.22,0,0,1,1.13-7.51c.09-.35.27-1,.46-1.67a1.29,1.29,0,0,1,2-.72c.59.4,1.14.78,1.43,1a31.77,31.77,0,0,1,5.64,5,.72.72,0,0,1,0,1A12.47,12.47,0,0,1,268.22,305.55Zm-16-7.5a11.18,11.18,0,0,1-.45-1.57.72.72,0,0,1,.49-.84,32,32,0,0,1,7.42-1.22c.36,0,1-.06,1.74-.09a1.3,1.3,0,0,1,1.3,1.67c-.21.68-.4,1.33-.52,1.67a32.29,32.29,0,0,1-3,6.95.74.74,0,0,1-1,.26A12.43,12.43,0,0,1,252.2,298.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M266,296.41a1,1,0,1,0-.62,1.33A1,1,0,0,0,266,296.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M264.79,296.09a.72.72,0,0,0-.43.92.73.73,0,0,0,.92.43.72.72,0,0,0,.43-.92A.71.71,0,0,0,264.79,296.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M262,296.53a1,1,0,1,0-1.46-.18A1,1,0,0,0,262,296.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M262,295.27a.72.72,0,0,0-1-.13.73.73,0,0,0-.13,1,.72.72,0,0,0,1.14-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M260.67,292.76a1,1,0,0,0,1.44-.27,1,1,0,1,0-1.72-1.17A1,1,0,0,0,260.67,292.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M261.85,292.31a.72.72,0,0,0-.2-1,.71.71,0,0,0-1,.19.72.72,0,0,0,.19,1A.73.73,0,0,0,261.85,292.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M263.83,290.32a1,1,0,1,0,1.29-.71A1,1,0,0,0,263.83,290.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M264.63,291.3a.72.72,0,0,0,.89-.5.71.71,0,0,0-.49-.88.72.72,0,1,0-.4,1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M267.13,292.57a1,1,0,1,0,1.08,1A1,1,0,0,0,267.13,292.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M266.45,293.63a.72.72,0,1,0,.7-.74A.73.73,0,0,0,266.45,293.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M262.58,294.17a1.44,1.44,0,1,0,.86-1.84A1.44,1.44,0,0,0,262.58,294.17Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 238.72,
    y: 274,
    width: 49.29,
    height: 17.92,
    transform: "translate(526.73 565.91) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M163.84,300.43h36.41l2.81-1.79h16.19l3.14,1.79H234a2.88,2.88,0,0,0,2.88-2.88v-1.34H161v1.34A2.88,2.88,0,0,0,163.84,300.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M292.91,288.82a52.86,52.86,0,0,0-.79,7.73c0,3.35.79,8.78.79,9.36,0,.3-1.78-1.53-2-2.43a35.81,35.81,0,0,1-1.47-7.49c-.57-7.55,2.17-10,2.17-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M96.32,289.76a52.2,52.2,0,0,0-.8,7.72c0,3.36.8,8.79.8,9.37,0,.3-1.79-1.53-2-2.43a35.81,35.81,0,0,1-1.47-7.49c-.58-7.56,2.17-10,2.17-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M30.4,258.61c10.07-8.29,33.86-21,33.86-21l1.75-.12s29.3-29,38.95-38.73c10.42-10.56,23.4-16.43,54.19-16.43h0c.61,0,1.22,0,5.47,0H320.71c7.21,0,10,4.24,10.55,9.8,1.26,13,3.29,27.64,3.38,37.05.07,7.47-.36,47.9-.48,58.78a3.49,3.49,0,0,1-2.64,3.36l-13.46,5.4-28.58.11L284.3,281.4a7.93,7.93,0,0,0-7.52-5.42H252.16a7.94,7.94,0,0,0-7.53,5.43L239.44,297,229,297l-30.3.12-106.1.36V282.59c-19-21.6-43.05-8.44-43.05,10.35v4.67l-1.33-.81L29.9,292.69S23.33,264.43,30.4,258.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M333.64,289.76l-15.58,7-28.58.1-5.21-15.53a7.9,7.9,0,0,0-7.49-5.39H252.13a7.89,7.89,0,0,0-7.49,5.41L239.44,297l-146.82.35V282.59c-19-21.6-43.05-8.44-43.05,10.35v4.39h-.46l-.87-.53L29.9,292.69s-6.35-27.32,3.8-33.77H337.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M32.83,292.94a39.57,39.57,0,1,1,79.13,0,39.05,39.05,0,0,1-.26,4.48l-19.08.06V282.59c-19-21.6-43.05-8.44-43.05,10.35v4.67l-1.33-.81-15.41-3.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M44.43,292.7a26.81,26.81,0,1,1,53.61.35v3.24h-5V293a21.84,21.84,0,1,0-43.68-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M36.26,275.63H27.31c-.52-7.13-.12-14.38,3.09-17l.14-.11h5.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 92.62,
    y: 295.28,
    width: 49.49,
    height: 3.04,
    transform: "translate(234.73 593.61) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M27.09,276c.3-2.19,25.08-1.34,25.78-.92a25.35,25.35,0,0,0-6.12,10.61,68,68,0,0,0-1.91,10.77s-13.78-.55-16.52-3.13C26.58,291.69,26.85,277.76,27.09,276Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M44,275.46c.23.9-1.65,14.43-3.92,16.69-1.75,1.74-8.87.54-10.18.54S26.06,281.43,27.39,276C27.76,274.46,43.64,274.07,44,275.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M43.39,275.52c.21.85-1.74,13.33-3.84,15.43-1.62,1.63-8.27.7-9.48.7S26.38,281,27.66,276C28,274.57,43.06,274.17,43.39,275.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M42.77,275.57C43,276.39,41,287.8,39,289.75c-1.5,1.52-7.67.85-8.8.85s-3.52-10-2.31-14.59C28.27,274.67,42.47,274.27,42.77,275.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M42.16,275.62c.17.78-1.91,11.14-3.66,12.93-1.36,1.41-7.06,1-8.11,1S27,280.12,28.18,276C28.53,274.78,41.89,274.38,42.16,275.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M41.54,275.67c.15.74-2,10-3.56,11.68-1.25,1.3-6.46,1.16-7.42,1.16s-3.18-8.82-2.12-12.46C28.78,274.89,41.31,274.48,41.54,275.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M40.93,275.73c.12.69-2.08,8.94-3.48,10.42-1.12,1.19-5.86,1.31-6.73,1.31s-3-8.2-2-11.39C29,275,40.73,274.58,40.93,275.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M40.32,275.78c.1.66-2.17,7.84-3.39,9.17-1,1.08-5.26,1.47-6.05,1.47s-2.82-7.59-1.92-10.33C29.29,275.1,40.14,274.68,40.32,275.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M39.7,275.83c.08.62-2.25,6.75-3.3,7.92-.87,1-4.65,1.62-5.35,1.62s-2.64-7-1.83-9.26C29.55,275.2,39.56,274.78,39.7,275.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M39.09,275.88c.06.58-2.34,5.66-3.21,6.67s-4.05,1.78-4.67,1.78-2.45-6.36-1.72-8.2C29.81,275.31,39,274.88,39.09,275.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M38.47,275.94c0,.53-2.42,4.55-3.12,5.41a10.27,10.27,0,0,1-4,1.93c-.53,0-2.24-5.74-1.62-7.13C30.07,275.42,38.4,275,38.47,275.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M37.86,276c0,.49-2.5,3.46-3,4.16a10,10,0,0,1-3.29,2.09c-.45,0-2-5.11-1.53-6.07C30.34,275.53,37.82,275.08,37.86,276Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M37.25,276c0,.46-2.59,2.37-3,2.91a9.8,9.8,0,0,1-2.6,2.24c-.36,0-1.79-4.47-1.43-5S37.25,275.19,37.25,276Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M31.16,289c2.66.53,11.33.4,13.77.36-.22,3.94-.09,7.05-.09,7.05s-13.78-.55-16.52-3.13c-.65-.6-1-2.88-1.21-5.61A22.06,22.06,0,0,0,31.16,289Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M27.09,276c.3-2.19,25.08-1.34,25.78-.92l-.56,2.08A138.16,138.16,0,0,0,31.42,276C29.59,276.19,27,276.51,27.09,276Z"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-74",
    width: 36,
    height: 23,
    transform: "translate(36.29 236.15)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAXCAYAAABj7u2bAAAACXBIWXMAAAsSAAALEgHS3X78AAAB0klEQVRIS83UwUsUYRiA8WeXdWvJxYsMRSooiKeITt46VRfpkFF4KBAUwaCDYKAbOLtvh251kVi3Q4cu/QVbxgYira6IHgVZ0IMb2BIVYaXjwuvpW8bSVt0ZpwfmMjDw43vne1FV/ocnlUqpqhJSVYJORBSg+0pnsCAR0Wg0iuM45KazzOYLoXCtj/zKnEoymWS9uMJsvhACiPz7M+8zEIBM5iXpyWf0Dz4ImXenBnJDcu8/MDoySKm0UYWYfP+H3JDNT5/pu32Nqzdu/QUx+QYSEbWaLcpfyuz8dLh8qY2794YOhZg8H5n7RC6eb+XcmV3uDzysCTF5BnJD2ts6KK4ucbO358gQkyfXXkS0Kd6E1WyRm86yWS4hT58fGwN1npD7VFJiMzHxuLpPTtqJQH/uErHH+Prte10Q07FAbsjb7DvGR4cP3CX1dCTQvptjtRJt2GK+MOcpxFRzD4mIxhvjxM7GWJif4dXrN75ATIfeMhHR9Iu0AiQS41Qqv3zHwAEjc48n/3GOO73X+b297TvEtA9kMC0XWpjKTLKwuHxqEFN1ZAZj2zY7zo9AMAAR94hs20ZVA4GYwgCdHV3EIruBYwDCsUiF4toqjxJPAscA7AHnmiFFcw3f3wAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M324,182.92a10.85,10.85,0,0,1,7.28,9.22c1.26,13,3.29,27.64,3.38,37.05.07,7.47-.36,47.9-.48,58.78a3.49,3.49,0,0,1-2.64,3.36l-13.46,5.4h-2.31Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "240.05 295.15 142.11 295.15 142.11 297.33 239.45 297 240.05 295.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "324.91 294.99 296.37 295.06 289.48 296.84 318.02 296.74 324.91 294.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M318.06,296.73l15-4.24c.73-.12,1.25-.56,1.26-1.07l.14-12.39c0-.18-.21-.32-.47-.32l-15.87.64Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "334.19 278.74 334.2 277.56 318.13 277.56 318.11 279.35 334.19 278.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M332.82,278.74l1.16,0c.26,0,.47.14.47.32l-.14,12.39c0,.51-.53.95-1.26,1.07l-.23,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M39.47,256.46c1.28-2.34,25.3-14.54,28.78-16.17,1.07-.5,66.32-2.51,66.43-1.5.35,3.25-52,15.62-61.36,19.76-5.66,2.5-17.49,12-21.6,14.67-3.16,2.06-16.8,1.33-17.5-.39C32.72,269.15,38.82,257.64,39.47,256.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M39.93,256.43c1.32-2.3,24-13.82,27.3-15.36,1-.47,60.62-2.27,60.69-1.32.24,3.07-47.71,14.53-56.39,18.52-5.23,2.4-16.13,11.34-20.1,13.92-3,2-15.8,1.27-16.45-.31C33.54,268.39,39.3,257.54,39.93,256.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M40.4,256.41c1.36-2.27,22.68-13.11,25.81-14.56,1-.45,54.92-2,55-1.14.12,2.9-43.47,13.43-51.43,17.27-4.8,2.31-14.77,10.71-18.61,13.18-2.88,1.86-14.78,1.2-15.38-.24C34.38,267.63,39.77,257.45,40.4,256.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M40.86,256.39c1.41-2.24,21.38-12.4,24.33-13.75,1-.44,49.22-1.79,49.23-1,0,2.72-39.23,12.33-46.47,16-4.36,2.22-13.4,10.07-17.11,12.44-2.74,1.76-13.78,1.14-14.33-.16C35.21,266.88,40.25,257.36,40.86,256.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M41.32,256.37c1.46-2.21,20.07-11.7,22.84-13,.93-.42,43.53-1.55,43.5-.79-.1,2.55-35,11.23-41.5,14.77-3.93,2.13-12,9.43-15.62,11.7-2.6,1.65-12.77,1.08-13.27-.08C36.05,266.12,40.73,257.26,41.32,256.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M41.79,256.35c1.5-2.18,18.75-11,21.35-12.15.89-.4,37.83-1.3,37.77-.61-.23,2.38-30.74,10.13-36.54,13.52-3.5,2-10.68,8.79-14.12,11-2.46,1.55-11.77,1-12.21,0C36.88,265.37,41.22,257.17,41.79,256.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M42.25,256.33c1.56-2.14,17.45-10.28,19.87-11.35.86-.37,32.13-1.06,32-.43-.34,2.21-26.49,9-31.57,12.27C59.52,258.77,53.26,265,50,267c-2.32,1.45-10.76,1-11.15.07C37.71,264.61,41.7,257.08,42.25,256.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M42.71,256.3c1.62-2.1,16.14-9.56,18.39-10.54.82-.35,26.43-.81,26.3-.25-.47,2-22.25,7.93-26.61,11-2.63,1.86-8,7.52-11.14,9.48-2.17,1.35-9.75.9-10.09.15C38.54,263.86,42.18,257,42.71,256.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M43.18,256.28c1.67-2.06,14.83-8.85,16.89-9.73.79-.34,20.74-.58,20.58-.08-.6,1.87-18,6.83-21.65,9.77-2.2,1.77-6.59,6.88-9.64,8.74-2,1.25-8.76.84-9,.22C39.37,263.1,42.67,256.9,43.18,256.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M43.64,256.26c1.74-2,13.52-8.14,15.41-8.93.76-.32,15-.33,14.84.1-.73,1.7-13.76,5.74-16.68,8.52-1.76,1.68-5.23,6.24-8.15,8-1.89,1.15-7.75.78-8,.3C40.2,262.35,43.16,256.82,43.64,256.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M44.1,256.24c1.82-2,12.22-7.43,13.93-8.13.72-.29,9.32-.09,9.11.28-.88,1.52-9.52,4.64-11.72,7.27-1.33,1.59-3.87,5.6-6.65,7.26-1.75,1.05-6.75.72-6.92.38C41,261.6,43.65,256.73,44.1,256.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M48.47,261.89c-1.6.94-5.75.66-5.86.45-.78-1.49,1.53-5.69,2-6.12,1.89-1.9,10.9-6.72,12.44-7.33.68-.27,3.62.15,3.38.46-1,1.33-5.28,3.54-6.76,6C52.74,256.87,51.12,260.34,48.47,261.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M76.63,237.84c2-2.06,14-16.33,15.88-18.42,7.23-8.07,12.24-12.34,11.37-13.29-.67-.73-11.32,9.17-13.32,11.41-2.36,2.63-13.31,14.37-16.2,17.11-5.16,4.91-8.3,8.71-7.85,9.26S74,240.5,76.63,237.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M74.37,234.77c2.73-2.59,13.08-13.69,15.31-16.18,1.92-2.14,11.84-11.42,12.47-10.75.81.88-3.87,4.91-10.67,12.5-1.92,2.14-13.11,15.48-15,17.38-2.42,2.4-8.8,6-9.22,5.5S69.66,239.24,74.37,234.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M74.37,234.89C77,232.44,86.7,222,88.81,219.63c1.82-2,11-10.7,11.61-10.08.75.81-3.6,4.6-10,11.7-2,2.2-12.37,14.6-14.17,16.34-2.21,2.15-8,5.41-8.34,4.95S70.12,238.93,74.37,234.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M74.38,235c2.42-2.29,11.56-12.11,13.55-14.32,1.73-1.94,10.22-10,10.76-9.42.68.74-3.33,4.29-9.26,10.91-2,2.25-11.63,13.72-13.32,15.3-2,1.89-7.1,4.8-7.45,4.38S70.58,238.61,74.38,235Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M74.38,235.12c2.27-2.14,10.81-11.32,12.67-13.4,1.65-1.84,9.42-9.26,9.91-8.75.62.67-3.07,4-8.56,10.11-2.07,2.31-10.88,12.84-12.46,14.27-1.8,1.63-6.25,4.2-6.57,3.82S71,238.29,74.38,235.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M74.39,235.24c2.11-2,10-10.53,11.79-12.48,1.55-1.73,8.61-8.54,9-8.07s-2.79,3.66-7.85,9.31c-2.12,2.37-10.13,11.95-11.6,13.22s-5.4,3.6-5.68,3.27S71.5,238,74.39,235.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M74.4,235.35c1.94-1.84,9.28-9.73,10.9-11.54,1.47-1.64,7.8-7.82,8.19-7.41s-2.52,3.35-7.15,8.51C84.17,227.34,77,236,75.6,237.1s-4.55,3-4.79,2.7S72,237.66,74.4,235.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M74.4,235.47c1.79-1.69,8.52-8.95,10-10.62s7-7.1,7.34-6.74-2.25,3-6.44,7.72c-2.23,2.48-8.64,10.18-9.9,11.15s-3.69,2.39-3.9,2.14S72.42,237.34,74.4,235.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M74.41,235.59c1.63-1.54,7.76-8.16,9.13-9.69s6.19-6.38,6.49-6.08-2,2.73-5.74,6.92c-2.27,2.54-7.88,9.3-9,10.12-.91.63-2.83,1.78-3,1.57S72.88,237,74.41,235.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M74.41,235.7c1.48-1.38,7-7.36,8.26-8.76s5.38-5.66,5.63-5.41-1.72,2.42-5,6.13c-2.32,2.59-7.11,8.42-8.18,9.07-.67.41-2,1.19-2.13,1S73.34,236.71,74.41,235.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M74.42,235.82c1.32-1.23,6.24-6.57,7.37-7.83s4.58-5,4.78-4.75-1.45,2.11-4.33,5.33c-2.38,2.66-6.34,7.56-7.33,8-.41.2-1.13.58-1.24.46S73.8,236.4,74.42,235.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M74.43,235.94c1.16-1.08,5.48-5.78,6.48-6.91s3.77-4.22,3.93-4.08-1.18,1.81-3.63,4.54-5.51,6.85-6.47,7a.43.43,0,0,1-.36-.11A.29.29,0,0,1,74.43,235.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M30.4,258.61c10.07-8.29,33.86-21,33.86-21l1.75-.12,5.13-.17a12.54,12.54,0,0,1-2.79,2.37c-1.35.73-26.56,14.13-28.75,16s-4.42,4.12-4.42,4.12l-6.18.52A6.09,6.09,0,0,1,30.4,258.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M27.79,270.08s10,0,11.33-1.2,6.15-14.08,4.63-14.15S31.27,256.92,29,260.24C27,263.2,26.12,269.09,27.79,270.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M27.79,270.08s10,0,11.33-1.2,6.15-14.08,4.63-14.15S31.27,256.92,29,260.24C27,263.2,26.12,269.09,27.79,270.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M27.79,270.08s10,0,11.33-1.2,6.15-14.08,4.63-14.15S31.27,256.92,29,260.24C27,263.2,26.12,269.09,27.79,270.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M43.75,254.73a13.52,13.52,0,0,0-1.74.2c-.33,3.16-3.74,12.29-4.86,13.25s-7,1.12-9.83,1.18a1.13,1.13,0,0,0,.47.72s10,0,11.33-1.2S45.27,254.8,43.75,254.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M32.66,264.78c2.22-3.25,9.27-7.48,11.11-7.6.33-1.43.39-2.43,0-2.45-1.52-.06-12.48,2.19-14.75,5.51-2,2.88-2.72,8.61-1.3,9.73C30.11,269.93,31.47,266.53,32.66,264.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M34.27,265.13c.08,1.5-.27,2.74-.78,2.77s-1-1.16-1.09-2.66.26-2.74.78-2.77S34.18,263.63,34.27,265.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M33.18,262.47c.51,0,1,1.16,1.09,2.66s-.27,2.74-.78,2.77L40.73,266l1.69-4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M31.74,265.57c.08,1.5-.27,2.74-.78,2.77s-1-1.16-1.09-2.66.26-2.74.77-2.77S31.65,264.08,31.74,265.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M43.82,255.14c-.09.65-10.51,4.11-12.59,5.61s-3.6,8.66-3.76,8.35,1-7.27,2.9-8.78C32.11,258.94,43.9,254.59,43.82,255.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M103,204.07c-.84,2.07,36-4.69,54-6.15,13.94-1.14,140.34-7.57,141-10.63s-126.68-5.16-148.79-3.76C122.44,185.21,107.18,193.77,103,204.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M104.26,203.5c-.76,2,36-4.61,52.56-6,13.17-1.15,130-7.41,130.58-10.34s-117.78-4.73-138.72-3.35C122.91,185.56,107.94,193.9,104.26,203.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M105.51,202.93c-.67,1.86,36-4.48,51.15-5.83,12.4-1.11,119.63-7.26,120.12-10s-108.88-4.32-128.65-2.94C123.38,185.91,108.7,194,105.51,202.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M106.75,202.36c-.58,1.75,36-4.38,49.75-5.68,11.64-1.09,109.27-7.09,109.66-9.74s-100-3.9-118.58-2.52C123.85,186.26,109.46,194.17,106.75,202.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M108,201.79c-.49,1.64,35.94-4.28,48.34-5.52,10.87-1.08,98.92-6.93,99.21-9.45S164.46,183.3,147,184.71C124.31,186.55,110.24,194.32,108,201.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M109.25,201.22c-.4,1.54,35.93-4.18,46.93-5.36,10.1-1.08,88.57-6.77,88.75-9.15s-82.18-3.11-98.46-1.7C124.78,186.89,111,194.46,109.25,201.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M110.5,200.65c-.31,1.44,35.92-4.1,45.52-5.2,9.34-1.07,78.21-6.61,78.29-8.86s-73.28-2.69-88.39-1.28C125.25,187.24,111.81,194.62,110.5,200.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M111.75,200.08c-.22,1.34,35.9-4,44.11-5,8.57-1.07,67.86-6.45,67.83-8.56s-64.38-2.28-78.32-.88C125.72,187.58,112.62,194.78,111.75,200.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M113,199.51c-.12,1.24,35.89-3.94,42.7-4.88,7.81-1.08,57.5-6.29,57.37-8.27s-55.48-1.85-68.25-.46C126.19,187.94,113.44,195,113,199.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M114.25,198.94c0,1.14,35.87-3.88,41.29-4.72,7-1.09,47.15-6.13,46.92-8s-46.58-1.42-58.2,0C126.66,188.29,114.3,195.13,114.25,198.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M115.5,198.37c.1,1,35.86-3.84,39.88-4.56,6.27-1.13,36.79-6,36.46-7.68s-37.68-1-48.13.37C127.13,188.69,115.2,195.3,115.5,198.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M116.74,197.8c.25.93,35.84-3.81,38.49-4.4,5.47-1.23,26.43-5.81,26-7.39s-28.77-.56-38.06.78C127.6,189,116.13,195.44,116.74,197.8Z"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-121",
    width: 9,
    height: 23,
    transform: "translate(326.29 249.15)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAXCAYAAADZTWX7AAAACXBIWXMAAAsSAAALEgHS3X78AAAA/klEQVQoU43QIXLCQBSH8Y/sijgGRVFFdR2VwXGziLgiyyXoEegJWFVEMOUUKHaTzPwraAbopIFvZtX7zcvkIYnfp/1+r7ayLFWWpSTJck7L5RuLxYLd7osYI9dZQN57QohsNp90ZQGMMQDkeT5oB0VRyLkXsmxOco3+FmPE+20/ApjNXu+jEMIZWduHTv2bhsMhp1PoR1VVXz5nTHvT2+q6ukbdm5qmoa6r+39395htj6Hj8dgLABJjDIfDd+dwNBpd0H81TXNG1nbf6AY9tClJEsbjp140kCTvt0wmE9brD0AAhBCZTp9xzjGQRDuRxGr1TpqmpGmKc44sm/MDCu+BUA0b4BMAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 328.14,
    y: 250.75,
    width: 7.22,
    height: 20.28,
    rx: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 328.14,
    y: 250.75,
    width: 7.22,
    height: 20.28,
    rx: 0.95
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-123",
    points: "328.95 257.07 333.57 257.07 333.57 252.05 328.9 252.05 328.95 257.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M334.83,254.56c0,1.39-.57,2.51-1.26,2.51s-1.27-1.12-1.27-2.51.57-2.51,1.27-2.51S334.83,253.18,334.83,254.56Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "328.95 263.47 333.57 263.47 333.57 258.45 328.9 258.45 328.95 263.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M334.83,261c0,1.39-.57,2.51-1.26,2.51s-1.27-1.12-1.27-2.51.57-2.51,1.27-2.51S334.83,259.58,334.83,261Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-126",
    points: "328.95 269.88 333.57 269.88 333.57 264.86 328.9 264.86 328.95 269.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M334.83,267.37c0,1.38-.57,2.51-1.26,2.51s-1.27-1.13-1.27-2.51.57-2.51,1.27-2.51S334.83,266,334.83,267.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 331.67,
    y: 251.56,
    width: 3.37,
    height: 18.99,
    rx: 1.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M334.34,270.54h0a.66.66,0,0,0,.7-.61V252.17a.66.66,0,0,0-.7-.61h0a.66.66,0,0,0-.7.61v17.76A.67.67,0,0,0,334.34,270.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M328.81,250.75h2.08a1,1,0,0,0-1,.89v18.5a1,1,0,0,0,1,.89h-2.08c-.37,0-.67-.59-.67-1.32V252.08C328.14,251.35,328.44,250.75,328.81,250.75Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "242.95 286.42 92.47 286.42 92.47 281.14 244.71 281.14 242.95 286.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "285.97 286.42 318.06 286.42 318.06 281.14 284.21 281.14 285.97 286.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M44.68,292.94a26.42,26.42,0,1,1,52.83.33v5.86a.8.8,0,0,1-.78.79H93.41a.79.79,0,0,1-.79-.79v-5.88a21.53,21.53,0,1,0-43.05-.32v4.67H48.24l-3.56-.76Z"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-74",
    width: 54,
    height: 90,
    transform: "translate(85.29 204.15)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAABaCAYAAADzc6X8AAAACXBIWXMAAAsSAAALEgHS3X78AAAE/ElEQVR4Xu2cbWhVZRzAf/9N03Dq3rxiIktEC6FoBCoFfqs+VIYkYtQQjYFphi1rumyMy7xO29zY2hqKJWkZvaikg/oQfQrSCMSXMioUQYhpe1GXe/P++3DPubtn233bRvc8D/vBtnvu8z/s/M7//zz3Ofc594qqMtHsrQnpsuKHqK1voaPrLuXbd4ACKHf7ekGVe+F7oKAo7jGoeh+Dok7MwEB/tN37EyasyvRp05kXmM8/ndfYWLpFZCLFjhxq0pmzizj/6znP84HCQMyBAAw7uJhtPNt4Yoizj6qSn1tAdnY2HzQ3c/HShYkRCwaDGgqFqKioIFAYoP1mO5WVlZJsv4lmf12d3unpYXnxYsYt1nbiiPb253Dp9wsAGRGKpbW5VRcumM2UZIGJCAaD0bOSaSEXp4eSlSQuLhtK1ilE+o9fpCJE+uaYxDaUrNOFi5cCsGnzJh9JDZG22Gul66NS/spUBHfETEusuqpc5y1YBPhTKko6pVhdVa7hrBmAz6UcUhJrrKs2RipSiimIHTnUpF09YcD/UlE0SR87+cXHeuV6J2CQlENcse9OHdOr17sBs6QSluIP336ll/9qH63JDFRHTqlOn/hUr1zrAODW7VtGZQvcKRVesVPHj+r1v+8A0H2r2zgpwLnsiRH75uujeqcnm/abkRI0UsrFHRU/OtisPf9O4c+rfwBmS6lTjFkAn31+ku7bXYDZUi4KZOfl5uijjzyWsaveiebMT2eq8mZNI6t4qQGT2jTwlKI7YNhCSnNF41CSzxVNxFOKtjFZiibhvGdsn5iLfWKq6b2ZYwrOGo19Yi4WitlaijpZiqYxWYpmYqGYpbN7VcjJmWGfmLUZc7FOzL27wzqxyVI0DXe1xToxt5NZJ2ZvxhzsE7O+FMMaThhoHk7GRKxYPRrC1pmHxaOipYNHtBQFu/qYpxTtGj+cUjx/+QoFeXM8d2QbjVuKr79RJmXb37Qma55SbGmqQ0TYXV1tQdZiRsWNpVuktfVAwnDTiA73LQ0hECEU2m101nT4JHjVmhI5faot7g6m4XmBDr63DUGo2bPH6KzBMLGnnl0rP5/9JV6sERTmB0Zfbdm2+RUQYW9NjZFZcz8oN0Js5dOr5fy5C6PtYwRxxQDWv/wcIsK+ffuMy5oSji/2zPMvSXfH7dGafI+qEk50y9HDS+YiCLXv1xqVtYSlCFDy6laZef+seM2+JakYwED/DUSgrrbOmKylJLb1rV2yqGhJohDfkZIYwMVLPyIi1O+vNyJrKYvtqtorRfMfTBbmG1IWAzhz9nsEaKhv8H3W0hLLyZ3L3MADycJ8wYjLlkRUVlbK8eNHEREaGxp9nTVVTe92iGUrniA/tyBZWMZRZy0iZbG339kpbW1fIgJNjU2+zVpapehS/Phypk69j86uzmShGWNMHygo31Ehhw8fID8337fvQ44pYwAvrH4REaEgrzBZaEYYs9jOne/KnppqAF9mbcxiAMGqXYjAnII5yUL/d8YltrF0i5RtL0sWlhHGfS/Vh037EYTWllbflKPbNfr6Bsf3ZUArn1yha9eVsLgojxs3O3DXs0XEWeSI/BUEJPaxExPzOLqfpx0GBgeH2t22SPCI5879do1QKERvb+/4v77p2CcHNT93Bn39/Tj/cmgpUYZtj/acewI8MZFfgwMDzgmRqMxoJ0ok0tbXN8iqNSUC8B/6qndKi+vFqQAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M131.14,207.47l-19.07.08a11.84,11.84,0,0,0-8.38,3.51L82.47,232.5a3.69,3.69,0,0,0,2.77,6.29l46-1.89a3,3,0,0,0,2.84-3V210.43A3,3,0,0,0,131.14,207.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M85.19,237.39l46-1.88a1.57,1.57,0,0,0,1.5-1.57V210.43a1.56,1.56,0,0,0-1.56-1.56l-19.07.08a10.4,10.4,0,0,0-7.4,3.1L83.46,233.48A2.24,2.24,0,0,0,83,236a2.27,2.27,0,0,0,2.11,1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M83,236a2.47,2.47,0,0,0,.84,1l5.44-5.19,1.11,5.36,8.35-.34a14.55,14.55,0,0,1-.7-2.58c.18,0,1.92-.22,1.92-.22l.7,2.72,1.1,0s-1.71-9.05-4.2-9.49-3.32,1.84-3.54,2.89c-.15.74-.26-1.28-.32-2.5l12.72-12.12a9.4,9.4,0,0,1,2.2-1.57v22.51l1.34-.05v-23a9.37,9.37,0,0,1,2.84-.51l19.94-.51v-1.9a1.56,1.56,0,0,0-1.56-1.56l-19.07.08a10.4,10.4,0,0,0-7.4,3.1L83.46,233.48A2.24,2.24,0,0,0,83,236Zm14.87-5.83c0-.22,0-1.14.52-.61a10.77,10.77,0,0,1,1.18,2.88H98.49S97.84,230.37,97.84,230.15Z"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-74",
    width: 57,
    height: 36,
    transform: "translate(79.29 205.15)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADkAAAAkCAYAAAAzUJLAAAAACXBIWXMAAAsSAAALEgHS3X78AAADdUlEQVRoQ92ZT0/bSBiHn3HsOLZDrKiRQELcnK4E3KB7SDhwau/dU1fd7qFA2FP3E6Blvsa29EtsvwKXfAJEVtogTnDIn2ZDiENmD6mTkKWYAAlJftJInvE7nnn0s1/beoVSinFLStld1HUTzM/PAwIhQAjRbYNjnf5NY73+8fExlUoVgL29PQEgxgUppVSJxBz1eh1d19F1nUgkgmEYpFIpNE3rNiGCYzH0+NHREaenpxiGga7rfPjwuxgLpJRSmWYU0zTJZrPYts3z5z9gGIYIm3sfFYtF9eXLX7RaLcrlymid7L8tU6lnvH+/hWmaIwEbVKlUUh8//kk0GkUPC76vpJTKdRMAZDIZXrz4cSxwgZLJpFhcXFTn5+ejgQwcNAyDN29+JplMjhUwUDqdplD4Gy0scFgFgKnUM7a3d54MEMDz0gCP62SQQYUQbG1tjyyxDKtHc7IfcHf3N6LR6JMDnpwUgUeCHAQcVwYNkxAdvAdDSinV3FwcIQS53O7EAAJoWmcrD4IMADVNI5fbJRaLTQwgPIKT/YA7O7mJA4QHOimlVPG40wW0LGviAOEBTgaAkUiE7e2diQUE0LR7QPYDvnv3K7ZtTywg8O1XbAhIKaVyHLsL+JRfMnfVUE4GgLquTw0gDJF4pJTKtq2pA4Q7Jp4A0DCMqQOEOzg57YAQ4qSUUllWbKoB4RYnA8BoNDrVgPAdJ2cJEG54hUgpVSxmzgwgDHwMBICmac4MIPScjGiapiwrRjwe5+3bX2YGEODi4uKPfD7fu11fv/5ppgBh4Jl0HIeFhYWZAoSBZ3J5efnW4GlVoXCM6ybQHMfGcZyw+KlTo9FQh4eHVKtVtFgsRj6fD5szVSqVSurg4BOVShWlQG+1WjQaDUqlkpqkxCOEUNlslvX1dVZXV/E8j83NTXzfp16v0263aTab11qt9hXPS/P58wHNZhPXTXRKd/v7+8p1E/i+j2VZvHz5inQ6HQobj8dVNptlbW2NlZUVNjY2WFpa4vLykkajgVLqW2vTbiuKxX9QStFu98ZOTooopSiXy9eu7ft+33yFUgz0O63V8oHOuUCe53F2dkalUr1ehJVSKiHoFkZN0ySTyVAoFKjVavi+/79NAFxdXXXH+he66Tjs/P1jexXl76lbn+yvJUKnzB3otoVqtX8JU9gmRq3/APX8mDJfOACEAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-74",
    width: 55,
    height: 34,
    transform: "translate(80.29 206.15)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADcAAAAiCAYAAAD7wEFuAAAACXBIWXMAAAsSAAALEgHS3X78AAAD60lEQVRYR92ZzU5bRxTHf/deJLsNmA8XDIFQvgzlQwFsVJRSBBKiXpCKFW/AG6RrqzoiRIJFeALegAfwAgWxM6IJVUNWDSyAykGCCpCRk+vck4WxCRRCAAN2/9LRnTsae+Z3z19npBlDVbkriYhalollWViWhWn+t51IJDAMA9M0z3waholpGmxt/cO9e9/y5MlvRvr/jduCExGtqqokHo/j8XjweDwUFXl4+/ZvTNM8Mw4PDzOw50cBlmURi8XY3NzMzBcOh41bgRMRrampprq6BoCWlhaKiz2UlpZlvnI2tLOzo8vLy0SjUQAKLhh/LYlI5ss9evQTs7OzTE9PZxXoc3m9XmNgYEAdx+Hlyz9uzpYior29PwIG3d3dVFRU3BjUaUUiEY1Go5gXDbyKRER7enoA2NjYuFWwtEzTyL4tRUQDgW4Anj6dZHFx8dbBgFRRumjQZSQi2tn5EICpqak7AwNS28lFg75WIqIdHR0APH8+w8LCwp2BQRYzJyLa1tYKwIsXC8zPz98pGIBpZiFzIqItLS0ALC8vMzMzc+dgAJZ1zcyJiPr9TQCsrPzJ5ORkToDBNW0pIur1lgGwurrKxMREzoBBypZX2gpERNvb2yksLGRjYwMRySkwuKIt08WjsLCQ/f19xsfHcw4MrmBLEdHW1h8oKvJwcHDA2NhYToLBJW2ZrooeTzEul4tQKJSzYHAJW4qINjf7KSkpweVyMTg4mNNgkLLlhZlLl/vS0jJ8Ph9dXV05DwZfYUsR0aamRsrKvDQ2NtLU1JQXYJCy5blwIqINDQ14vd/R29tLSUlJ3oDBF2wpIlpfX0d5eTkDAwO43e68AoNzbCkiWlf3PRUVPkKhXwAj78DgDFuKiNbW1uLzVRIKhQDyEgxObeIiog8e1FBVVXWUsfwFg89smT56u3+/Ou8zBpBM2ic38erqmv8FGKSy9urVCpZpmtrZ+ZC+vp/zsiqepbW1td+3traOM5dv+9h5mpubyxzEmpWVPtzub740Pm+0tLSkwWDw+Dg9FntHLPaOQCCg5eXlt549v9+vIyMjDA0NMTw8jNvtJpFI4DgOjuOwv7/Hhw82yWSSZNLGtpOZ9t7eHh8/Orx/n8DlcgPw+vVfBALdPH78a+oiJBKJKKQuKOrr61FVA6CgoED7+/sJBoOMjo7S19cHQDweByB9FL+7u4uqEo/HUVVUFbfbzfr6emaRqfh46v16Ydt2Zr7m5mZ2d/9le3ubcDhswNEV1rNnkxoIBHnzZpW2tnZUncyPHEeP2sd9x/1n9Z3sP6tvZ2fn1EI1s6Bs6sRFiIhoZaUP207ZwLbto0jeyOQ3rU/bwAGp7UhYSAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "105.27 237.14 106.61 237.14 106.61 210.01 105.27 210.71 105.27 237.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-136",
    points: "106.3 236.59 106.61 236.59 106.61 210.51 106.3 210.71 106.3 236.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-137",
    points: "105.57 236.59 105.27 236.59 105.27 211.5 105.57 211.25 105.57 236.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M54,256.13c0,12.21,109.54,18.34,176.2,18.34s86.69-3.44,87.91-18.34c.72-8.77-12.69-23.91-79.34-23.91S54,240.76,54,256.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M58.5,256.17c0,11.23,101.48,16.91,164.43,16.91s83.05-3.24,84.16-16.91c.65-8.11-13.44-22-76.38-22S58.5,242.07,58.5,256.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M63.05,256.21c0,10.25,93.42,15.47,152.65,15.47s79.41-3,80.41-15.47c.59-7.44-14.17-20-73.4-20S63.05,243.37,63.05,256.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M67.59,256.25c0,9.26,85.37,14,140.88,14s75.78-2.81,76.67-14c.53-6.77-14.92-18.09-70.43-18.09S67.59,244.68,67.59,256.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M72.14,256.29c0,8.28,77.31,12.6,129.11,12.6s72.14-2.61,72.92-12.6c.46-6.1-15.67-16.15-67.47-16.15S72.14,246,72.14,256.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M76.69,256.32c0,7.31,69.25,11.17,117.33,11.17s68.51-2.4,69.18-11.17c.39-5.43-16.42-14.2-64.5-14.2S76.69,247.3,76.69,256.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M81.24,256.36c0,6.32,61.19,9.73,105.56,9.73s64.89-2.19,65.43-9.73c.34-4.76-17.17-12.26-61.54-12.26S81.24,248.6,81.24,256.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M85.79,256.4c0,5.34,53.13,8.3,93.78,8.3s61.26-2,61.69-8.3c.27-4.09-17.92-10.33-58.57-10.33S85.79,249.91,85.79,256.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M90.33,256.44c0,4.35,45.08,6.86,82,6.86s57.62-1.77,57.93-6.86c.21-3.42-18.66-8.39-55.6-8.39S90.33,251.22,90.33,256.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M94.88,256.47c0,3.38,37,5.43,70.24,5.43s54-1.56,54.19-5.43c.15-2.75-19.41-6.44-52.63-6.44S94.88,252.52,94.88,256.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M99.43,256.51c0,2.4,29,4,58.47,4s50.34-1.36,50.44-4c.08-2.08-20.16-4.5-49.66-4.5S99.43,253.83,99.43,256.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M104,256.55c0,1.41,20.9,2.56,46.69,2.56s46.7-1.15,46.7-2.56S176.46,254,150.67,254,104,255.14,104,256.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M90.19,225.12l.17,13.58a.64.64,0,0,1-.61.64L78.29,240a1.77,1.77,0,0,1-1.35-3l12.15-12.26A.64.64,0,0,1,90.19,225.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M90.39,223.44h5.38a.74.74,0,0,1,.74.74v9.62a.75.75,0,0,1-.75.75H87.69a3.87,3.87,0,0,1-3.87-3.87V230A6.57,6.57,0,0,1,90.39,223.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M95.76,234.44h-8A3.76,3.76,0,0,1,84,230.68V230a6.47,6.47,0,0,1,6.46-6.47h5.27a.73.73,0,0,1,.73.73v9.42A.73.73,0,0,1,95.76,234.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M95.75,234.32H87.88a3.64,3.64,0,0,1-3.64-3.64V230a6.35,6.35,0,0,1,6.35-6.36h5.16a.71.71,0,0,1,.71.71v9.22A.71.71,0,0,1,95.75,234.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M95.74,234.2H88a3.53,3.53,0,0,1-3.53-3.53v-.62a6.25,6.25,0,0,1,6.25-6.26h5a.7.7,0,0,1,.7.7v9A.69.69,0,0,1,95.74,234.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M95.73,234.09H88.07a3.42,3.42,0,0,1-3.42-3.42v-.61a6.14,6.14,0,0,1,6.14-6.15h4.94a.69.69,0,0,1,.69.68v8.81A.69.69,0,0,1,95.73,234.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M95.72,234H88.16a3.31,3.31,0,0,1-3.3-3.31v-.6a6,6,0,0,1,6-6h4.83a.67.67,0,0,1,.67.66v8.61A.67.67,0,0,1,95.72,234Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M95.71,233.85H88.26a3.19,3.19,0,0,1-3.2-3.19v-.59A5.94,5.94,0,0,1,91,224.14h4.72a.66.66,0,0,1,.66.65v8.41A.66.66,0,0,1,95.71,233.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M95.71,233.74H88.35a3.08,3.08,0,0,1-3.08-3.09v-.57a5.83,5.83,0,0,1,5.82-5.82h4.62a.63.63,0,0,1,.63.64v8.2A.64.64,0,0,1,95.71,233.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M95.7,233.62H88.45a3,3,0,0,1-3-3v-.56a5.72,5.72,0,0,1,5.72-5.71H95.7a.62.62,0,0,1,.62.62v8A.62.62,0,0,1,95.7,233.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M95.69,233.51H88.54a2.86,2.86,0,0,1-2.86-2.86v-.55a5.61,5.61,0,0,1,5.61-5.61h4.4a.6.6,0,0,1,.6.61v7.8A.61.61,0,0,1,95.69,233.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M95.68,233.39h-7a2.75,2.75,0,0,1-2.75-2.75v-.53a5.5,5.5,0,0,1,5.5-5.5h4.29a.59.59,0,0,1,.59.59v7.6A.59.59,0,0,1,95.68,233.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M95.67,233.27H88.73a2.64,2.64,0,0,1-2.64-2.63v-.52a5.4,5.4,0,0,1,5.4-5.4h4.18a.57.57,0,0,1,.57.58v7.4A.56.56,0,0,1,95.67,233.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M95.66,233.16H88.82a2.52,2.52,0,0,1-2.52-2.53v-.5a5.29,5.29,0,0,1,5.29-5.29h4.07a.56.56,0,0,1,.56.56v7.2A.56.56,0,0,1,95.66,233.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M95.65,233H88.92a2.41,2.41,0,0,1-2.41-2.41v-.49A5.18,5.18,0,0,1,91.69,225h4a.54.54,0,0,1,.54.54v7A.54.54,0,0,1,95.65,233Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M95.64,232.92H89a2.3,2.3,0,0,1-2.3-2.29v-.48a5.09,5.09,0,0,1,5.08-5.08h3.85a.53.53,0,0,1,.53.53v6.8A.52.52,0,0,1,95.64,232.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M95.63,232.81H89.11a2.19,2.19,0,0,1-2.19-2.19v-.46a5,5,0,0,1,5-5h3.74a.51.51,0,0,1,.51.51v6.6A.51.51,0,0,1,95.63,232.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M92,225.31h3.63a.5.5,0,0,1,.5.5v6.39a.49.49,0,0,1-.49.49H89.2a2.07,2.07,0,0,1-2.07-2.07v-.44A4.87,4.87,0,0,1,92,225.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M91,229.23c-3.31,2.24-6,2.83-6.58,2.05s-.55-3,2.33-6.26c1.54-1.74,8.38-1.75,8.94-1S93.67,227.44,91,229.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M91,229c-3.13,2.11-5.69,2.64-6.21,1.88S84.28,228,87,225c1.45-1.63,7.89-1.63,8.41-.87S93.48,227.3,91,229Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M90.93,228.74c-2.93,2-5.34,2.44-5.82,1.71s-.46-2.71,2.11-5.55c1.37-1.52,7.4-1.5,7.89-.77S93.29,227.17,90.93,228.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M90.89,228.49c-2.75,1.83-5,2.25-5.45,1.55s-.41-2.57,2-5.2c1.29-1.42,6.91-1.37,7.36-.68S93.1,227,90.89,228.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M90.85,228.25c-2.56,1.68-4.66,2.05-5.08,1.38s-.36-2.43,1.89-4.85c1.22-1.31,6.42-1.25,6.84-.58S92.91,226.9,90.85,228.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M90.8,228c-2.37,1.54-4.31,1.86-4.69,1.21s-.32-2.27,1.77-4.5c1.14-1.2,5.93-1.11,6.32-.47S92.71,226.77,90.8,228Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M90.76,227.76c-2.19,1.39-4,1.66-4.32,1s-.27-2.13,1.67-4.15c1-1.09,5.44-1,5.78-.37S92.52,226.63,90.76,227.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M90.71,227.51c-2,1.26-3.62,1.47-3.93.88s-.23-2,1.55-3.8c1-1,5-.86,5.26-.27S92.33,226.5,90.71,227.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M90.67,227.27c-1.81,1.11-3.28,1.27-3.56.71s-.18-1.85,1.44-3.45c.9-.88,4.46-.73,4.74-.17S92.14,226.36,90.67,227.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M90.63,227c-1.62,1-2.94,1.08-3.19.54s-.13-1.7,1.33-3.09c.82-.78,4-.61,4.22-.07S92,226.23,90.63,227Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M90.58,226.78c-1.43.83-2.59.88-2.8.37s-.09-1.56,1.21-2.74c.74-.67,3.48-.48,3.69,0S91.76,226.1,90.58,226.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M90.54,226.53c-1.25.69-2.26.69-2.43.21s0-1.41,1.1-2.39c.67-.57,3-.35,3.17.13S91.57,226,90.54,226.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M90.5,226.29c-1.06.55-1.92.49-2.06,0s0-1.27,1-2c.58-.46,2.5-.23,2.64.23S91.38,225.83,90.5,226.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M90.45,226c-.87.41-1.57.3-1.67-.13a1.67,1.67,0,0,1,.88-1.68c.51-.36,2-.1,2.11.33S91.19,225.7,90.45,226Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M90.41,225.8c-.68.27-1.23.1-1.3-.3a1.32,1.32,0,0,1,.77-1.33c.44-.25,1.52,0,1.59.43S91,225.56,90.41,225.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M90.37,225.55c-.49.13-.89-.09-.92-.46a1,1,0,0,1,.65-1c.37-.14,1,.15,1.07.53A1,1,0,0,1,90.37,225.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M90.87,224.68a.6.6,0,0,1-.55.63.59.59,0,0,1-.54-.63.59.59,0,0,1,.54-.63A.6.6,0,0,1,90.87,224.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M130,249.7a3,3,0,1,1-3-2.95A3,3,0,0,1,130,249.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M133.12,250.73H121.81a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1h11.31a1,1,0,0,1,1,1h0A1,1,0,0,1,133.12,250.73Z"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-74",
    width: 74,
    height: 37,
    transform: "translate(151.29 205.15)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAAAlCAYAAADlcn/+AAAACXBIWXMAAAsSAAALEgHS3X78AAAC0ElEQVRoQ+2au04bQRRAz8yObSAOfki4pyAVoiMNPwAfQAQRcT6CVERakaUJoQk9JQ5fkPRIyCjwCcglIRTgByEOuytPCnuNX+AlSYGycxpfzdzrx9Gd0cg7QmtNL47j6PHxpyilkFKSzWYBEEIAAiGCeNDYv5mv1+vtuMlD47B5t3GpVKJSqbC29rbrXQBEpyjHcXQspojFYiilSKVSTE9Pc3lZbiY/4EN7YwjqO+PBNZ2S7hLZfO2M/37++PiYSqWCUgrLslhdfXP7zQJRQRcJIcjlciwuvkAp1Wf2f0YIoY+OvlIsFqlWawDYti0AZG9yPv+a5eWXImqSALTWYnb2uchksiwszGNZks3N9xpaohzH0QBzc3NkMpnICeoln8+LqalnJJNJbm5coKOjMpk0S0vLdxZHjXQ6LWZmZkgmn+A4jpaO4+h4PMbKyitKpVLku6mT9fV3WJaFlKLZUaOjo1xcXAyrixz7+/tCKUWjoW+XXnCuMXQTj8eB1h6ltTaihmBEhcSIConZo0JiOiokRlRIzNILSbujDPdjll5IZCLRPHkaUYNpNBpAq6MSiYQRNQQZ7E9G1P0YUUMIvJjjQUikORqEoy2qVqsNSY02pqNC0ve4ytBNezM3HRUOqTV4nsfk5OSw3Egjodlep6enw3Ijiet2PAC9vv7J+fn3ewuiSLlc1r7vAyBt2xap1DgHBweUy2WzYbWYmJjQhcJu+7KGBKhWa1xd/aBQ2GVnZ8fIAr58+dy+7mTbtpBBMDKSQEqJ1g3Ozr5FVpbv+3pv75MuFoukUuPtaz9dF8m2tz92CcrlcszPL5BMJoFB/4RqeocGHTfC1AVjlmX1TvTlDOfhea7rcnJywuFhEd/38TwP1/UGiwrY2vqg6/VfAMRiirGxsb6ccELuHn9sucFv7L1AFjBQVMDGhqO1bsrq5U8Oqo+5RimF5/l9ggJ+A73oR4LH1SbdAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-74",
    width: 64,
    height: 26,
    transform: "translate(156.29 210.15)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAAaCAYAAAAHfFpPAAAACXBIWXMAAAsSAAALEgHS3X78AAAB4klEQVRYR+2YsW7iQBCGvyECp6Jx3FucoKBDQqIwRWjOLwHPkHsFv8BBKr8KJQXu6GiQKKho3CBR254rDDbWRTHJXWXzSyPv7/1nVzs7s1qtqCpXiIg6jsP7+wLTNFEFVSXV6N08bZfxf/Et8mazVRin+M3br68TLMsiDEPJ1nwNgIgowHa75Xg88vxsXBxvkf/4P31F4Xf6Wq1WaYDyIMBsNsM0TUzTZL1ey0WEAup5nnqep9edqaL5vq+n00mbzaaqZlFCwzDUMueq2HK5VNu21XEcbYiIGoaB7/vUBa7rymq1Yjgc0gAYDAY8PTXK/CqF3W5HEARpAKIoKtNXEpvNJg1AHMfEcVKmrxRs2waobwYkSbrhtQ1AHMcAeQnUDVkGdDqdEmk1kSSXDIiiCMuySuTVw/XQb9Sx/uEmA+pY//DIgOIZUEc8MqDuZ0B2D6hrBjxKILm5CgdB8Km4iuh0fgDQUFVxHAfX/VniUh3M57+12+2mRFXp9/vabrcr/yB6tcPhoOnSNX8WH4/HGoYh0+kUAMlezkFuSQn/ihbkC/N8XwvC+XxmNBoxmUwwDAMAVZUsAAC9Xk/3+z2LxTwbUEQy+5unE93L79F8zO/RfOyTt4WXF5O3t18EQYCqCsAfAfFoTp1iUesAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-74",
    width: 74,
    height: 37,
    transform: "translate(236.29 205.15)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAAAlCAYAAADlcn/+AAAACXBIWXMAAAsSAAALEgHS3X78AAACqklEQVRoQ+2aMU/bQBTH/8/xhci4JAIpEqxQZaPpQPkMdKIj/Q50oHSgQwaXrXyNJkOZ+BQEFnbERgVDUhSK7NhX6XUIduzEsY909P2WnN69dzn99f6+yDliZsRxHIer1SVYlgXbfgUigIgAhJ+UExuN/yfmeV5sHhnjrLmX593c3KDX60MIE0dHX5PVoVCO43C5LCCEgGmaqNfrWF5eVvoCIBQtPy+vJi5SnqB581kxwzCm9nB1dQXXdTEYPIabQqvVIgAwgZFItr2IUqmERqOB29tf2Nv7mFC0CGxtvcPDwwN3Om0Mh0OUSqVojpg5Emp//xOEEIUTKI3T0598fX0NIQQOD7+Q4TgOA8Dq6qoWKcbGxmtYlgXX9QA8W69aXcLOzvvMwqLRbDbJ81zudrtwHIeN8ISr1Wq6mybY3HyD8HQ3cnILzd3dHYDRqWhM/o7SpGMwM7RY2RCRtp4KRKStp4oWSgFtPUUi6+muSse27WisrZdBqI22niL61MuBmeH7PgBtvUyYGUQE3w9G1tNipRPXRXdUBmFHAc9CxV95asYkhMrJLTTaei9Ad5QCuqMUmXqYa9LRD3NFtPUUSXRUuVyGlDKnRGNUKhVIKbG+vq5ba4KVlZXIfkbYTefn51k1haTTaY+t57oeBoNHtNs/4Hme7qpn7u/vudfrYzB4RKvVImJmnJx85yAIUKvVsLv7AWtra4X9e52I+OKii8vLS/R6/eh+VOIimRAmhBCoVCrY3t5Gs/l2YhmG6iGpfpqqrqmaB6jnjvOCIMDT0x+cnZ2h3/8NALDtRRwcfE4KBYyvJUopIaWEZVnTS8/YQVp8FEqLq68xK/6S3FnxeMyyLPi+j4WFhchu8VyatfDx8TdOe/2i3ilJ5qmbpwaYr840TUj5d0qgkH+31Fry1OMkeQAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-74",
    width: 64,
    height: 26,
    transform: "translate(241.29 210.15)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAAaCAYAAAAHfFpPAAAACXBIWXMAAAsSAAALEgHS3X78AAACAUlEQVRYR+1ZMW7iQBR93zOGXIAaS5bMEUA2ElmJAomCmlNwBlBSb6iXFEmzoaah3EhwhqwEEtBkJSO7oMsK629hGGMlikl2q/E+aeR5nvfH8ps/tvxNzIwjiIg9z8P19RXK5TKYAWZGrOGzedzP4n8Tm+amWUjNkz4m/cvLLyiVSvB9n9Q9MzOIiHu9HobDITabNZ6efuLiongIPEVy4t+MpYWfGSsUCpkGHblt23BdF47jYDab0WHi2J4wDPn+/o6Pq6Jj6/f7/Pj4g03TZMuymJmVnTydTjlrAl3adrtVBkgAWK1WsCxL7QvdcXs7QqfTARGxUavVsFgssmK0wsvLb8zncwCAsd/vIYSREaIfisUihBAwoiiCYYgsvZYQQuQ3AwBAShkbYBg5NiDPW0BlQF63gHoG/M+AnGZA7p8BuX4NBkFw+hrMXwZIKbFcLvObAULEi25EUZQh1RNSSgCHj6H1epMh1w8pA/IGohMDPM9DpVLJCNELtm0n9QAAaLfbGI2+vSpl6grX9QAAzEzGsTr6/PwLg8FAexMeHr5zt9tVnJgZ9Xqdfd/HeDzGZDKJB04qhETpcuF7/CNagD5wnc9rAcJut0O1WkWr1VJnmZmIOV50x3E4CAKEYYibm69qQiJS7TWPL3QuP0fzNj9H83ZM0ic0Gg00m83knwCAP+ARo2ni9eR7AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 60.94,
    y: 257.24,
    width: 6.18,
    height: 3.24,
    rx: 0.63,
    transform: "translate(128.05 517.72) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 61.01,
    y: 257.28,
    width: 6.01,
    height: 3.13,
    rx: 0.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: 61.09,
    y: 257.31,
    width: 5.85,
    height: 3.02,
    rx: 0.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-185",
    x: 61.16,
    y: 257.35,
    width: 5.68,
    height: 2.91,
    rx: 0.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 61.23,
    y: 257.38,
    width: 5.52,
    height: 2.8,
    rx: 0.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-187",
    x: 61.3,
    y: 257.42,
    width: 5.35,
    height: 2.69,
    rx: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-188",
    x: 61.38,
    y: 257.45,
    width: 5.19,
    height: 2.58,
    rx: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-189",
    x: 61.45,
    y: 257.49,
    width: 5.02,
    height: 2.47,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-190",
    x: 61.52,
    y: 257.52,
    width: 4.86,
    height: 2.36,
    rx: 0.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 61.59,
    y: 257.56,
    width: 4.69,
    height: 2.25,
    rx: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-192",
    x: 61.67,
    y: 257.59,
    width: 4.53,
    height: 2.14,
    rx: 0.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 61.74,
    y: 257.63,
    width: 4.36,
    height: 2.03,
    rx: 0.42,
    transform: "translate(127.84 517.29) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-194",
    x: 61.27,
    y: 257.33,
    width: 5.64,
    height: 2.71,
    rx: 0.55,
    transform: "translate(128.19 517.38) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-195",
    x: 61.29,
    y: 257.34,
    width: 5.61,
    height: 2.63,
    rx: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 61.31,
    y: 257.35,
    width: 5.57,
    height: 2.55,
    rx: 0.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 61.32,
    y: 257.35,
    width: 5.54,
    height: 2.46,
    rx: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 61.34,
    y: 257.36,
    width: 5.5,
    height: 2.38,
    rx: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-199",
    x: 61.36,
    y: 257.37,
    width: 5.47,
    height: 2.3,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 61.38,
    y: 257.37,
    width: 5.43,
    height: 2.22,
    rx: 0.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 61.39,
    y: 257.38,
    width: 5.4,
    height: 2.14,
    rx: 0.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-202",
    x: 61.41,
    y: 257.39,
    width: 5.37,
    height: 2.05,
    rx: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-203",
    x: 61.43,
    y: 257.4,
    width: 5.33,
    height: 1.97,
    rx: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-204",
    x: 61.44,
    y: 257.4,
    width: 5.3,
    height: 1.89,
    rx: 0.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-205",
    x: 61.46,
    y: 257.41,
    width: 5.26,
    height: 1.81,
    rx: 0.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 61.48,
    y: 257.42,
    width: 5.23,
    height: 1.73,
    rx: 0.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 61.5,
    y: 257.42,
    width: 5.19,
    height: 1.64,
    rx: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-208",
    x: 61.51,
    y: 257.43,
    width: 5.16,
    height: 1.56,
    rx: 0.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 61.53,
    y: 257.44,
    width: 5.12,
    height: 1.48,
    rx: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-210",
    x: 61.55,
    y: 257.44,
    width: 5.09,
    height: 1.4,
    rx: 0.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    x: 61.56,
    y: 257.45,
    width: 5.06,
    height: 1.32,
    rx: 0.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-212",
    x: 61.58,
    y: 257.46,
    width: 5.02,
    height: 1.23,
    rx: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M61.93,257.46h4.32a.33.33,0,0,1,.33.33v.48a.33.33,0,0,1-.33.33H61.93a.34.34,0,0,1-.34-.34v-.48A.33.33,0,0,1,61.93,257.46Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-214",
    x: 61.62,
    y: 257.47,
    width: 4.95,
    height: 1.07,
    rx: 0.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-215",
    x: 61.63,
    y: 257.48,
    width: 4.92,
    height: 0.99,
    rx: 0.31,
    transform: "translate(128.19 515.94) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M66.47,257.8a20.14,20.14,0,0,1-4.76.17c-.19-.22-.13-.46.45-.49S66.5,257.47,66.47,257.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "M332.8,201a.47.47,0,0,0-.47-.47H111.66c-4.33,0-5,.27-5.46.74l2.77.86H332.33a.47.47,0,0,0,.47-.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-218",
    points: "101.24 202.49 105.06 202.49 71.14 237.35 66.01 237.52 101.24 202.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "100.29 203.41 102.58 201.13 106.4 201.13 71.14 237.35 70.61 237.37 103.69 203.53 100.29 203.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-219",
    points: "230.92 297.03 230.92 182.34 230.15 182.34 230.15 297.01 230.92 297.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-220",
    points: "231.68 296.99 231.68 182.34 230.92 182.34 230.92 297.03 231.68 296.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "145.52 297.3 145.52 182.85 144.75 182.91 144.75 297.33 145.52 297.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "146.29 297.33 146.29 182.8 145.52 182.85 145.52 297.3 146.29 297.33"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-223",
    x: 260.47,
    y: 239.16,
    width: 114.4,
    height: 0.77,
    transform: "translate(78.14 557.21) rotate(-90)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-224",
    points: "318.82 296.36 318.82 182.34 318.06 182.34 318.06 296.74 318.82 296.36"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-225",
    cx: 180.89,
    cy: 129.76,
    rx: 180.89,
    ry: 12.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "M266.37,129.19c0,3.31,10.15,6,22.67,6s22.68-2.68,22.68-6-10.16-6-22.68-6S266.37,125.89,266.37,129.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-227",
    d: "M256.17,122.15c0,3.3,10.15,6,22.67,6s22.68-2.68,22.68-6-10.16-6-22.68-6S256.17,118.84,256.17,122.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M76.66,129.45c0,3.3,10.15,6,22.67,6s22.68-2.68,22.68-6-10.15-6-22.68-6S76.66,126.15,76.66,129.45Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-229",
    cx: 107.9,
    cy: 125.05,
    rx: 22.67,
    ry: 5.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-230",
    d: "M281.76,90.66a17.78,17.78,0,1,0,17.77,17.78A17.78,17.78,0,0,0,281.76,90.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M297.46,106.73l2.35-.27-.41-2.33-2.32.55c-.05-.22-.1-.44-.16-.65l2.27-.67-.81-2.23-2.18.94c-.09-.2-.19-.4-.29-.6l2.13-1.06-1.18-2-2,1.3c-.12-.19-.26-.36-.4-.55l1.92-1.41-1.52-1.81-1.73,1.63-.48-.48,1.64-1.72L292.5,93.8l-1.42,1.91-.55-.4,1.31-2-2-1.19-1.07,2.13-.6-.29.95-2.17L286.84,91l-.68,2.27-.65-.17.56-2.31-2.33-.41-.28,2.35-.66,0,.14-2.38h-2.37l.15,2.38-.67,0-.28-2.35-2.33.41.56,2.31-.65.17L276.67,91l-2.23.81.95,2.17-.6.29-1.07-2.13-2.05,1.19,1.31,2-.55.4L271,93.8l-1.81,1.52L270.84,97l-.48.48-1.73-1.63-1.52,1.81L269,99.11c-.14.19-.28.36-.4.55l-2-1.3-1.18,2,2.13,1.06c-.1.2-.2.4-.29.6l-2.18-.94-.81,2.23,2.28.67c-.07.21-.12.43-.17.65l-2.32-.55-.41,2.33,2.35.27c0,.22,0,.44,0,.67l-2.38-.14v2.37l2.38-.15c0,.22,0,.45,0,.67l-2.35.27.41,2.34,2.32-.56c.05.22.1.43.16.65l-2.27.68.81,2.22,2.17-.94c.09.2.2.4.29.6l-2.12,1.07,1.18,2,2-1.31c.13.19.27.36.4.54l-1.91,1.43,1.52,1.81,1.73-1.64.47.48-1.63,1.73,1.81,1.52,1.42-1.92c.18.13.35.28.54.4l-1.3,2,2.05,1.18,1.06-2.13.6.29-.94,2.18,2.23.81.67-2.28.65.17-.55,2.32,2.33.41.27-2.36c.22,0,.45,0,.68,0l-.15,2.38h2.37l-.14-2.38c.22,0,.45,0,.67,0l.27,2.36,2.33-.41-.55-2.32.65-.17.67,2.28,2.23-.81-.94-2.18.6-.29,1.06,2.13,2-1.18-1.3-2c.19-.12.36-.27.54-.4l1.42,1.92,1.81-1.52-1.63-1.73.47-.48,1.73,1.64,1.52-1.81-1.91-1.43c.13-.18.27-.35.4-.54l2,1.31,1.18-2-2.12-1.07c.09-.2.2-.4.29-.6l2.17.94.81-2.22-2.27-.68c.06-.22.11-.43.16-.65l2.32.56.41-2.34-2.35-.27c0-.22,0-.45,0-.67l2.38.15v-2.37l-2.38.14C297.48,107.17,297.48,107,297.46,106.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M281.76,95.85a12.6,12.6,0,1,0,12.59,12.59A12.6,12.6,0,0,0,281.76,95.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M261.39,111.4l1.29,2.49a4.33,4.33,0,0,0,4.16,2.33l47.73-3.56L308.75,88.2l-37.14-3.82Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-234",
    cx: 288.52,
    cy: 112.03,
    r: 18.5,
    transform: "translate(-20.12 135.11) rotate(-25.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "M304.18,115.84l2.36.57L307,114l-2.41-.28c0-.23,0-.46.06-.69l2.42.15v-2.42l-2.42.15c0-.23,0-.46-.07-.68L307,110l-.43-2.38-2.35.56c-.05-.22-.13-.44-.19-.66l2.33-.69-.83-2.27-2.23,1c-.09-.21-.19-.42-.29-.62l2.18-1.09-1.21-2.09-2,1.34c-.13-.19-.25-.39-.39-.57l1.95-1.44-1.56-1.85-1.76,1.67-.48-.49,1.66-1.76-1.85-1.55L298,99l-.56-.39,1.34-2-2.1-1.21-1.08,2.16c-.2-.1-.41-.18-.62-.27l1-2.23-2.27-.83L293,96.56c-.21-.07-.43-.14-.65-.19L292.9,94l-2.38-.42L290.25,96l-.68-.07.14-2.42h-2.42l.15,2.41-.68.07-.28-2.41L284.1,94l.57,2.35-.66.19-.7-2.32-2.27.82,1,2.23-.62.29-1.09-2.17-2.09,1.21,1.34,2c-.19.12-.38.24-.57.38l-1.44-1.94-1.85,1.56,1.67,1.76c-.16.15-.33.31-.49.48l-1.76-1.66-1.55,1.85,1.95,1.44-.39.56-2-1.33-1.2,2.09,2.16,1.08c-.1.2-.18.42-.27.63l-2.24-1-.82,2.28,2.33.68c-.06.22-.13.44-.19.66l-2.35-.55-.42,2.38,2.42.27c0,.22-.05.45-.07.68l-2.42-.14v2.42l2.42-.16c0,.23,0,.46.07.69l-2.41.28.42,2.38,2.35-.57c.05.22.13.44.19.66l-2.33.7.83,2.27,2.22-1c.1.21.19.41.3.62l-2.17,1.09,1.21,2.09,2-1.35c.13.19.25.39.38.57L273.59,123l1.55,1.85,1.76-1.68.48.49-1.66,1.77,1.85,1.55L279,125l.57.38-1.34,2,2.1,1.2,1.07-2.17.64.28-1,2.24,2.27.82.7-2.33.66.19-.57,2.35,2.38.42.28-2.42.68.07-.14,2.42h2.41l-.14-2.41.68-.07.28,2.41L293,130l-.56-2.35.65-.2.7,2.34L296,129l-1-2.23.62-.29,1.09,2.17,2.09-1.21-1.34-2,.57-.38,1.44,1.94,1.84-1.56-1.67-1.76c.17-.16.34-.31.5-.48l1.75,1.67,1.55-1.86-1.94-1.44c.13-.19.26-.38.38-.57l2,1.34,1.21-2.09L303,119.13c.1-.21.19-.42.28-.63l2.23,1,.83-2.27-2.34-.7C304.06,116.28,304.13,116.06,304.18,115.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "M292.79,100.27a12.51,12.51,0,1,0,7.49,16A12.52,12.52,0,0,0,292.79,100.27Zm-8,22a10.84,10.84,0,1,1,13.88-6.5A10.86,10.86,0,0,1,284.83,122.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-237",
    d: "M300.79,115.66l.1.06.1-.82s0-.06,0-.08a12.56,12.56,0,0,0,.19-4.31.13.13,0,0,1,0-.06l-.07-1.35-.17.08a12.76,12.76,0,0,0-5.25-7.6,2.23,2.23,0,0,1,.21-.19l-3-1.4h0l-3.21-.85s0,.11,0,.31a12.74,12.74,0,0,0-8.85,2.56l-.14-.3-2.25,2.44h0l-1.8,2.8.27,0c-.11.26-.22.52-.32.8a12.64,12.64,0,0,0-.08,8.43l-.19,0,.69,1.24,0,0a12.71,12.71,0,0,0,.9,1.61h0l0,0A12.28,12.28,0,0,0,279.5,121l.05.06.5.62.06-.1a12.58,12.58,0,0,0,8.71,3.22l0,.06.27-.05.13,0a12.7,12.7,0,0,0,5.59-1.62l.12,0,.26-.1,0,0a12.67,12.67,0,0,0,5.4-6.56C300.63,116.2,300.71,115.93,300.79,115.66Zm-.49-7.2a1,1,0,0,1-.63,1.22,12.33,12.33,0,0,1-3.22.64c-.6,0-1.34.07-2.11.1a2.31,2.31,0,0,1-2.19-3.23c.31-.72.62-1.39.88-1.94a13.19,13.19,0,0,1,1.74-2.69,1,1,0,0,1,1.36-.14A12.38,12.38,0,0,1,300.3,108.46Zm-11.49-8.63a1,1,0,0,1,1,1,13,13,0,0,1-.39,3.13c-.15.59-.35,1.3-.56,2a2.31,2.31,0,0,1-3.75,1.08c-.58-.52-1.13-1-1.57-1.43a13,13,0,0,1-2-2.43,1,1,0,0,1,.29-1.35A12.28,12.28,0,0,1,288.81,99.83Zm-11.8,8.1h0a1,1,0,0,1,1.22-.59,13,13,0,0,1,2.91,1.35c.51.33,1.13.73,1.77,1.17a2.31,2.31,0,0,1-.13,3.9c-.67.39-1.32.76-1.85,1a13.18,13.18,0,0,1-3.06,1.17,1,1,0,0,1-1.19-.71A12.21,12.21,0,0,1,277,107.93Zm7.37,15.76a12.19,12.19,0,0,1-3.36-1.86,1,1,0,0,1-.2-1.35A13.05,13.05,0,0,1,283.1,118c.47-.39,1-.85,1.66-1.32a2.3,2.3,0,0,1,3.66,1.33c.17.76.32,1.48.43,2.08a13,13,0,0,1,.16,3.42,1,1,0,0,1-1,.9A12.38,12.38,0,0,1,284.38,123.69Zm8.19-4.68c-.23-.56-.48-1.25-.75-2a2.31,2.31,0,0,1,2.41-3.08c.77.08,1.5.16,2.1.24a12.49,12.49,0,0,1,3.25.89,1,1,0,0,1,.56,1.23h0a12.26,12.26,0,0,1-4.52,5.89,1,1,0,0,1-1.35-.21A12.74,12.74,0,0,1,292.57,119Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M293.63,99.25a13.76,13.76,0,1,0,8,17A13.76,13.76,0,0,0,293.63,99.25Zm7.21,10.62a.75.75,0,0,1-.55.84,32.42,32.42,0,0,1-7.43.7l-1.75,0a1.3,1.3,0,0,1-1.18-1.75c.24-.66.48-1.29.62-1.62a33.16,33.16,0,0,1,3.35-6.55.74.74,0,0,1,1-.21A12.56,12.56,0,0,1,300.84,109.87Zm-12.36,2Zm1.9-12.24a.73.73,0,0,1,.62.78,33.28,33.28,0,0,1-1.63,7.14c-.1.35-.33,1-.56,1.65a1.3,1.3,0,0,1-2,.59l-1.36-1.09a33.74,33.74,0,0,1-5.17-5.19.73.73,0,0,1,.11-1A12.55,12.55,0,0,1,290.38,99.66Zm-13.62,8.1a12.13,12.13,0,0,1,.65-1.47.73.73,0,0,1,.93-.34,33.59,33.59,0,0,1,6.32,3.76l1.39,1.05a1.31,1.31,0,0,1-.07,2.12c-.59.39-1.15.76-1.45.94a33,33,0,0,1-6.67,3.37.75.75,0,0,1-.91-.42A12.48,12.48,0,0,1,276.76,107.76Zm2.87,13.06a.72.72,0,0,1,0-1,31.77,31.77,0,0,1,5.64-5c.29-.22.84-.6,1.43-1a1.29,1.29,0,0,1,2,.72c.19.68.37,1.32.46,1.67a32.22,32.22,0,0,1,1.13,7.51.73.73,0,0,1-.67.73,12.45,12.45,0,0,1-9.93-3.67Zm14.65,2.3a.74.74,0,0,1-1-.26,32.29,32.29,0,0,1-3-7c-.12-.34-.32-1-.52-1.67a1.3,1.3,0,0,1,1.3-1.67c.71,0,1.38.06,1.74.09a32,32,0,0,1,7.42,1.22.72.72,0,0,1,.49.84,11.18,11.18,0,0,1-.45,1.57A12.43,12.43,0,0,1,294.28,123.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M286.47,114.65a1,1,0,1,1,.62,1.33A1,1,0,0,1,286.47,114.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-240",
    d: "M287.69,114.33a.72.72,0,0,1,.43.92.73.73,0,0,1-.92.43.72.72,0,0,1-.43-.92A.71.71,0,0,1,287.69,114.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "M290.46,114.77a1,1,0,1,1,1.46-.18A1,1,0,0,1,290.46,114.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-242",
    d: "M290.53,113.51a.72.72,0,0,1,1-.13.73.73,0,0,1,.13,1,.72.72,0,0,1-1.14-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-243",
    d: "M291.81,111a1,1,0,0,1-1.44-.27,1,1,0,1,1,1.72-1.17A1,1,0,0,1,291.81,111Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-244",
    d: "M290.63,110.55a.72.72,0,0,1,.2-1,.71.71,0,0,1,1,.19.72.72,0,0,1-.19,1A.73.73,0,0,1,290.63,110.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-245",
    d: "M288.65,108.56a1,1,0,1,1-1.29-.71A1,1,0,0,1,288.65,108.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M287.85,109.54a.72.72,0,0,1-.89-.5.71.71,0,0,1,.49-.88.72.72,0,1,1,.4,1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-247",
    d: "M285.35,110.81a1,1,0,1,1-1.08,1A1,1,0,0,1,285.35,110.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "M286,111.87a.72.72,0,1,1-.7-.74A.73.73,0,0,1,286,111.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-249",
    d: "M289.9,112.41a1.44,1.44,0,1,1-.86-1.84A1.44,1.44,0,0,1,289.9,112.41Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-250",
    x: 262.47,
    y: 89.85,
    width: 49.29,
    height: 18.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-251",
    cx: 101.9,
    cy: 108.14,
    r: 17.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "M117.6,106.43l2.35-.27-.41-2.33-2.32.55c0-.22-.1-.44-.16-.65l2.27-.68-.81-2.22-2.17.94-.3-.61,2.13-1.06-1.18-2-2,1.31c-.12-.19-.26-.37-.4-.55l1.92-1.41L115,95.58l-1.73,1.64-.48-.48L114.45,95l-1.81-1.52-1.42,1.91c-.18-.14-.36-.28-.54-.4l1.3-2-2-1.19L108.87,94l-.61-.29.95-2.18L107,90.7,106.3,93l-.65-.17.56-2.31-2.33-.41-.28,2.35-.66,0,.14-2.38h-2.37l.15,2.38-.67,0-.27-2.35-2.34.41.56,2.31-.65.17-.68-2.28-2.22.81.94,2.18-.6.29-1.07-2.13-2,1.19,1.31,2c-.19.12-.36.26-.54.4L91.15,93.5,89.34,95,91,96.74c-.16.16-.32.31-.48.48l-1.73-1.64L87.25,97.4l1.92,1.41c-.13.18-.28.36-.4.55l-2-1.31-1.18,2,2.13,1.06c-.1.2-.2.4-.29.61l-2.18-.94-.81,2.22,2.28.68c-.07.21-.12.43-.17.65l-2.32-.55-.41,2.33,2.36.27c0,.22,0,.44,0,.67L83.77,107v2.37l2.38-.15c0,.22,0,.45,0,.67l-2.36.27.41,2.33,2.32-.55c.05.21.1.43.16.65l-2.27.68.81,2.22,2.17-1c.09.21.2.41.3.61l-2.13,1.07,1.18,2,2-1.31c.13.19.27.36.4.54l-1.91,1.42,1.52,1.82,1.73-1.64.47.48-1.63,1.72,1.81,1.53,1.42-1.92c.18.13.35.27.54.4l-1.3,2,2,1.18,1.06-2.13.61.29-.94,2.18,2.22.81.67-2.28.65.17-.55,2.32,2.34.41.26-2.36c.23,0,.45,0,.68,0l-.15,2.38h2.37l-.14-2.38c.23,0,.45,0,.67,0l.27,2.36,2.33-.41-.55-2.32.65-.17.67,2.28,2.23-.81-.94-2.18.6-.29,1.06,2.13,2-1.18-1.3-2c.19-.13.36-.27.54-.4l1.42,1.92,1.81-1.53-1.63-1.72.48-.48L115,120.7l1.52-1.82-1.91-1.42c.13-.18.27-.35.4-.54l2,1.31,1.18-2-2.12-1.07c.1-.2.2-.4.29-.61l2.17,1,.81-2.22-2.27-.68c.06-.22.11-.44.17-.65l2.31.55.41-2.33-2.35-.27c0-.22,0-.45,0-.67l2.38.15V107l-2.38.14C117.63,106.87,117.62,106.65,117.6,106.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-253",
    d: "M101.9,95.55a12.59,12.59,0,1,0,12.59,12.59A12.6,12.6,0,0,0,101.9,95.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "M66,110.27l1.28,2.48a4.34,4.34,0,0,0,4.17,2.33l47.72-3.55-5.82-24.47L76.21,83.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M102,94.63a18.5,18.5,0,1,0,11.09,23.7A18.5,18.5,0,0,0,102,94.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-256",
    d: "M111.32,115.84l2.35.57.42-2.38-2.42-.28c0-.23,0-.46.07-.69l2.42.15v-2.42l-2.42.15c0-.23,0-.46-.07-.68l2.41-.28-.42-2.38-2.35.56c-.06-.22-.13-.44-.19-.66l2.33-.69-.83-2.27-2.23,1c-.09-.21-.19-.42-.29-.62l2.17-1.09-1.21-2.09-2,1.34c-.13-.19-.24-.39-.38-.57l1.94-1.44L109,99.19l-1.77,1.67c-.16-.16-.31-.33-.48-.49l1.67-1.76-1.86-1.55-1.44,2-.57-.39,1.34-2-2.09-1.21-1.08,2.16c-.2-.1-.42-.18-.62-.27l1-2.23-2.27-.83-.69,2.34c-.22-.07-.44-.14-.66-.19L100,94l-2.38-.42L97.39,96l-.69-.07.14-2.42H94.43l.15,2.41L93.9,96l-.29-2.41L91.23,94l.57,2.35-.66.19-.7-2.32-2.27.82,1,2.23-.62.29-1.1-2.17-2.09,1.21,1.35,2c-.19.12-.39.24-.57.38l-1.45-1.94-1.85,1.56,1.68,1.76c-.16.15-.33.31-.49.48l-1.76-1.66-1.55,1.85,2,1.44c-.14.18-.26.37-.39.56l-2-1.33L79,103.84l2.17,1.08c-.1.2-.18.42-.28.63l-2.23-1-.83,2.28,2.34.68c-.06.22-.14.44-.19.66l-2.36-.55L77.23,110l2.41.27c0,.22,0,.45-.06.68l-2.42-.14v2.42l2.42-.16c0,.23,0,.46.07.69l-2.42.28.42,2.38,2.35-.57c.06.22.13.44.2.66l-2.33.7.83,2.27,2.22-1c.09.21.19.41.29.62L79,120.25l1.21,2.09,2-1.35c.13.19.24.39.38.57L80.72,123l1.56,1.85L84,123.18c.16.17.31.33.48.49l-1.66,1.77L84.71,127,86.15,125l.56.38-1.33,2,2.09,1.2,1.08-2.17.64.28-1,2.23,2.27.83.69-2.33.66.19L91.28,130l2.38.42.28-2.42.68.07-.15,2.42h2.42l-.15-2.41.69-.07.27,2.41,2.38-.42-.56-2.35.66-.2.69,2.34,2.27-.83-1-2.23.62-.29,1.08,2.17,2.09-1.21-1.34-2c.19-.13.39-.25.57-.38l1.44,1.94,1.85-1.56-1.67-1.76c.17-.16.33-.31.49-.48l1.76,1.67,1.55-1.86-2-1.44c.14-.19.26-.38.39-.57l2,1.34,1.2-2.09-2.16-1.08c.1-.21.18-.42.27-.63l2.24,1,.82-2.27-2.33-.7C111.19,116.28,111.27,116.06,111.32,115.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-257",
    d: "M99.92,100.27a12.51,12.51,0,1,0,7.5,16A12.51,12.51,0,0,0,99.92,100.27Zm-8,22a10.84,10.84,0,1,1,13.89-6.5A10.87,10.87,0,0,1,92,122.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-258",
    d: "M107.93,115.66l.1.06.1-.82a.19.19,0,0,1,0-.08,12.55,12.55,0,0,0,.18-4.31v-.06l-.08-1.35-.16.08a12.74,12.74,0,0,0-5.26-7.6l.21-.19-3-1.4h0l-3.22-.85s0,.11,0,.31A12.73,12.73,0,0,0,88,102l-.14-.3-2.26,2.44h0l-1.81,2.8.28,0c-.12.26-.23.52-.33.8a12.64,12.64,0,0,0-.07,8.43l-.2,0,.7,1.24a.17.17,0,0,1,0,0,15.79,15.79,0,0,0,.9,1.61h0l0,0a12.21,12.21,0,0,0,1.5,1.86l.06.06.5.62,0-.1A12.62,12.62,0,0,0,96,124.84v.06l.26-.05.13,0a12.74,12.74,0,0,0,5.6-1.62l.11,0,.26-.1,0,0a12.69,12.69,0,0,0,5.41-6.56C107.76,116.2,107.85,115.93,107.93,115.66Zm-.49-7.2a1,1,0,0,1-.63,1.22,12.51,12.51,0,0,1-3.22.64c-.61,0-1.34.07-2.12.1a2.31,2.31,0,0,1-2.18-3.23c.31-.72.61-1.39.88-1.94a13.19,13.19,0,0,1,1.74-2.69,1,1,0,0,1,1.36-.14A12.38,12.38,0,0,1,107.44,108.46ZM96,99.83a1,1,0,0,1,1,1,13.5,13.5,0,0,1-.39,3.13c-.15.59-.35,1.3-.57,2a2.3,2.3,0,0,1-3.74,1.08c-.58-.52-1.13-1-1.57-1.43a13.08,13.08,0,0,1-2-2.43,1,1,0,0,1,.3-1.35A12.28,12.28,0,0,1,96,99.83Zm-11.81,8.1h0a1,1,0,0,1,1.22-.59,13.25,13.25,0,0,1,2.91,1.35c.51.33,1.12.73,1.76,1.17a2.31,2.31,0,0,1-.13,3.9c-.67.39-1.31.76-1.85,1A13,13,0,0,1,85,116a1,1,0,0,1-1.18-.71A12.29,12.29,0,0,1,84.14,107.93Zm7.37,15.76a12.33,12.33,0,0,1-3.36-1.86,1,1,0,0,1-.2-1.35A13.15,13.15,0,0,1,90.24,118c.46-.39,1-.85,1.65-1.32A2.31,2.31,0,0,1,95.56,118c.17.76.32,1.48.43,2.08a13,13,0,0,1,.15,3.42,1,1,0,0,1-1,.9A12.38,12.38,0,0,1,91.51,123.69ZM99.7,119c-.22-.56-.48-1.25-.74-2a2.31,2.31,0,0,1,2.4-3.08c.77.08,1.5.16,2.11.24a12.72,12.72,0,0,1,3.25.89,1,1,0,0,1,.55,1.23h0a12.32,12.32,0,0,1-4.52,5.89,1,1,0,0,1-1.36-.21A13.11,13.11,0,0,1,99.7,119Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M100.77,99.25a13.76,13.76,0,1,0,8,17A13.77,13.77,0,0,0,100.77,99.25Zm7.2,10.62a.73.73,0,0,1-.54.84,32.49,32.49,0,0,1-7.43.7l-1.75,0a1.3,1.3,0,0,1-1.18-1.75c.24-.66.48-1.29.62-1.62a33.16,33.16,0,0,1,3.35-6.55.73.73,0,0,1,1-.21A12.5,12.5,0,0,1,108,109.87Zm-12.35,2Zm1.9-12.24a.73.73,0,0,1,.61.78,33.75,33.75,0,0,1-1.62,7.14c-.11.35-.33,1-.57,1.65a1.3,1.3,0,0,1-2,.59c-.55-.44-1.08-.86-1.35-1.09a33.29,33.29,0,0,1-5.17-5.19.72.72,0,0,1,.11-1A12.54,12.54,0,0,1,97.52,99.66Zm-13.62,8.1a12.08,12.08,0,0,1,.64-1.47.74.74,0,0,1,.93-.34,33.28,33.28,0,0,1,6.32,3.76c.3.21.84.62,1.4,1.05a1.31,1.31,0,0,1-.07,2.12c-.59.39-1.15.76-1.46.94A33.21,33.21,0,0,1,85,117.19a.74.74,0,0,1-.91-.42A12.48,12.48,0,0,1,83.9,107.76Zm2.86,13.06a.72.72,0,0,1,0-1,31.63,31.63,0,0,1,5.63-5c.29-.22.85-.6,1.43-1a1.3,1.3,0,0,1,2,.72c.19.68.37,1.32.45,1.67a31.81,31.81,0,0,1,1.14,7.51.74.74,0,0,1-.67.73,12.46,12.46,0,0,1-9.94-3.67Zm14.65,2.3a.72.72,0,0,1-1-.26,31.72,31.72,0,0,1-3-7c-.11-.34-.31-1-.51-1.67a1.3,1.3,0,0,1,1.3-1.67c.7,0,1.38.06,1.73.09a32,32,0,0,1,7.43,1.22.73.73,0,0,1,.49.84,12.71,12.71,0,0,1-.45,1.57A12.44,12.44,0,0,1,101.41,123.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-260",
    d: "M93.6,114.65a1,1,0,0,1,1.33-.63,1,1,0,1,1-.71,2A1,1,0,0,1,93.6,114.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M94.82,114.33a.71.71,0,0,1,.43.92.72.72,0,0,1-.92.43.73.73,0,0,1-.43-.92A.71.71,0,0,1,94.82,114.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-262",
    d: "M97.6,114.77a1,1,0,1,1,1.46-.18A1,1,0,0,1,97.6,114.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M97.67,113.51a.72.72,0,1,1,.12,1A.72.72,0,0,1,97.67,113.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M99,111a1,1,0,0,1-1.45-.27,1,1,0,1,1,1.73-1.17A1,1,0,0,1,99,111Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M97.77,110.55a.72.72,0,0,1,1.19-.81.72.72,0,1,1-1.19.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M95.78,108.56a1,1,0,1,1-2,.57,1,1,0,1,1,2-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-267",
    d: "M95,109.54a.72.72,0,1,1,.5-.89A.73.73,0,0,1,95,109.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-268",
    d: "M92.48,110.81a1,1,0,1,1-1.07,1A1,1,0,0,1,92.48,110.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-269",
    d: "M93.16,111.87a.72.72,0,0,1-.74.7.73.73,0,0,1-.69-.75.72.72,0,1,1,1.43.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M97,112.41a1.43,1.43,0,1,1-.86-1.84A1.43,1.43,0,0,1,97,112.41Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 71.6,
    y: 92.23,
    width: 49.29,
    height: 17.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M195.78,118.67H159.36l-2.81-1.79H140.37l-3.15,1.79H125.58a2.88,2.88,0,0,1-2.89-2.88v-1.34h76v1.34A2.88,2.88,0,0,1,195.78,118.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-273",
    d: "M66.71,107.06a52.86,52.86,0,0,1,.79,7.73c0,3.35-.79,8.78-.79,9.36,0,.3,1.78-1.53,2-2.43a36.65,36.65,0,0,0,1.46-7.49c.58-7.55-2.16-10-2.16-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M263.3,108a52.84,52.84,0,0,1,.79,7.72c0,3.36-.79,8.79-.79,9.37,0,.3,1.78-1.53,2-2.43a35.31,35.31,0,0,0,1.46-7.49c.58-7.56-2.16-10-2.16-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-275",
    d: "M329.22,76.85c-10.07-8.29-33.87-21-33.87-21l-1.75-.12S264.3,26.81,254.66,17C244.24,6.47,231.26.6,200.47.6h0c-.61,0-1.22,0-5.47,0H38.91c-7.21,0-10,4.24-10.56,9.8C27.1,23.37,25.06,38,25,47.43c-.07,7.47.36,47.9.48,58.78a3.52,3.52,0,0,0,2.65,3.36L41.56,115l28.57.11,5.18-15.44a8,8,0,0,1,7.53-5.42h24.62A8,8,0,0,1,115,99.65l5.18,15.56,10.43,0,30.29.12,106.11.36V100.83c19-21.6,43-8.44,43,10.35v4.67l1.33-.81,18.34-4.11S336.29,82.67,329.22,76.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-276",
    d: "M26,108l15.59,7,28.57.1,5.22-15.53a7.89,7.89,0,0,1,7.48-5.39h24.66A7.89,7.89,0,0,1,115,99.61l5.19,15.61,146.83.35V100.83c19-21.6,43-8.44,43,10.35v4.39h.47l.86-.53,18.34-4.11s6.36-27.32-3.79-33.77H21.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-277",
    d: "M326.79,111.18a39.57,39.57,0,1,0-79.13,0,41.46,41.46,0,0,0,.25,4.48l19.09.06V100.83c19-21.6,43-8.44,43,10.35v4.67l1.33-.81,15.41-3.45C326.79,111.45,326.79,111.31,326.79,111.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M315.18,110.94a26.81,26.81,0,1,0-53.61.35v3.24h5v-3.27a21.84,21.84,0,1,1,43.68-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-278",
    d: "M323.36,93.87h8.94c.52-7.13.12-14.38-3.08-17l-.14-.11h-5.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-279",
    x: 217.51,
    y: 113.52,
    width: 49.49,
    height: 3.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M332.52,94.23c-.3-2.2-25.07-1.34-25.77-.92a25.39,25.39,0,0,1,6.11,10.61,67.36,67.36,0,0,1,1.92,10.77s13.77-.55,16.52-3.13C333,109.93,332.77,96,332.52,94.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M315.62,93.7c-.24.9,1.65,14.43,3.92,16.69,1.74,1.74,8.87.54,10.17.54s3.85-11.26,2.51-16.72C331.85,92.7,316,92.31,315.62,93.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M316.23,93.76c-.21.85,1.74,13.33,3.83,15.43,1.62,1.63,8.27.7,9.49.7s3.68-10.66,2.41-15.66C331.6,92.81,316.56,92.41,316.23,93.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M316.84,93.81c-.19.82,1.83,12.23,3.75,14.18,1.49,1.52,7.66.85,8.8.85s3.51-10,2.31-14.59C331.34,92.91,317.14,92.51,316.84,93.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M317.46,93.86c-.17.78,1.9,11.14,3.65,12.93,1.37,1.41,7.07,1,8.11,1s3.35-9.44,2.22-13.53C331.09,93,317.72,92.62,317.46,93.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M318.07,93.91c-.14.74,2,10,3.57,11.68,1.24,1.3,6.46,1.16,7.42,1.16s3.18-8.82,2.12-12.46C330.84,93.13,318.31,92.72,318.07,93.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M318.69,94c-.13.69,2.08,8.94,3.47,10.42,1.12,1.19,5.86,1.31,6.74,1.31s3-8.2,2-11.39C330.58,93.23,318.89,92.82,318.69,94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M319.3,94c-.1.66,2.17,7.84,3.39,9.17,1,1.08,5.25,1.47,6,1.47s2.83-7.59,1.92-10.33C330.32,93.34,319.47,92.92,319.3,94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M319.91,94.07c-.08.62,2.26,6.75,3.3,7.92.87,1,4.66,1.62,5.36,1.62s2.64-7,1.82-9.26C330.07,93.44,320.05,93,319.91,94.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M320.53,94.12c-.06.58,2.33,5.66,3.21,6.67.74.86,4.05,1.78,4.67,1.78s2.44-6.36,1.72-8.2C329.81,93.55,320.63,93.12,320.53,94.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M321.14,94.18c0,.53,2.42,4.55,3.12,5.41a10.33,10.33,0,0,0,4,1.93c.54,0,2.24-5.74,1.63-7.13C329.54,93.65,321.21,93.22,321.14,94.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M321.76,94.23c0,.49,2.5,3.46,3,4.16a9.81,9.81,0,0,0,3.29,2.09c.45,0,2-5.11,1.53-6.07C329.27,93.77,321.79,93.32,321.76,94.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M322.37,94.28c0,.46,2.58,2.37,2.95,2.91a9.65,9.65,0,0,0,2.6,2.24c.36,0,1.79-4.47,1.42-5S322.37,93.43,322.37,94.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M328.46,107.28c-2.67.53-11.33.4-13.77.36.21,3.94.09,7,.09,7s13.77-.55,16.52-3.13c.64-.6,1-2.88,1.21-5.61A22.57,22.57,0,0,1,328.46,107.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M332.52,94.23c-.3-2.2-25.07-1.34-25.77-.92l.56,2.08a138,138,0,0,1,20.89-1.12C330,94.43,332.6,94.75,332.52,94.23Z"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-74",
    width: 36,
    height: 22,
    transform: "translate(287.29 55.15)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAWCAYAAACosj4+AAAACXBIWXMAAAsSAAALEgHS3X78AAAB5klEQVRIS8XUvWsTcRjA8e+ZkktydStZLBWsWtDFKiKU0j+gq4NgOhTUUEQQfElEQ5I7U4ujrVAoBkIrLkVwsVK0pbuDloqYWAhWcQiBUPHiS4bHQX7nC9U0aS73hRvu4YbPPcf9tKWFeSkUy5TKJZLJpIbHaSJC38E+iYxECHeFGTs/5imqAyBfyGvBQECOHztCqVwSwLNtaSLi3Mxlp6Rzdw9rb1adWbthf4BUmXRcDh8a8AS2JQjAsixZe/mc4eGTvP+44czdhv0TpLIsS54tLnA6MopdtTFChqt/ZF2QamZ6UoJ+jc9fO6h+sbGrVVdQ2wapctlpuXDxKrFYzJm1EtYwSPX40QO5czfH4NCgM2sFrGmQaunJvCyvrKIbfme2E9iOQaq57JQEQ3t4/faVM2sG1jKQKpOOS+/+o2x+qlCr1ahsVhqC7ar3QKMl0re19WKe2dl7AAQDASzL2vZbt3xDv3c/NyPXEjeJRs85s3rbchWkWll8KE+XX6AbfsJd4f8erG0BqTLpuOzr7We9WAC23lZbQQATt8bl+o0EpmkC0BkyuHTl8i+YiHhyjY6cEl3XxTRNMU1T1LztG/o7n88nqVQK+PkJPQcB7O3pljNno4AL51Azvdv4oJ3oP8A3+zs/AIbxQG/4SB/NAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M35.64,1.16a10.84,10.84,0,0,0-7.29,9.22C27.1,23.37,25.06,38,25,47.43c-.07,7.47.36,47.9.48,58.78a3.52,3.52,0,0,0,2.65,3.36L41.56,115h2.31Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-284",
    points: "119.56 113.39 217.51 113.39 217.51 115.57 120.17 115.24 119.56 113.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-285",
    points: "34.7 113.23 63.24 113.3 70.14 115.08 41.59 114.98 34.7 113.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "M41.56,115l-15-4.24c-.73-.12-1.25-.56-1.27-1.07l-.13-12.39c0-.18.21-.32.47-.32l15.87.64Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-287",
    points: "25.43 96.98 25.42 95.8 41.48 95.8 41.51 97.59 25.43 96.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-288",
    d: "M26.79,97l-1.15,0c-.26,0-.48.14-.47.32l.13,12.39c0,.51.54,1,1.27,1.07l.22,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M320.15,74.7c-1.28-2.34-25.31-14.54-28.79-16.17C290.3,58,225.05,56,224.94,57c-.35,3.25,51.95,15.62,61.35,19.76,5.67,2.5,17.49,12,21.6,14.67,3.17,2.06,16.8,1.33,17.5-.39C326.9,87.39,320.79,75.88,320.15,74.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M319.68,74.67c-1.32-2.3-24-13.82-27.29-15.36-1-.47-60.62-2.27-60.7-1.32-.23,3.07,47.71,14.53,56.39,18.52,5.24,2.4,16.13,11.34,20.11,13.92,3,2,15.79,1.27,16.44-.31C326.07,86.63,320.32,75.78,319.68,74.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M319.22,74.65c-1.36-2.27-22.68-13.11-25.81-14.56-1-.45-54.93-2-55-1.14-.13,2.9,43.46,13.43,51.42,17.27,4.8,2.31,14.77,10.71,18.61,13.18,2.89,1.86,14.79,1.2,15.39-.24C325.23,85.87,319.84,75.69,319.22,74.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M318.76,74.63c-1.41-2.24-21.38-12.4-24.33-13.75-1-.44-49.23-1.79-49.23-1,0,2.72,39.22,12.33,46.46,16C296,78.15,305.07,86,308.78,88.37c2.74,1.76,13.78,1.14,14.33-.16C324.4,85.12,319.36,75.59,318.76,74.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M318.29,74.61c-1.45-2.21-20.06-11.7-22.84-13-.92-.42-43.53-1.55-43.5-.79.11,2.55,35,11.23,41.5,14.77,3.94,2.13,12.05,9.43,15.62,11.7,2.6,1.65,12.78,1.08,13.27-.08C323.57,84.36,318.88,75.5,318.29,74.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M317.83,74.59c-1.51-2.18-18.76-11-21.36-12.15-.89-.4-37.83-1.3-37.76-.61.22,2.38,30.73,10.13,36.54,13.52,3.49,2,10.68,8.79,14.12,11,2.46,1.55,11.77,1,12.21,0C322.74,83.61,318.4,75.41,317.83,74.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M317.37,74.57c-1.56-2.14-17.45-10.28-19.87-11.35-.86-.37-32.14-1.06-32-.43.35,2.21,26.49,9,31.58,12.27,3.06,2,9.31,8.15,12.63,10.22,2.31,1.45,10.76,1,11.15.07C321.9,82.85,317.92,75.32,317.37,74.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M316.9,74.54C315.29,72.44,300.76,65,298.52,64c-.82-.35-26.43-.81-26.31-.25.48,2,22.25,7.93,26.62,11,2.62,1.86,7.95,7.52,11.13,9.48,2.17,1.35,9.76.9,10.09.15C321.07,82.1,317.43,75.23,316.9,74.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M316.44,74.52c-1.68-2.06-14.83-8.85-16.9-9.73-.79-.34-20.73-.58-20.57-.08.6,1.87,18,6.83,21.65,9.77,2.19,1.77,6.59,6.88,9.64,8.74,2,1.25,8.75.84,9,.22C320.24,81.34,317,75.14,316.44,74.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M316,74.5c-1.75-2-13.53-8.14-15.42-8.93-.75-.32-15-.33-14.84.1.74,1.7,13.76,5.74,16.69,8.52,1.76,1.68,5.23,6.24,8.14,8,1.89,1.15,7.75.78,8,.3C319.42,80.59,316.46,75.06,316,74.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M315.51,74.48c-1.81-2-12.21-7.43-13.92-8.13-.73-.29-9.33-.09-9.11.28.88,1.52,9.51,4.64,11.72,7.27,1.32,1.59,3.87,5.6,6.65,7.26,1.75,1,6.75.72,6.91.37C318.59,79.84,316,75,315.51,74.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M311.14,80.13c1.61.94,5.75.66,5.86.45.79-1.49-1.52-5.69-1.95-6.12-1.9-1.9-10.91-6.72-12.44-7.33-.69-.27-3.62.15-3.38.46,1,1.33,5.27,3.54,6.76,6C306.88,75.11,308.49,78.58,311.14,80.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M283,56.08c-2-2.06-14-16.33-15.88-18.42-7.23-8.07-12.24-12.34-11.37-13.29.67-.73,11.31,9.17,13.32,11.41,2.35,2.63,13.3,14.37,16.19,17.11,5.17,4.91,8.31,8.71,7.85,9.26S285.62,58.74,283,56.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M285.25,53c4.71,4.47,7.56,8,7.14,8.45s-6.81-3.1-9.23-5.5c-1.91-1.9-13.1-15.24-15-17.38C261.34,31,256.66,27,257.47,26.08c.62-.67,10.55,8.61,12.46,10.75C272.17,39.32,282.51,50.42,285.25,53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M285.24,53.13c4.26,4,6.82,7.18,6.43,7.65s-6.12-2.8-8.34-5c-1.8-1.74-12.2-14.14-14.17-16.34-6.36-7.1-10.71-10.89-10-11.7.58-.62,9.78,8,11.61,10.08C272.92,40.22,282.66,50.68,285.24,53.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M285.24,53.24c3.8,3.61,6.08,6.43,5.72,6.85s-5.45-2.49-7.46-4.38c-1.68-1.58-11.29-13.05-13.31-15.3-5.93-6.62-9.95-10.17-9.26-10.91.53-.56,9,7.48,10.76,9.42C273.67,41.13,282.81,51,285.24,53.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M285.23,53.36c3.35,3.17,5.34,5.66,5,6s-4.77-2.19-6.56-3.82c-1.58-1.43-10.39-12-12.46-14.27-5.5-6.13-9.19-9.44-8.56-10.11.49-.51,8.26,6.91,9.9,8.75C274.43,42,283,51.22,285.23,53.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M285.23,53.48c2.89,2.74,4.59,4.9,4.3,5.25s-4.1-1.89-5.68-3.27-9.48-10.85-11.61-13.22c-5.06-5.65-8.41-8.72-7.85-9.31s7.49,6.34,9.05,8.07C275.18,43,283.12,51.49,285.23,53.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M285.22,53.59c2.44,2.31,3.85,4.14,3.59,4.45s-3.42-1.58-4.79-2.7-8.58-9.76-10.75-12.19c-4.62-5.16-7.65-8-7.15-8.51s6.73,5.77,8.2,7.41C275.94,43.86,283.27,51.75,285.22,53.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M285.21,53.71c2,1.87,3.12,3.38,2.88,3.65s-2.76-1.26-3.9-2.14-7.67-8.67-9.89-11.15c-4.19-4.68-6.89-7.27-6.45-7.72s6,5.2,7.34,6.74S283.42,52,285.21,53.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M285.21,53.83c1.53,1.44,2.37,2.61,2.17,2.84s-2.11-.94-3-1.57c-1.16-.82-6.76-7.58-9-10.12-3.75-4.19-6.12-6.54-5.74-6.92s5.2,4.64,6.49,6.08S283.57,52.29,285.21,53.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M285.2,53.94c1.08,1,1.63,1.86,1.46,2.05s-1.46-.61-2.13-1c-1.06-.65-5.85-6.48-8.18-9.07-3.32-3.71-5.36-5.82-5-6.13s4.44,4.07,5.64,5.41S283.73,52.56,285.2,53.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M285.2,54.06c.61.58.89,1.09.75,1.25s-.83-.26-1.24-.46c-1-.48-4.95-5.38-7.33-8-2.89-3.22-4.59-5.08-4.34-5.33s3.67,3.51,4.78,4.75S283.88,52.83,285.2,54.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M285.19,54.18c-1.17-1.08-5.48-5.78-6.49-6.91s-3.77-4.22-3.92-4.08S276,45,278.41,47.73s5.51,6.85,6.47,7a.4.4,0,0,0,.35-.11A.29.29,0,0,0,285.19,54.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-289",
    d: "M329.22,76.85c-10.07-8.29-33.87-21-33.87-21l-1.75-.12-5.12-.17A12.64,12.64,0,0,0,291.26,58c1.35.73,26.56,14.13,28.76,16S324.44,78,324.44,78l6.17.52A6.23,6.23,0,0,0,329.22,76.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-290",
    d: "M331.82,88.32s-10,0-11.33-1.2S314.35,73,315.87,73s12.48,2.19,14.74,5.51C332.63,81.44,333.5,87.33,331.82,88.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-290",
    d: "M331.82,88.32s-10,0-11.33-1.2S314.35,73,315.87,73s12.48,2.19,14.74,5.51C332.63,81.44,333.5,87.33,331.82,88.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-291",
    d: "M331.82,88.32s-10,0-11.33-1.2S314.35,73,315.87,73s12.48,2.19,14.74,5.51C332.63,81.44,333.5,87.33,331.82,88.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M315.87,73a13.52,13.52,0,0,1,1.74.2c.33,3.16,3.74,12.29,4.86,13.25s7,1.12,9.83,1.18a1.1,1.1,0,0,1-.48.72s-10,0-11.33-1.2S314.35,73,315.87,73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-292",
    d: "M327,83c-2.21-3.25-9.27-7.48-11.1-7.6-.33-1.43-.4-2.43,0-2.45,1.51-.06,12.48,2.19,14.74,5.51,2,2.88,2.73,8.61,1.31,9.73C329.5,88.17,328.14,84.77,327,83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-293",
    d: "M325.35,83.37c-.09,1.5.26,2.74.78,2.77s1-1.16,1.09-2.66-.26-2.74-.78-2.77S325.44,81.87,325.35,83.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-294",
    d: "M326.44,80.71c-.52,0-1,1.16-1.09,2.66s.26,2.74.78,2.77l-7.24-1.93-1.7-4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-295",
    d: "M327.88,83.81c-.09,1.5.26,2.74.78,2.77s1-1.16,1.09-2.66-.26-2.74-.78-2.77S328,82.32,327.88,83.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M315.79,73.38c.1.65,10.52,4.11,12.6,5.61s3.6,8.66,3.75,8.35-1-7.27-2.9-8.78S315.72,72.83,315.79,73.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M256.61,22.31c.84,2.07-36-4.69-54-6.15C188.7,15,62.3,8.59,61.6,5.53S188.28.37,210.38,1.77C237.18,3.45,252.44,12,256.61,22.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M255.36,21.74c.75,2-36-4.61-52.56-6C189.63,14.6,72.81,8.33,72.21,5.41S190,.68,210.93,2.06C236.71,3.8,251.68,12.14,255.36,21.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M254.11,21.17c.67,1.86-36-4.48-51.15-5.83C190.55,14.23,83.33,8.08,82.83,5.3S191.71,1,211.49,2.36C236.24,4.15,250.92,12.27,254.11,21.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M252.86,20.6c.58,1.75-36-4.38-49.74-5.68C191.48,13.83,93.84,7.83,93.45,5.18s100-3.9,118.59-2.52C235.77,4.5,250.15,12.41,252.86,20.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M251.61,20c.49,1.64-35.94-4.28-48.33-5.52-10.88-1.08-98.92-6.93-99.21-9.45S195.15,1.54,212.59,3C235.3,4.79,249.38,12.56,251.61,20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M250.36,19.46c.41,1.54-35.92-4.18-46.92-5.36C193.33,13,114.87,7.33,114.69,5s82.18-3.11,98.45-1.7C234.83,5.13,248.6,12.7,250.36,19.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M249.11,18.89c.32,1.44-35.91-4.1-45.52-5.2-9.33-1.07-78.2-6.61-78.28-8.86s73.28-2.69,88.38-1.28C234.37,5.48,247.81,12.86,249.11,18.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M247.87,18.32c.21,1.34-35.91-4-44.12-5-8.57-1.07-67.85-6.45-67.83-8.56s64.38-2.28,78.33-.88C233.9,5.82,247,13,247.87,18.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M246.62,17.75c.12,1.24-35.89-3.94-42.71-4.88-7.8-1.08-57.5-6.29-57.37-8.27S202,2.75,214.8,4.14C233.43,6.18,246.17,13.19,246.62,17.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M245.37,17.18c0,1.14-35.88-3.88-41.3-4.72-7-1.09-47.14-6.13-46.91-8s46.58-1.42,58.19,0C233,6.53,245.31,13.37,245.37,17.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M244.12,16.61c-.1,1-35.86-3.84-39.89-4.56-6.26-1.13-36.79-6-36.45-7.68s37.67-1,48.12.37C232.48,6.93,244.42,13.54,244.12,16.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M242.87,16c-.24.93-35.84-3.81-38.48-4.4-5.48-1.23-26.43-5.81-26-7.39s28.77-.56,38,.78C232,7.28,243.48,13.68,242.87,16Z"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-121",
    width: 9,
    height: 24,
    transform: "translate(24.29 67.15)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAYCAYAAAAoG9cuAAAACXBIWXMAAAsSAAALEgHS3X78AAABE0lEQVQoU73SsW7CMBSF4d+xo7KRicBGhyhLkcJEnykPwZBHoS9TZlhYqAoDUoZQxECURL0dDDSlJOrUu3j5dHx1bCUiAMLNlGWJ67oKwMznrz/AYDBgt9uxWq0Iw1Amk2dlfN9nNnu5DaLTeSAMQwAxw+Ejo9ETi8WS6XSqLihJkusNzq+I2jiOtqeIcDwe7yJjzqgoirsAQOszyvP8L+iE53nt6HRqSzIW5XlOWZYNqLZT0/JXFEUR2+22HQH0+/1GlKZpe+ObzTtaa4t6Pb8RGqPbk8DW4ABU1f0KLNIXVP0TMnVU/43jcUS3ax/eAARBwHr9RhzHZFnGfp8BcDh8ACglIoiIiHyi1HcjSikABfAFdOBtH2RssRgAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 24.26,
    y: 68.99,
    width: 7.22,
    height: 20.28,
    rx: 0.95,
    transform: "translate(55.74 158.26) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 24.26,
    y: 68.99,
    width: 7.22,
    height: 20.28,
    rx: 0.95,
    transform: "translate(55.74 158.26) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-297",
    points: "30.66 75.31 26.05 75.31 26.05 70.29 30.71 70.29 30.66 75.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M24.79,72.8c0,1.39.56,2.51,1.26,2.51s1.26-1.12,1.26-2.51-.56-2.51-1.26-2.51S24.79,71.42,24.79,72.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-298",
    points: "30.66 81.71 26.05 81.71 26.05 76.69 30.71 76.69 30.66 81.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M24.79,79.2c0,1.39.56,2.51,1.26,2.51s1.26-1.12,1.26-2.51-.56-2.51-1.26-2.51S24.79,77.82,24.79,79.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-299",
    points: "30.66 88.12 26.05 88.12 26.05 83.1 30.71 83.1 30.66 88.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M24.79,85.61c0,1.38.56,2.51,1.26,2.51s1.26-1.13,1.26-2.51-.56-2.51-1.26-2.51S24.79,84.22,24.79,85.61Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-300",
    x: 24.57,
    y: 69.8,
    width: 3.37,
    height: 18.99,
    rx: 1.18,
    transform: "translate(52.52 158.58) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M25.27,88.78h0a.67.67,0,0,1-.7-.61V70.41a.66.66,0,0,1,.7-.61h0a.66.66,0,0,1,.7.61V88.17A.66.66,0,0,1,25.27,88.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M30.8,69H28.73a1,1,0,0,1,1,.89v18.5a1,1,0,0,1-1,.89H30.8c.38,0,.68-.59.68-1.32V70.32C31.48,69.59,31.18,69,30.8,69Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-301",
    points: "116.67 104.66 267.15 104.66 267.15 99.38 114.91 99.38 116.67 104.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-302",
    points: "73.65 104.66 41.56 104.66 41.56 99.38 75.41 99.38 73.65 104.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-303",
    d: "M314.94,111.18a26.42,26.42,0,1,0-52.84.33v5.86a.8.8,0,0,0,.79.79h3.32a.8.8,0,0,0,.79-.79V111.5a21.52,21.52,0,1,1,43-.32v4.67h1.33l3.57-.76Z"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-74",
    width: 54,
    height: 90,
    transform: "translate(220.29 22.15)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAABaCAYAAADzc6X8AAAACXBIWXMAAAsSAAALEgHS3X78AAAFXUlEQVR4Xt2cXWwUVRiGn29dhVAQw39ooTFEIIZ4q95gQIN4IQIWBBRSUW5ARRDjBXGQsrT81cqWtSggYkGKICYSbTBqlB8RxSBYm9Tyo1KCLIWEtrC7yu7xYna2s2Hb2W4L3TlPMmlm59vd8+73nm/OOTNTUUrhf6dULVy0hNmz5nAjeoNUhEIhVEwRUzGUUiilCIVCxGKx5E3FuHLlciIm1TZu7EPMmD6Fo8frMAxDUn5hJxGlFJOfnKjGjZ/IL8eO07dv3+SGALS7r0CRtK+U7bUU+6PvH5VowJhRD/Bs4UwC/nXMnbegy0TK3l3bVG393/Tu1ZuFi17tsg9Oh6KiIgUwaMAgAI4e+Y6tlVVd0gb55svd6tDPtbfMEuliiTz4/SFmzniq09nzQOsv1p1YP+zjEycQjggfbAoop/e0hwdAdeojug7DMGTJ60sEoOHCZSq3lGfcMo/5J+P33xLmvzRfAK5F7mT/vp0ZNc7jFNCdXA9d5+y5qxz46rMOi8sqK9oxDENarrUQCoeoPXWRb6v3dKiVWWlFC8MwpLmlmXAkzB9nG9m/b1faDc1qK4Iprqm5iWBjkPP/XOfzPZVpiYtbMa3YbsM6FTRcOMe18F1Ubd/s2OCsz5iFJa7+TB2KPnz80aZ2xXno1Pn99mIX16NHf3Zse79Nca6woh1L3O91NeTkDGlzhOIaK9qxxJ2s/ZV77s5NKc6VwqBVXE3dSaI3elJc7EsSZ1oxS89jTljiLlw6T7jlP3y+FQkhHoFsPT+nhSXO2/MOwi3/JqY/rrWiHUtc3vBcli1bBrjcinYMw5BgY5CKQAWB8jJlZsz9uoBWcWNG5eMB0SJjdsKRiB59zI7ER1JaWRFA4mNEbYpHgqSMaYSILWM6JQxdrSjaWtGeMa1I9DFx10TTCWtBQLuMiQhXrzZl97piZsStKGTnSnCmiJhZ086KZvEQ/awomNqy9qJEpogIgo5WREDQ0Ir24qGTFZMGwTohIvZyr0/KJL7pZ0Wzk5mrVHplLMmKGiF2KzrEuglptSJadTKJz6Fddak2LeKDRf2siJiDYAG9rKjvIBhNrShW8QCtrIh1go5GY06RriK+MqDjEre9eOijy0Q0HVLZyr0e0lasMO/x+OlEPV6nYDchIpz7q4GVq32izUTT5zPvpRo9cjCg0SqVCISaI8x+4WUBTRZziotXJmULMPuY26+PCcKI/JE889y0xCTM9RkrKSlRAPWnjiW97gUY2L/7H9rJFBEYfd8YJhdMSpoyuzpjq1etUgA1NYdvOubqPiYi3DtsBNNnTUvKFrjwLm6LNavXKIDq6k9THvci7hQmIuQNzScciaQ87korrlu7VgFs37GJL6q/TrnO5hXcJwyEAf368+DDY9uM8IIQU+6ZRZeuK1UAW7e+x4HDP7a5Kuo6K4oIOb1yeLqgoN04Vwmz7qnf9uFmTvxW2+4atquqYp/efUApCgsLnULdVTxEhOKSlQQvNTpecXDNCXp92XoFsKp4uVMo4KI+JiIsfm0x0WjUMVvgkoz51/vNorGlwik0gRey/0kJQVj65lKampvSyha44A7TDf4NCiDgX+sUmkS8KmbvyENEeLusjDNnT6edLcC8KJGtGQuUm89e+kuLnEJvIqurooiws6qKg4cOdChbkMVVsSJQoQCWL33FKTQlHoAB/QY6xXUDwg+HjzD+iYIOZwvA82fDRYKNQcr9mf+3k65m47sbFcC856c4hbaJd+68BTJt6nT16GPjyR+e1+3icocOYc6cF8kdnMMjE6ZmlC2IF4/dez8R31tvqPxheU7xt4XT9ScJNg5hklNgO/wPxvVRbtgZcnEAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M228.48,25.71l19.06.08a11.86,11.86,0,0,1,8.39,3.51l21.22,21.44A3.69,3.69,0,0,1,274.37,57l-46-1.89a3,3,0,0,1-2.84-3V28.67A3,3,0,0,1,228.48,25.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-304",
    d: "M274.43,55.63l-46-1.88a1.57,1.57,0,0,1-1.5-1.57V28.67a1.56,1.56,0,0,1,1.57-1.56l19.07.08a10.37,10.37,0,0,1,7.39,3.1l21.22,21.43a2.29,2.29,0,0,1-1.61,3.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M276.15,51.72,254.93,30.29a10.37,10.37,0,0,0-7.39-3.1l-19.07-.08a1.56,1.56,0,0,0-1.57,1.56v1.9l19.94.51a9.44,9.44,0,0,1,2.85.51v23l1.34.05V32.16a9.4,9.4,0,0,1,2.2,1.57l12.71,12.12c-.05,1.22-.16,3.24-.32,2.5-.21-1.05-1-3.33-3.54-2.89S257.89,55,257.89,55L259,55l.7-2.72s1.75.22,1.92.22a13.65,13.65,0,0,1-.7,2.57l8.36.35,1.1-5.36,5.44,5.19a2.39,2.39,0,0,0,.84-1A2.22,2.22,0,0,0,276.15,51.72Zm-15-1.06h-1.05a11.12,11.12,0,0,1,1.18-2.88c.53-.53.53.39.53.61S261.12,50.66,261.12,50.66Z"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-74",
    width: 58,
    height: 36,
    transform: "translate(223.29 23.15)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAAkCAYAAADYZynDAAAACXBIWXMAAAsSAAALEgHS3X78AAADsElEQVRoQ92Zv08bVxzAP9/nOxtzNpbAgEgR1HGaIoJBHpzBYkhT0hRIt7ihgdBUYg9KlY4MtzaNmq2RmJut+Q8KA7AgIUSjZmFJWRAScuyCCFzgdbDOPZIqEMCu7Y9k3fO784/P+379fT59RWuNi23bGiASaeA0iEhxrLUml8sDMDU19e+JMiNaa2zb1koJSiksy8I0TQ4ODv7zBd6FOc45rTX7+/uHHpZlkc//XVZx0Vrz+PHP+uDggJ6eHl6+/IuJiYkz/QI7Ozt6fX2d58//YG1tDcdx2N3d5fXr3bLJyqNHP+m9vT2GhoZJJBJl+dCNjQ399OmvOI7D3t4eb97sl1xYKaUIh8NlkwRoaWmRe/cmJRqNAtDQEC7Wh1KhHMchlUoddV1JuHv3OxkcHEJEiEQaSiqrdnZ2jrqmpCSTSblzZxwobWTVUReUg8bGRhkbGwMgHA6VRFZ597z/k6amqIyOlk62YkQBmpub5fbtUQBCIetMZSsidb20trbKyMg3AFhW/ZnJVlREXdra2mRkZAQ4O9mKFAU4d+4juXWrIFtfHzy1bMWlrpf29nbJZL4GIBisO5VsxUbUpaOjQzKZDACmaZxYtuJFATo7P5abNzPU19efuBpXdOp6icVicuPGV/h8vhMVqKqIqEs8Hpfh4WEMw/hg2aqJqMuFC5/I4ODgB8tWVURdLl78VK5f/xLDMI699VSlKEBXV5dcu/YFpmkeS7bqUtdLd3e3DAwMYJrmkfts1UbU5dKlHrl69XP8fv97ZateFCCRSMiVK5+9V7aqU9dLX1+fpNNp/H4/dXWBd2RrIqIuqdRlSafTBAKBd2SNWhKFgiygFxcXCQQCxfmaSV0vqdRlSSaT5HL5YlRrKnW9PHjwA9FoU7GPpNwGUK0xNzcnvb29xQaXAlhYWGBra+vIv1HVxvnzcaDQJVQAuVyeFy/+ZHp6uqZk29ragEK7UrnNnZmZGba3t8hmszqbzWrHcTSgV1dX9fT0tJ6cnNT9/f1aRKpiMbLZrH748Mfib1TcnqZt29qdHB//lidPfkEphYggIofG7nOfz1d847q6IMFgHaFQCBGhqSmKUgqlhI6OTpQSRFTxGApZgLC9vc3y8jKzs7MsLS0xPz/P5ubmqSrkzMzvemVl5VADWt5u3tq2rb2F2FuVSzk2DOPQvGmaeCncf1rEYrHiYkPhGI/HUUrx7NlvvHr1CsMwyOXyhEIW9+9/L+CJaDk46lbqNEQiDby9g3h7rv8AEUNSs6rZfw4AAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-74",
    width: 55,
    height: 33,
    transform: "translate(224.29 25.15)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADcAAAAhCAYAAAB9VDPAAAAACXBIWXMAAAsSAAALEgHS3X78AAADeElEQVRYR9WZ30tbVxzAP99zY/jWOtuupgTdalixEVlZsUZffJY6sw6p61o6pKM/6Og6nIW8GfD+LXlZfZ7FPsUHH/K6zo50qBFWXzIEa9C8yNlDTBq1M1YTzf3A4Ry+9xxyP3y/595wrlhrcV3XUsbExAQA1tod/cFjFmthdnaWVCpFOfF4XDgmxFrLzMyMBQiHwwSDQRKJBMaYPa21tbU0dhyHQCCAMYampib8fj/GGJqbm0uSm5ubLCwssLKywtu3/9DW9hnr6+94/fqvY5GUyclJCxCLxVDVmv7gxsaGnZ7+nWw2Szb7b80FDcClS1/UXAygsbFRRka+k2vXegB4/vw3u3tLVBNjjNDSEqg0r6r09vZKLBbjzJmzRCI9e/Z8tTDGmEpzaoKqysDAAADd3d01ETwxOQARkevXBwG4evWrqgsax3EqzakpIiJDQ0MAXLnyZVUFTzRzRUREotFvAOjq6qqaYF3IQeHJNjj4NQCdneGqCJ54WZajqhKNRgHo6Og4smDdZK6IqsqNG98ChffvUQTrTg4KgsPDwwCEQu2HFqyrsixHVeXmzREALl78/FCCdZm5Iqoqt259D0BbW+tHC9a1HBQEb9++A0AwGPwowboty3JUVe7e/QGACxcCBxas+8wVUVUZHR0F4Pz5Tw8k6Bk5KAjeu/cjAOfOna0o6ImyLEdV5f79BwA0N3+yr6CnMldEVeXhw0cAnD7d+L+CnpSDguDjxz8BcOqUflDQGOOwubmxZ7EXUFV58uRnAPz+hj2CZn5+/oMLvYKqytOnvwDg8zk7BA2AMd56qOxGVWVs7FcAjJGS4LacN/ddOaoq4+PPiER6SzEfgON4Xw4KguFw2AK4rmtLZSkiFd/4XiAUCknxxNsApFIpFhcX913kJUSEy5c7MOVH2i9eTNtMJmNfvfrDptNpm8lk7Orqql1bW7O5XM7m83lbJJlM2rGxMdvf319XGc/n83Z9/R1v3vxNKYWu69pIpIeWlgAvX87gOE7pg0f52BgHxzH7xArj3bH29nZEBGMEEbM9LvSBQAARKbWGhgaWlpZIJpNMTU0xNzdHLpereNy/tbVll5eXSSQSxONxKckdBtd1rTHvb7LQG44a23ntfczn822Pi624VgiHO0mn0wDMz//J+Pizo8kdB5X++Rfp6+sjlUrt+HL0H3CSNgHjfrcsAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "254.35 55.38 253.01 55.38 253.01 28.25 254.35 28.95 254.35 55.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-305",
    points: "253.31 54.83 253.01 54.83 253.01 28.75 253.31 28.95 253.31 54.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-306",
    points: "254.04 54.83 254.35 54.83 254.35 29.74 254.04 29.49 254.04 54.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M269.43,43.36l-.17,13.58a.63.63,0,0,0,.6.64l11.47.61a1.77,1.77,0,0,0,1.35-3L270.52,42.92A.63.63,0,0,0,269.43,43.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M267,41.68H275a.74.74,0,0,1,.74.74V52a.74.74,0,0,1-.74.74h-5.38a6.57,6.57,0,0,1-6.57-6.57v-.67A3.87,3.87,0,0,1,267,41.68Z",
    transform: "translate(538.89 94.48) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M263.86,52.68h8a3.77,3.77,0,0,0,3.76-3.76v-.65a6.47,6.47,0,0,0-6.47-6.47h-5.26a.73.73,0,0,0-.73.73V52A.73.73,0,0,0,263.86,52.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M263.86,52.56h7.88a3.64,3.64,0,0,0,3.64-3.64v-.64A6.36,6.36,0,0,0,269,41.92h-5.16a.71.71,0,0,0-.71.71v9.22A.71.71,0,0,0,263.86,52.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M263.87,52.44h7.77a3.53,3.53,0,0,0,3.53-3.53v-.62A6.25,6.25,0,0,0,268.92,42h-5.05a.7.7,0,0,0-.69.7v9A.69.69,0,0,0,263.87,52.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M263.88,52.33h7.67A3.42,3.42,0,0,0,275,48.91v-.62a6.14,6.14,0,0,0-6.15-6.14h-4.94a.69.69,0,0,0-.68.68v8.81A.69.69,0,0,0,263.88,52.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M263.89,52.21h7.56a3.31,3.31,0,0,0,3.31-3.31v-.6a6,6,0,0,0-6-6h-4.83a.67.67,0,0,0-.67.66v8.61A.67.67,0,0,0,263.89,52.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M263.9,52.09h7.46a3.19,3.19,0,0,0,3.19-3.19v-.59a5.93,5.93,0,0,0-5.93-5.93H263.9a.65.65,0,0,0-.65.65v8.41A.65.65,0,0,0,263.9,52.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M263.91,52h7.35a3.09,3.09,0,0,0,3.09-3.09v-.57a5.83,5.83,0,0,0-5.83-5.82h-4.61a.64.64,0,0,0-.64.63v8.21A.64.64,0,0,0,263.91,52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M263.92,51.86h7.25a3,3,0,0,0,3-3v-.56a5.72,5.72,0,0,0-5.72-5.71h-4.5a.62.62,0,0,0-.62.62v8A.62.62,0,0,0,263.92,51.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M263.93,51.75h7.14a2.86,2.86,0,0,0,2.86-2.86v-.55a5.61,5.61,0,0,0-5.61-5.61h-4.39a.61.61,0,0,0-.61.61v7.8A.61.61,0,0,0,263.93,51.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M263.94,51.63h7a2.75,2.75,0,0,0,2.75-2.75v-.53a5.51,5.51,0,0,0-5.51-5.5h-4.28a.58.58,0,0,0-.59.59V51A.58.58,0,0,0,263.94,51.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M264,51.51h6.94a2.63,2.63,0,0,0,2.63-2.63v-.52a5.4,5.4,0,0,0-5.4-5.4H264a.58.58,0,0,0-.58.58v7.4A.57.57,0,0,0,264,51.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M264,51.4h6.83a2.52,2.52,0,0,0,2.52-2.53v-.5A5.29,5.29,0,0,0,268,43.08H264a.56.56,0,0,0-.56.56v7.2A.56.56,0,0,0,264,51.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M264,51.28h6.74a2.41,2.41,0,0,0,2.41-2.41v-.49a5.18,5.18,0,0,0-5.19-5.18h-4a.54.54,0,0,0-.54.54v7A.54.54,0,0,0,264,51.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M264,51.16h6.63a2.3,2.3,0,0,0,2.3-2.29v-.48a5.08,5.08,0,0,0-5.08-5.08H264a.52.52,0,0,0-.52.53v6.8A.52.52,0,0,0,264,51.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M264,51.05h6.53a2.18,2.18,0,0,0,2.18-2.19V48.4a5,5,0,0,0-5-5H264a.51.51,0,0,0-.51.51v6.6A.51.51,0,0,0,264,51.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M265.57,43.55H272a.49.49,0,0,1,.49.49v6.39a.49.49,0,0,1-.49.49h-3.63a4.87,4.87,0,0,1-4.87-4.87v-.44A2.07,2.07,0,0,1,265.57,43.55Z",
    transform: "translate(535.99 94.48) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M268.6,47.47c3.31,2.24,6,2.83,6.58,2.05s.54-3-2.34-6.26c-1.53-1.74-8.38-1.75-8.94-1S266,45.68,268.6,47.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M268.64,47.22c3.12,2.11,5.68,2.64,6.2,1.88s.5-2.85-2.22-5.9c-1.45-1.63-7.89-1.63-8.41-.87S266.14,45.54,268.64,47.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M268.68,47c2.94,2,5.34,2.44,5.83,1.71S275,46,272.4,43.14c-1.37-1.52-7.4-1.5-7.89-.77S266.33,45.41,268.68,47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M268.73,46.73c2.74,1.83,5,2.25,5.45,1.55s.41-2.57-2-5.2c-1.3-1.42-6.91-1.37-7.37-.68S266.52,45.28,268.73,46.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M268.77,46.49c2.56,1.68,4.65,2,5.07,1.38s.37-2.43-1.89-4.85c-1.21-1.31-6.42-1.25-6.83-.58S266.71,45.14,268.77,46.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M268.81,46.24c2.38,1.54,4.31,1.86,4.7,1.21s.32-2.27-1.78-4.5c-1.13-1.2-5.93-1.11-6.31-.47S266.9,45,268.81,46.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M268.86,46c2.18,1.39,4,1.66,4.31,1s.28-2.13-1.66-4.15c-1.06-1.09-5.44-1-5.79-.37S267.09,44.87,268.86,46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M268.9,45.75c2,1.26,3.63,1.47,3.94.88s.23-2-1.55-3.8c-1-1-5-.86-5.27-.27S267.28,44.74,268.9,45.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M268.94,45.51c1.81,1.11,3.29,1.27,3.57.71s.18-1.85-1.44-3.45c-.9-.88-4.46-.73-4.74-.17S267.48,44.6,268.94,45.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M269,45.26c1.62,1,2.94,1.08,3.18.54s.14-1.7-1.33-3.09c-.81-.78-4-.61-4.21-.07S267.67,44.47,269,45.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M269,45c1.44.83,2.6.88,2.81.37s.09-1.56-1.22-2.74c-.74-.67-3.48-.48-3.69,0S267.86,44.34,269,45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M269.07,44.77c1.25.69,2.26.69,2.43.21s.05-1.41-1.1-2.39c-.66-.57-3-.35-3.16.13S268.05,44.2,269.07,44.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M269.12,44.53c1.06.55,1.91.49,2.05,0s0-1.27-1-2c-.59-.46-2.5-.23-2.64.23S268.24,44.07,269.12,44.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M269.16,44.28c.87.41,1.57.3,1.68-.13a1.69,1.69,0,0,0-.88-1.68c-.51-.36-2-.1-2.12.33S268.43,43.94,269.16,44.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M269.21,44c.68.27,1.22.1,1.29-.3a1.32,1.32,0,0,0-.76-1.33c-.44-.25-1.53,0-1.6.43S268.62,43.8,269.21,44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M269.25,43.79c.49.13.88-.09.92-.46a1,1,0,0,0-.66-1c-.36-.14-1,.15-1.06.53S268.8,43.67,269.25,43.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M268.75,42.92a.59.59,0,0,0,.54.63.6.6,0,0,0,.55-.63.6.6,0,0,0-.55-.63A.59.59,0,0,0,268.75,42.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M305.67,74.37c0,12.21-109.55,18.34-176.21,18.34s-86.68-3.44-87.9-18.34c-.72-8.77,12.68-23.91,79.34-23.91S305.67,59,305.67,74.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M301.12,74.41c0,11.23-101.49,16.91-164.43,16.91s-83-3.24-84.16-16.91c-.66-8.11,13.43-22,76.37-22S301.12,60.31,301.12,74.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M296.57,74.45c0,10.25-93.43,15.47-152.65,15.47S64.5,86.9,63.5,74.45c-.59-7.44,14.18-20,73.41-20S296.57,61.61,296.57,74.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M292,74.49c0,9.26-85.37,14-140.88,14s-75.78-2.81-76.67-14C74,67.72,89.4,56.4,144.91,56.4S292,62.92,292,74.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M287.47,74.53c0,8.28-77.31,12.6-129.1,12.6s-72.15-2.61-72.93-12.6c-.45-6.1,15.68-16.15,67.47-16.15S287.47,64.23,287.47,74.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M282.93,74.56c0,7.31-69.26,11.17-117.34,11.17s-68.51-2.4-69.17-11.17c-.4-5.43,16.42-14.2,64.5-14.2S282.93,65.54,282.93,74.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M278.38,74.6c0,6.32-61.2,9.73-105.56,9.73s-64.89-2.19-65.43-9.73c-.34-4.76,17.17-12.26,61.53-12.26S278.38,66.84,278.38,74.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M273.83,74.64c0,5.34-53.14,8.3-93.79,8.3s-61.26-2-61.68-8.3c-.27-4.09,17.92-10.33,58.57-10.33S273.83,68.15,273.83,74.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M269.28,74.68c0,4.35-45.08,6.86-82,6.86s-57.62-1.77-57.94-6.86c-.21-3.42,18.67-8.39,55.6-8.39S269.28,69.46,269.28,74.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M264.73,74.71c0,3.38-37,5.43-70.24,5.43s-54-1.56-54.19-5.43c-.14-2.75,19.42-6.44,52.63-6.44S264.73,70.76,264.73,74.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M260.19,74.75c0,2.4-29,4-58.47,4s-50.35-1.36-50.44-4c-.08-2.08,20.15-4.5,49.66-4.5S260.19,72.07,260.19,74.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M255.64,74.79c0,1.41-20.91,2.56-46.7,2.56s-46.69-1.15-46.69-2.56,20.9-2.56,46.69-2.56S255.64,73.38,255.64,74.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-307",
    d: "M229.59,67.94a3,3,0,1,0,2.95-3A3,3,0,0,0,229.59,67.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-308",
    d: "M226.49,69h11.32a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1H226.49a1,1,0,0,0-1,1h0A1,1,0,0,0,226.49,69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-309",
    d: "M196.1,67.94a3,3,0,1,0,3-3A3,3,0,0,0,196.1,67.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M193,69h11.32a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1H193a1,1,0,0,0-1,1h0A1,1,0,0,0,193,69Z"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-74",
    width: 74,
    height: 37,
    transform: "translate(134.29 23.15)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAAAlCAYAAADlcn/+AAAACXBIWXMAAAsSAAALEgHS3X78AAACe0lEQVRoQ+2asU7bUBSG/3vji60gxQpRlmyR8gJUouIpmEnFGjYCnakiJSp7eYQyFKmA8gqeIjXeygMUFoRQhOUkrrlC4XQIDnYCtqW2A/h+k6987OHTOcdH8mFEhHkODj5TPp8H53zh3luDMQYigpQSmqZhPPbQarXYQlxYVKfTmR1MswAhxHz8m+X+/h4AIKXE3Z1ckDUTdXj4hSaTCSaTCcrlMra2tqBpYsHsW4UxRtfX1zg5+Y7bWwemWYDrDmfCNGCaSaXSCoQQqNc/oFgsZkZQABExANjZaVK//wO9Xi9ynwPA8nIeo9Eos5LCEBFbW3vPVlffAXhqR7zT6ZDn/UalUsm8pDCDwQCmWQB7NMLa7TaZZgHN5i4YY0pUCMdx6OjoK1x3CG4YOnK5nJL0DGdnZ7NrLqXMxLz0tyhDMYQTiKuKe5lgageUqFg450+iEmIzjSq9lEQySol6GdWjUqJ6VEpUj0pJUHqGoStRcXDOsbS0NL1OiM00QekRkcqoOJSolARulKgEIl+9mLjMo0ovJar0UqJKLyWq9FJyeXkJQIlKpFarAQCIAO66w9l/d0WU9fV1PDw8AAj1KMdxFtdaMs75+U9IKQE8inLdIY6Pv8U+lDUsyyLbtmEYBlqtFuPBtobv+7i5uVFZ9cjFxS94njc7R8aD09MT2HafGGOZFmbbfbq6ugIA7O19ZEBoPyq8RFYqrWBzs45ut4tGo/Hcu/4p1Wo1KeS/srGxge3tBizLgu/74JyDcx7Zj4ps3AFTYYahQ9f1Z1/62gi+WnHMrxSEBQUsiAKmsoTQIISA7/tPwXMz12s5j0ZjJJHLcezvf3pxqPwDNhoENB3JjwgAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-74",
    width: 64,
    height: 27,
    transform: "translate(139.29 28.15)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAAbCAYAAADMIInqAAAACXBIWXMAAAsSAAALEgHS3X78AAAB1UlEQVRYR+2ZP4oiQRjF39clomhiIIIaKHiADjTRTPoGnsBLCDuBYCeGO7CTCYIXGFNH2Im6Md85g9KYzQY2SFe/CdTVWRg6ni5/UNDUv+Dx6iv6lZDEhUKhwMPhgDAMkSZIQkTgOA48z5Pbsczlo9vtEgBmsxmCIPh/j1Tg+z5EhABAUoCzALVajc1mE6+vv/Hyskaj0fikUlp4fPzJ9/e/WK/XEBGSFHQ6HVarVb69/SFJmNCOxyMBkCSsbDaLxWKB5+dlkoCpYTqdotfrQUSYAYBWqwXHcVJp+69ot9sAAGuz2YC83gQmMB6PJY5jxHEMSykFrXXSmtShtUYURbAymQziOE6anzq01tBaXwQwzwFRFF0doLV5DigWiycBlFJGOgCA2Q4AYHYNAO4OuNcA4x1wUwPMFOB+BEw/Ajf/AmY6QGsNAcAwDJHL5YzJA1zX5Xw+R71ehwUA+XweT0+/jAkF+v0+SqUSPM8Ti+d01LbtpHWpwHVdRlGE7XZ76jinQQTAIAg4mUyYFCp+17Zarai1pm3bLJfLJHmKxUmKiHAwGMD3fQDgaDT6QsPviVIKy+USw+EQlUoF+/3++i4AXB8KRIQPDz+g1L+hVLHb7T4V+w91+UkoHfwprwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-74",
    width: 74,
    height: 37,
    transform: "translate(49.29 23.15)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAAAlCAYAAADlcn/+AAAACXBIWXMAAAsSAAALEgHS3X78AAACaUlEQVRoQ+2av26bUBTGv4sNwXYT66qZPHjy7imu5DlN00dwHyHd0h1VzM0DNFO8NGszNYufo3kBL7FkBMY1gWtOh9YE/AdIFdV1uT/JA/ceuOLTd7gHfBgRYRnTNAkA6vWDlbk/oVwurx1ft3YafyM+DENMJi4Mw2DxORa/2MXFJxJCQNd1EBE0TXvyYptgLLHuP0sQBLGfiASLhIq7qNvtotN5BSLajbt7RizLouvrL7BtG9VqFbbtwDAMVgYeRTo8fImTkzdotVrsuZy0a3DO2dnZe1iWRf3+VTReBoD9/RcIggC93jtwzgvnonVwzlmlUiHHmcA0TSopikKVio5Go4Gjo44UKUa73f54d/cdqqpCAQDP83B6+jbrvMKhqirjnAMAFMYAXdexGJCsR8kKKDqLPU3ZlfpmexCISDoqi0WZJB2VAyKSQmVBtJR6Qoi0+MIjHZVB5CjGGGaz2c683W8DIoLi+0FWXKGJdj1gd74VbYvoYS6F2szKridJJ3KUdNV6Eo6SIqUjUy8HctfLyeIfKSlUDhKpJ8VKRzoqBzL1ciJ3vScgHZWDMPztqPl8jtFolBVfSMbjMWq1qky9NIQQJITAdPoDimEYzHWn6PevMBwOi9mZsYHLy8/RJ/KEo25uvsKyLCkWgNFoRI7jAAAMw2CJ/qh6/QCe56HZbKLX6+H4+DUGg0Ha9f4rxuMxbm+/4f7+Hrb9KBKw1HFnmibt7Wl4ePBRq1U3thTuGmEYZoUAABTlV4L5vo9SqYTz8w9RObC2YWwhmKZpcF03NsOQrCSyjldLj20dTybx+0hnuX8TAH4C6vsfOBqSLrQAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-74",
    width: 63,
    height: 27,
    transform: "translate(55.29 28.15)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAbCAYAAADLYlf/AAAACXBIWXMAAAsSAAALEgHS3X78AAABvklEQVRYR+2Zv2oqQRjFz8xuccNWWwluo9XWFjZuYeMNvomVbyCC+wJi4UuIjyDcRGYRrGxExMJuUVBsxex6UpiYBJK7RUDITH7wFTtzduD7xwwzgiRecRyH+/0eOkESQgjUajVEUQSS4nVOkESlUuFms8F2u8V8Pv/fWj+W0+kE3/ev3ySF7Xkei8UilFIYjUYoFArXyOhEGIaczWY4HA5otVqXwXK5zNVqxU6nQ5LQ3cbjMQFcLAgCPjz8Y9ZPOtl6vWYQBJQA8Pg4/rpeNGS5XAIA5GQyyZDqh5QC5/MZ0rKsLK12SGkhSRJI27aztNohpUSapmY6b1nS5My/lL2JPW985n973kTnf3ve5Mwb2/NxHL+V/d3dnyy9dhhb9sA755MkydJqR5qmkNPpFE9PZjnv+z7y+TxsALi//5ul14YwDOm6LlzXhQDAfr+P3W6Hdrut5eXlexaLBavVKjzPuzgPAMPh8HptrWMQwjBko9FAvV6H4zhQSgmbpBBCsNvtIooi9Ho9HI/Ht5eMG3CLU2YcxyiVSsjlclBKCQCXnufLK4YQgoPBAM1m89MFyK9j8t25W2y5cRx/qOhnMUYr3zSALPsAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 292.5,
    y: 75.48,
    width: 6.17,
    height: 3.24,
    rx: 0.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 292.59,
    y: 75.52,
    width: 6.01,
    height: 3.13,
    rx: 0.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: 292.68,
    y: 75.55,
    width: 5.85,
    height: 3.02,
    rx: 0.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-185",
    x: 292.78,
    y: 75.59,
    width: 5.68,
    height: 2.91,
    rx: 0.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 292.87,
    y: 75.62,
    width: 5.52,
    height: 2.8,
    rx: 0.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-187",
    x: 292.96,
    y: 75.66,
    width: 5.35,
    height: 2.69,
    rx: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-188",
    x: 293.05,
    y: 75.69,
    width: 5.19,
    height: 2.58,
    rx: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-189",
    x: 293.14,
    y: 75.73,
    width: 5.02,
    height: 2.47,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-190",
    x: 293.24,
    y: 75.76,
    width: 4.86,
    height: 2.36,
    rx: 0.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 293.33,
    y: 75.8,
    width: 4.69,
    height: 2.25,
    rx: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-192",
    x: 293.42,
    y: 75.83,
    width: 4.53,
    height: 2.14,
    rx: 0.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 293.51,
    y: 75.87,
    width: 4.36,
    height: 2.03,
    rx: 0.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-194",
    x: 292.7,
    y: 75.57,
    width: 5.64,
    height: 2.71,
    rx: 0.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-195",
    x: 292.72,
    y: 75.58,
    width: 5.61,
    height: 2.63,
    rx: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 292.74,
    y: 75.59,
    width: 5.57,
    height: 2.55,
    rx: 0.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 292.75,
    y: 75.59,
    width: 5.54,
    height: 2.46,
    rx: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 292.77,
    y: 75.6,
    width: 5.5,
    height: 2.38,
    rx: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-199",
    x: 292.79,
    y: 75.61,
    width: 5.47,
    height: 2.3,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 292.81,
    y: 75.61,
    width: 5.43,
    height: 2.22,
    rx: 0.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 292.82,
    y: 75.62,
    width: 5.4,
    height: 2.14,
    rx: 0.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-202",
    x: 292.84,
    y: 75.63,
    width: 5.37,
    height: 2.05,
    rx: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-203",
    x: 292.86,
    y: 75.64,
    width: 5.33,
    height: 1.97,
    rx: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-204",
    x: 292.87,
    y: 75.64,
    width: 5.3,
    height: 1.89,
    rx: 0.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-205",
    x: 292.89,
    y: 75.65,
    width: 5.26,
    height: 1.81,
    rx: 0.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 292.91,
    y: 75.66,
    width: 5.23,
    height: 1.73,
    rx: 0.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 292.93,
    y: 75.66,
    width: 5.19,
    height: 1.64,
    rx: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-208",
    x: 292.94,
    y: 75.67,
    width: 5.16,
    height: 1.56,
    rx: 0.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 292.96,
    y: 75.68,
    width: 5.12,
    height: 1.48,
    rx: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-210",
    x: 292.98,
    y: 75.68,
    width: 5.09,
    height: 1.4,
    rx: 0.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    x: 293,
    y: 75.69,
    width: 5.06,
    height: 1.32,
    rx: 0.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-212",
    x: 293.01,
    y: 75.7,
    width: 5.02,
    height: 1.23,
    rx: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 293.03,
    y: 75.7,
    width: 4.99,
    height: 1.15,
    rx: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-214",
    x: 293.05,
    y: 75.71,
    width: 4.95,
    height: 1.07,
    rx: 0.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-215",
    x: 293.06,
    y: 75.72,
    width: 4.92,
    height: 0.99,
    rx: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M293.15,76a20.07,20.07,0,0,0,4.75.17c.19-.22.14-.46-.44-.49S293.12,75.71,293.15,76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-311",
    d: "M26.82,19.24a.47.47,0,0,1,.47-.47H248c4.32,0,5,.27,5.46.74l-2.78.86H27.29a.47.47,0,0,1-.47-.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-218",
    points: "258.38 20.73 254.55 20.73 288.48 55.59 293.6 55.76 258.38 20.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "259.32 21.64 257.04 19.37 253.21 19.37 288.48 55.59 289 55.61 255.93 21.77 259.32 21.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-312",
    points: "214.09 115.54 214.09 1.09 214.86 1.15 214.86 115.57 214.09 115.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-313",
    points: "213.33 115.57 213.33 1.03 214.09 1.09 214.09 115.54 213.33 115.57"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-314",
    x: 41.53,
    y: 64.18,
    width: 87.17,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-315",
    x: 41.53,
    y: 71.13,
    width: 87.17,
    height: 2.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-316",
    points: "128.7 115.27 128.7 0.58 129.47 0.58 129.47 115.25 128.7 115.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-317",
    points: "127.93 115.23 127.93 0.58 128.7 0.58 128.7 115.27 127.93 115.23"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-318",
    x: -15.26,
    y: 57.4,
    width: 114.4,
    height: 0.77,
    transform: "translate(-15.84 99.72) rotate(-90)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-319",
    points: "40.79 114.59 40.79 0.58 41.56 0.58 41.56 114.98 40.79 114.59"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-320",
    x: 42.68,
    y: 67.7,
    width: 86.02,
    height: 2.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-321",
    x: 41.53,
    y: 66.78,
    width: 3.7,
    height: 4.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-322",
    d: "M125.93,66.78h2.77a0,0,0,0,1,0,0v4.35a0,0,0,0,1,0,0h-2.77a.93.93,0,0,1-.93-.93V67.71A.93.93,0,0,1,125.93,66.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M380.14,314.65c4.22,4.79,32,2.78,51.55,2.78s53.57,1.28,56.5-4.33-17.59-25.82-22.9-28.44-55.63-4-61-.73S376.06,310,380.14,314.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-323",
    d: "M380.27,314.6c4.17,4.76,32,2.74,51.43,2.74s53.48,1.32,56.38-4.26-17.61-25.73-22.9-28.34-55.42-4-60.74-.73S376.25,310,380.27,314.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-324",
    d: "M380.41,314.55c4.11,4.73,31.93,2.7,51.3,2.7s53.4,1.35,56.25-4.18-17.62-25.65-22.9-28.25-55.21-3.95-60.5-.73S376.44,310,380.41,314.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-325",
    d: "M380.54,314.51c4.06,4.68,31.88,2.66,51.18,2.66s53.31,1.38,56.13-4.12S470.2,287.49,465,284.9s-55-3.94-60.28-.72S376.63,310,380.54,314.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-326",
    d: "M380.68,314.46c4,4.65,31.83,2.62,51,2.62s53.23,1.42,56-4.05-17.66-25.47-22.9-28-54.79-3.92-60-.72S376.82,309.94,380.68,314.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-327",
    d: "M380.81,314.41c3.94,4.62,31.78,2.58,50.92,2.58s53.15,1.45,55.88-4-17.68-25.39-22.89-28-54.58-3.91-59.82-.72S377,309.92,380.81,314.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-328",
    d: "M380.94,314.36c3.89,4.58,31.73,2.54,50.8,2.54s53.06,1.49,55.76-3.9-17.7-25.3-22.89-27.86-54.38-3.9-59.59-.72S377.2,309.9,380.94,314.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-329",
    d: "M381.08,314.31c3.81,4.56,31.67,2.51,50.67,2.51s53,1.52,55.63-3.83-17.72-25.22-22.89-27.77-54.17-3.88-59.36-.72S377.38,309.89,381.08,314.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-330",
    d: "M381.21,314.26c3.76,4.52,31.63,2.47,50.55,2.47s52.89,1.55,55.51-3.76-17.74-25.13-22.89-27.67-54-3.87-59.14-.71S377.56,309.87,381.21,314.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-331",
    d: "M381.35,314.21c3.7,4.49,31.57,2.43,50.42,2.43s52.8,1.59,55.38-3.69-17.76-25-22.89-27.57-53.75-3.85-58.9-.71S377.75,309.85,381.35,314.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-332",
    d: "M381.48,314.17c3.64,4.45,31.52,2.38,50.3,2.38s52.72,1.63,55.25-3.61-17.77-25-22.88-27.48-53.54-3.84-58.68-.71S377.94,309.83,381.48,314.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-333",
    d: "M381.62,314.12c3.58,4.42,31.46,2.35,50.17,2.35s52.63,1.65,55.13-3.55S469.13,288.05,464,285.54s-53.33-3.82-58.44-.71S378.12,309.81,381.62,314.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-334",
    d: "M381.75,314.07c3.52,4.38,31.41,2.31,50.05,2.31s52.55,1.69,55-3.48S469,288.12,463.92,285.61s-53.12-3.8-58.22-.69S378.31,309.79,381.75,314.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-335",
    d: "M381.88,314c3.47,4.35,31.37,2.27,49.92,2.27s52.47,1.73,54.89-3.4-17.83-24.7-22.89-27.2-52.91-3.78-58-.69S378.5,309.77,381.88,314Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M382,314c3.41,4.32,31.31,2.23,49.79,2.23s52.39,1.76,54.76-3.33-17.85-24.61-22.88-27.1-52.7-3.77-57.76-.69S378.69,309.75,382,314Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-336",
    d: "M382.15,313.92c3.35,4.29,31.26,2.2,49.67,2.2s52.3,1.79,54.63-3.26-17.86-24.53-22.87-27-52.5-3.76-57.53-.69S378.87,309.73,382.15,313.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-337",
    d: "M382.29,313.88c3.29,4.24,31.2,2.15,49.54,2.15s52.21,1.83,54.51-3.19-17.89-24.44-22.88-26.91-52.29-3.74-57.3-.69S379.06,309.71,382.29,313.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-338",
    d: "M382.42,313.83c3.23,4.21,31.15,2.11,49.42,2.11s52.13,1.86,54.38-3.12-17.9-24.36-22.87-26.81-52.08-3.73-57.08-.68S379.25,309.69,382.42,313.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-339",
    d: "M382.56,313.78c3.17,4.18,31.1,2.07,49.29,2.07s52,1.9,54.25-3-17.91-24.28-22.87-26.72-51.87-3.71-56.84-.68S379.43,309.67,382.56,313.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-340",
    d: "M382.69,313.73c3.12,4.14,31.05,2,49.17,2s52,1.93,54.13-3-17.94-24.19-22.87-26.62-51.66-3.7-56.62-.68S379.62,309.65,382.69,313.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-341",
    d: "M382.82,313.68c3.06,4.11,31,2,49.05,2s51.87,2,54-2.9S467.92,288.67,463,286.25s-51.45-3.68-56.38-.68S379.81,309.63,382.82,313.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-342",
    d: "M383,313.63c3,4.08,30.94,2,48.92,2s51.78,2,53.88-2.83-18-24-22.87-26.43-51.24-3.67-56.16-.68S380,309.61,383,313.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-343",
    d: "M383.09,313.58c2.94,4.05,30.9,1.92,48.79,1.92s51.71,2,53.76-2.76-18-23.93-22.86-26.33-51-3.66-55.93-.67S380.18,309.59,383.09,313.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-344",
    d: "M383.23,313.54c2.88,4,30.84,1.87,48.66,1.87s51.62,2.07,53.63-2.68-18-23.85-22.86-26.24-50.82-3.64-55.7-.67S380.37,309.57,383.23,313.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-345",
    d: "M383.36,313.49c2.83,4,30.79,1.84,48.54,1.84s51.54,2.1,53.51-2.62-18-23.76-22.86-26.14-50.62-3.63-55.47-.67S380.56,309.55,383.36,313.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-346",
    d: "M383.5,313.44c2.76,3.94,30.73,1.8,48.41,1.8s51.45,2.13,53.38-2.55-18.05-23.67-22.86-26S412,283,407.19,286,380.75,309.53,383.5,313.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-347",
    d: "M383.63,313.39c2.71,3.9,30.68,1.76,48.29,1.76s51.37,2.17,53.26-2.47-18.07-23.59-22.86-25.95-50.2-3.6-55-.66S380.93,309.51,383.63,313.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M383.76,313.34c2.65,3.87,30.64,1.72,48.17,1.72s51.28,2.21,53.13-2.4S467,289.16,462.2,286.81s-50-3.58-54.78-.66S381.12,309.49,383.76,313.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-349",
    d: "M383.9,313.29c2.59,3.84,30.58,1.69,48,1.69s51.19,2.23,53-2.33-18.1-23.42-22.85-25.76-49.78-3.57-54.56-.66S381.31,309.46,383.9,313.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-350",
    d: "M384,313.25c2.54,3.79,30.53,1.64,47.92,1.64s51.11,2.27,52.88-2.26S466.71,289.3,462,287s-49.57-3.54-54.32-.65S381.5,309.44,384,313.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-351",
    d: "M384.17,313.2c2.47,3.76,30.47,1.6,47.79,1.6s51,2.31,52.75-2.19S466.57,289.37,461.86,287s-49.36-3.53-54.1-.65S381.68,309.42,384.17,313.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-352",
    d: "M384.3,313.15c2.42,3.73,30.42,1.56,47.66,1.56s51,2.34,52.64-2.11-18.16-23.16-22.85-25.48-49.16-3.52-53.87-.64S381.87,309.4,384.3,313.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-353",
    d: "M384.44,313.1c2.36,3.69,30.37,1.53,47.53,1.53s50.86,2.37,52.51-2.05-18.18-23.07-22.85-25.38-48.94-3.5-53.64-.64S382.06,309.38,384.44,313.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-354",
    d: "M384.57,313.05c2.3,3.66,30.32,1.49,47.41,1.49s50.77,2.41,52.38-2-18.19-23-22.84-25.28-48.74-3.49-53.41-.64S382.25,309.36,384.57,313.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-355",
    d: "M384.7,313c2.25,3.63,30.27,1.45,47.29,1.45s50.69,2.44,52.26-1.9S466,289.65,461.4,287.36s-48.53-3.47-53.18-.64S382.43,309.34,384.7,313Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-356",
    d: "M384.84,313c2.19,3.59,30.21,1.41,47.16,1.41s50.6,2.48,52.13-1.83-18.23-22.81-22.84-25.09-48.32-3.46-53-.63S382.62,309.32,384.84,313Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-357",
    d: "M385,312.91c2.13,3.55,30.17,1.37,47,1.37s50.52,2.51,52-1.76-18.24-22.73-22.84-25-48.11-3.44-52.72-.63S382.81,309.3,385,312.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-358",
    d: "M385.11,312.86c2.07,3.51,30.11,1.33,46.91,1.33s50.43,2.54,51.88-1.69-18.27-22.64-22.84-24.9-47.9-3.43-52.5-.63S383,309.28,385.11,312.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-359",
    d: "M385.24,312.81c2,3.48,30.06,1.29,46.79,1.29s50.35,2.58,51.75-1.62-18.28-22.55-22.84-24.8-47.69-3.42-52.26-.63S383.19,309.26,385.24,312.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-360",
    d: "M385.38,312.76c1.95,3.45,30,1.25,46.66,1.25s50.26,2.62,51.63-1.54S465.36,290,460.83,287.76s-47.48-3.4-52-.63S383.37,309.23,385.38,312.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-361",
    d: "M385.51,312.71c1.9,3.41,29.95,1.22,46.53,1.22s50.18,2.64,51.51-1.48-18.32-22.39-22.83-24.61-47.28-3.39-51.81-.62S383.56,309.21,385.51,312.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-362",
    d: "M385.64,312.66c1.85,3.38,29.91,1.18,46.41,1.18s50.1,2.68,51.38-1.41-18.34-22.3-22.83-24.51-47.07-3.37-51.58-.62S383.75,309.19,385.64,312.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-363",
    d: "M385.78,312.62c1.78,3.33,29.85,1.13,46.28,1.13s50,2.72,51.26-1.33S465,290.2,460.49,288s-46.86-3.36-51.35-.62S383.94,309.17,385.78,312.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-364",
    d: "M385.91,312.57c1.73,3.3,29.8,1.09,46.16,1.09s49.93,2.75,51.13-1.26-18.37-22.13-22.83-24.32-46.65-3.34-51.12-.62S384.13,309.15,385.91,312.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-365",
    d: "M386.05,312.52c1.67,3.27,29.74,1.06,46,1.06s49.84,2.78,51-1.19-18.4-22.05-22.83-24.23-46.44-3.33-50.9-.62S384.31,309.13,386.05,312.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-366",
    d: "M386.18,312.47c1.61,3.23,29.69,1,45.91,1s49.75,2.81,50.88-1.12-18.41-22-22.83-24.13-46.23-3.31-50.66-.61S384.5,309.11,386.18,312.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-367",
    d: "M386.32,312.42c1.55,3.2,29.64,1,45.78,1s49.67,2.85,50.75-1-18.43-21.87-22.82-24-46-3.29-50.44-.6S384.69,309.08,386.32,312.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-368",
    d: "M386.45,312.37c1.5,3.16,29.59.94,45.66.94s49.58,2.89,50.63-1-18.45-21.79-22.83-23.95-45.81-3.28-50.2-.6S384.88,309.06,386.45,312.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-369",
    d: "M386.58,312.32c1.45,3.13,29.54.9,45.54.9s49.5,2.92,50.5-.9-18.47-21.7-22.82-23.85-45.6-3.26-50-.6S385.07,309,386.58,312.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M386.72,312.28c1.38,3.08,29.48.86,45.4.86s49.42,2.95,50.39-.83S464,290.69,459.69,288.55s-45.4-3.25-49.75-.59S385.26,309,386.72,312.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-371",
    d: "M386.85,312.23c1.33,3,29.44.82,45.28.82s49.34,3,50.26-.76-18.5-21.53-22.82-23.66-45.19-3.23-49.52-.59S385.45,309,386.85,312.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-372",
    d: "M387,312.18c1.27,3,29.38.78,45.15.78s49.25,3,50.13-.69-18.52-21.44-22.81-23.56-45-3.22-49.29-.59S385.64,309,387,312.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-373",
    d: "M387.12,312.13c1.22,3,29.33.74,45,.74s49.16,3.06,50-.61-18.54-21.36-22.82-23.47-44.77-3.2-49.06-.59S385.83,309,387.12,312.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-374",
    d: "M387.26,312.08c1.16,2.95,29.27.71,44.9.71s49.08,3.09,49.88-.55S463.48,291,459.23,288.87s-44.56-3.19-48.84-.59S386,308.93,387.26,312.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M387.39,312c1.1,2.91,29.22.67,44.78.67s49,3.12,49.75-.48S463.35,291,459.11,289s-44.35-3.18-48.6-.58S386.2,308.91,387.39,312Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-376",
    d: "M387.52,312c1.05,2.87,29.18.62,44.66.62s48.91,3.16,49.63-.4S463.21,291.11,459,289s-44.14-3.16-48.38-.58S386.39,308.89,387.52,312Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-377",
    d: "M387.66,311.94c1,2.83,29.12.58,44.53.58s48.82,3.2,49.5-.33-18.61-21-22.81-23.08S415,286,410.74,288.53,386.58,308.87,387.66,311.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-378",
    d: "M387.79,311.89c.94,2.8,29.07.55,44.41.55s48.73,3.22,49.38-.26-18.64-20.93-22.81-23-43.72-3.13-47.92-.58S386.77,308.84,387.79,311.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-379",
    d: "M387.93,311.84c.88,2.76,29,.51,44.27.51s48.66,3.26,49.26-.19-18.65-20.84-22.8-22.89-43.52-3.12-47.69-.58S387,308.82,387.93,311.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-380",
    d: "M388.06,311.79c.83,2.73,29,.47,44.15.47s48.57,3.3,49.13-.12-18.66-20.75-22.8-22.79-43.31-3.1-47.46-.57S387.15,308.8,388.06,311.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-381",
    d: "M388.2,311.74c.77,2.69,28.91.43,44,.43s48.49,3.33,49,0-18.69-20.67-22.8-22.7-43.1-3.09-47.23-.57S387.34,308.78,388.2,311.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-382",
    d: "M388.33,311.69c.72,2.66,28.86.4,43.9.4s48.4,3.36,48.88,0-18.7-20.58-22.8-22.6-42.89-3.07-47-.57S387.54,308.75,388.33,311.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-383",
    d: "M388.46,311.65c.67,2.61,28.81.35,43.78.35s48.32,3.4,48.76.09-18.73-20.49-22.8-22.5-42.68-3.06-46.78-.57S387.73,308.73,388.46,311.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-384",
    d: "M388.6,311.6c.61,2.58,28.75.31,43.65.31s48.23,3.43,48.63.17-18.74-20.41-22.8-22.42-42.47-3-46.54-.55S387.92,308.71,388.6,311.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-385",
    d: "M388.73,311.55c.56,2.54,28.71.27,43.53.27s48.14,3.47,48.5.24S462,291.73,458,289.74s-42.26-3-46.32-.55S388.11,308.69,388.73,311.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-386",
    d: "M388.87,311.5c.5,2.51,28.65.24,43.4.24s48.06,3.5,48.38.31-18.78-20.25-22.8-22.23-42.05-3-46.08-.55S388.3,308.67,388.87,311.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-387",
    d: "M389,311.45c.45,2.47,28.6.2,43.28.2s48,3.53,48.25.38-18.79-20.16-22.79-22.13-41.85-3-45.86-.55S388.49,308.64,389,311.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-388",
    d: "M389.14,311.4c.39,2.44,28.54.16,43.14.16s47.9,3.57,48.14.45-18.82-20.07-22.79-22S416,287,412,289.43,388.69,308.62,389.14,311.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-389",
    d: "M389.27,311.36c.34,2.39,28.49.11,43,.11s47.81,3.6,48,.53-18.83-20-22.79-21.94-41.43-3-45.4-.54S388.88,308.6,389.27,311.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-390",
    d: "M389.4,311.31c.29,2.36,28.45.08,42.9.08S480,315,480.18,312s-18.85-19.9-22.78-21.84-41.22-2.95-45.18-.54S389.07,308.58,389.4,311.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-391",
    d: "M389.54,311.26c.24,2.32,28.39,0,42.77,0S480,315,480.07,312s-18.87-19.82-22.79-21.75-41-2.94-44.94-.54S389.27,308.55,389.54,311.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-392",
    d: "M389.67,311.21c.18,2.29,28.34,0,42.65,0s47.55,3.7,47.63.74-18.89-19.73-22.78-21.65-40.8-2.92-44.72-.54S389.46,308.53,389.67,311.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-393",
    d: "M381.13,312c0,1.38,6.14,2.5,13.71,2.5s13.7-1.12,13.7-2.5-6.14-2.51-13.7-2.51S381.13,310.57,381.13,312Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-394",
    d: "M459.58,312c0,1.38,6.14,2.5,13.71,2.5S487,313.33,487,312s-6.14-2.51-13.7-2.51S459.58,310.57,459.58,312Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-395",
    points: "447.6 298.62 419.09 298.62 406.89 296.81 459.8 296.81 447.6 298.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-396",
    d: "M467.82,293.85H480a0,0,0,0,1,0,0v16.66a1.77,1.77,0,0,1-1.77,1.77h-8.62a1.77,1.77,0,0,1-1.77-1.77V293.85A0,0,0,0,1,467.82,293.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-395",
    d: "M481.91,303H467.07c-.16,0-.3-.07-.31-.17l-1.19-7h16.66v6.94C482.23,303,482.09,303,481.91,303Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-397",
    d: "M389,293.85H401.2a0,0,0,0,1,0,0v16.66a1.77,1.77,0,0,1-1.77,1.77h-8.62a1.77,1.77,0,0,1-1.77-1.77V293.85A0,0,0,0,1,389,293.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-395",
    d: "M401.73,303H386.88c-.17,0-.31-.08-.31-.19V295.9h16.66l-1.19,7C402,303,401.89,303,401.73,303Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-398",
    d: "M483,250.75a276.86,276.86,0,0,0-8.83-62.65,6.26,6.26,0,0,0-5.82-4.58s-13.65-1.18-35.08-1.18c-23.78,0-35.08,1.18-35.08,1.18a6.25,6.25,0,0,0-5.81,4.58,276.28,276.28,0,0,0-8.83,62.65c-.87,35.54,3.13,45.68,3.13,45.68h93.19S483.88,286.29,483,250.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-399",
    d: "M397.84,183.57a6.21,6.21,0,0,0-5.45,4.53,276.28,276.28,0,0,0-8.83,62.65c-.46,18.49.41,30.08,1.34,37h12.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-400",
    d: "M474.32,188.1a6.23,6.23,0,0,0-5.22-4.51V287.72h12.71c.93-6.89,1.8-18.48,1.34-37A276.28,276.28,0,0,0,474.32,188.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-401",
    points: "433.28 283.31 389.46 283.31 389.46 296.75 433.28 296.75 477.1 296.75 477.1 283.31 433.28 283.31"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-74",
    width: 44,
    height: 99,
    transform: "translate(390.29 185.15)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAABjCAYAAADgiuK4AAAACXBIWXMAAAsSAAALEgHS3X78AAAE7UlEQVR4XtWcT2gcVRzHv+/tzOymMdkm2c2fTUqbQPEgVBEqlByUUmj9gwoFEYUeRPHQY0qLVHNYG5uKoB48CUIPKioeCh4Uby0FTzXVi8klNiTd/NnNJvt3tjO7z8PuTmY3b2ZEIfN7HwKzvPnO8OXl937z29+8hAkh8F9Ip9OCMYAxBgYGMIZIJAIGIN5/GIZuAGBgDIjFDoEBABhisRi0SASmWUOxWECtVkO90UBuO4eaacK2bdi2jWwuC8u2YJomTLOK/M5O8w5Bht94/U0xEDcwfeokEolBRA0D9XoDAgKtH1QqJgQAIQSatxPO591iGUIINBoCDSGcz3vHRnNcdt41nhoZxMzlq9D8zMbj/WJm5hIAwLQEfru35Cf/38zOzjKvc199+YUA4G346pX3xY3rH8LQNbz1zkXPGx0U7UDgXoIbn1yHoWtYzeS8JKHgafjdty9gNZPz/TUdLAIMHobT6bQ4/+qLslOhIzV87MgkMpvbslOh0Y5h6aJb/GsR0V5Ddip0pDN88+ubAPzTzMHTnGL5ohO2dDhM2o83qeHXzr8sGw4Xrzw8d+2aeOHcme5hMuwzPHXsOFbWNmVaEuwzvJvfkelCR3gtutt3bxN7wrXwiuFvv/ume4gU+wyPp0ZlutDxTGuvvHSue4gU+ww/f/a0TBc+QrLoPv/0M9FoSOVk6DA8nBxDNl/AoR56hU87hjuqtd38DiqPyqhUH0kuoUHHDN/66RZKZZNeDgbkefiXX3+WSUkgfdJNTR6ViinRYfjsmec8ZHToMHz62WkvXfh0x/D8/LzQjaiXPHT2PZqPTkwimy8gOdjvcUnYCABsz3B2awuWXcfWdsHnovBxDN+5ewcbWzs0czAkvbUffvzeS0sH5jI8nhrzk5LBMZwYGsDE2JCfNlREd3k5feoZcq1VGS7DJ/10JHDarel0WoyODAfIacABYCA+gFK5GqQNlY60pus6dksVPz0BXItudDgFy7IRi+q+l1BAA4D1TAZls4TLV94j+ZQDuoqfhT8WUK7WfOQEcMfw/T/v+0lJwQFgaWkxSEcA16IrlYq+Ugp0xHAySbeGcHDH8JGJlJ+UFBwAnn7qRJAudDr6Eo8fn/IVU4IDwJMnngjShU87hj+amxOWRe9Fohd8aDCJUsUM0oWOk9bifXHk8rS/2jdpLTotooMxsjXPHkFbaKjhdOB/X7hHdm+EDL78YBkAtb0R3vBCQYUFh73XXg8frgUoaeCktfWNdV8hNXhmPUO6RdUN7+npUaJF5fQlYlFVUlpr0XEeUSYkGkKAjwwPKRESbbiu0+/2AK4Yfqy3119JDD46qkab1Vl0lmUFCGngPOkmxlNqZAl3PbyZpbm5TgYHAE2LBOnIwA/H+5Uw7DRSLNuCroBhJ4aTiSFoEQUMt+CMMWia7x/MkMBJa0IIqPAtvyOtqVH8dL1rVgVeLlN/odjEiWHbrvsKydCOYbuuSqu1FcOqzLArJFSZ4SbKzLATw8t/r0CLqJPdWvsl6NcSTrVWLJWUqCXa8LW1dbXKy2KpBF2nP8NOWiuXK9jYUug7Xa1GfCeKQ2vRJRLJACER2jHc19fnLySCE8OGoUp/uIlyhjVDj6KwncHHcx8IwP3/IeBsgfU7NuWSo/s+EMC/Ofrdr+kXGo9wVKsmHqysghqc85bZ9gQA/wDU9Am4A0aXlwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-74",
    width: 37,
    height: 43,
    transform: "translate(393.29 203.15)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAArCAYAAAD/lEFzAAAACXBIWXMAAAsSAAALEgHS3X78AAACTklEQVRYR82Yv2/aQBTHv3cMJVBYMBZGZgJ3QKlgyHbN3gz8E+nUqJlTKgUJ08zNP9Go2ZopHZCYYUPeQEKCDYmJCUvoXgewY1MipDSy7ys9yfZ7Z398v579GBFhn2zbprOzj7Csd1gsFiAi36SUofOXWD6fh6ZpGI9H6Ha7aDa/Me/ZbB/UcDiker2O8XiM5XKJ1WqF3bjg+Ut9tVoNjUYDk8kEDw+/8fj4B61Wi/3zBoNBn4QQtGl/+I1fwwzDICEEOY5DRISQs9OxCUCkQJ7V63XSdZ1ub3+EHXd3P0kIETmQZ0IIcl2XeHC8DaOIOOW6LkzTDE/0RCJB25Xlr4SoJYQI9xTnPFYgAJBSwoeybZs4DzHGohAUsOmpuBWCymTeqgfFOVcPStd19aCKxaJ6UKlUSj2o4+P36kE1m01loPw0YxgGSSkxn89j3dEty3pKM5zz2IGAwPCpkmKAAFQy+UaJ+QQEoIhIPah0Oq0eVC6XUw8qk8moB1Uul9WDMk1TPajr65Z6UL1e71BsZPKhOOdwHCf2FANsoW5uviuTYoAtlEq7ObAzfKpISgmezWbVg1LlL8aTP6cYU2LhAQjMqX6/fyg2EjHGSAgBvl6vUSqVDsVHppOTE/DpdIrZbAbLsvaXiSPW6emHzVfnaDSiSqUSS63TMwRqrRwA7u9/4fLyC4QQ0DQt0h5jjBFjjACg3W5vrm0p0enYVCgUcH7+CdVqFRcXn0ONvbjd4//1XV19xWDQf6qh45nivm3bdHSUfPaGr3EcfKwH4+kvJjkJTWClFjIAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-74",
    width: 32,
    height: 37,
    transform: "translate(396.29 206.15)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAlCAYAAAAjt+tHAAAACXBIWXMAAAsSAAALEgHS3X78AAABtklEQVRYR82YsU7CUBiFz18LSJvQ8AzohAM7DCw8BC44iwnOmHS4Ccz6EvIaDEy42J2FFSZYAFP7O2Brb2ghxPaWL2nS3P8M557enNyUmBk+Qgi2rBJyuRweH7uEhBmN3rlcLmM6/YCuX6HffyEtStjtPkUt/5t2+546nQdYVgmu+w0AID8Bf/e93nPiO4/i7e2VV6s1IhNQiWQgfB5UQIQLS8A0zThdKhCRbKBavYvTpoZkoFKpxOlS4SCB2WwWp00NyUC9XlfSAT4HCWRBpgaCBIQQbBjFU/pUCBJQ3YLApZ2BfD5/TJc42+1WTsAwjGP6xCEi7HZffwZqtdoxfWoEBm5ubo/pEodo33mBgfl8HitOk/AnUF7DQMZNCGRoIEhACMG6fnVCnh7ZJwCovwuGuYwEVNdwGA3IpoalBFTXcBgNABzHOaVLHCmBZrOptIbDaJZVwng8Vn8f+0XzPA+O83lKlyjL5ZJd14Vt26RvNhuYponhcMCtVgsAsL+fsvQetXbuvFi8xmQyQaFQgK7rAEJ/SIbDATcaDTCz9Hie/+6dNfub+zOA2cNiscBqtYZt2wQAP5cVx3s/BRwyAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-395",
    x: 388.02,
    y: 200.53,
    width: 7.26,
    height: 1.84,
    rx: 0.65
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-121",
    width: 10,
    height: 24,
    transform: "translate(382.29 249.15)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAYCAYAAADDLGwtAAAACXBIWXMAAAsSAAALEgHS3X78AAAAx0lEQVQoU8XTMW7CMBSH8c8vLDDBnlOkl6DHKAfJkEtkIycp9yhSssCWNQMo1vt3qIKgihRvfJvtnyxZeg6S6PteTXPkdrsz1+HwxUqS6rqeBVOXy5XV80ZZluF5XVWVAGKMWAgvZ7PFGLElNJUEN5t1GgSw8/lnyQBgZtmSAcCy7B3QXWlwHMd3QUh8zG63TYOQeGNRfKTB0+kbM0sboJevMI3+/yRhIYSQ5/nc+aP9/vNPS2IYBrm7uq6Tu6ttW7m73F2S+AWRZVuzAuTFjgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 382.95,
    y: 250.1,
    width: 8.03,
    height: 21.33,
    rx: 1.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 382.95,
    y: 250.1,
    width: 8.03,
    height: 21.33,
    rx: 1.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M390.38,267.43a2.75,2.75,0,1,0-2.75,2.64A2.69,2.69,0,0,0,390.38,267.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-402",
    d: "M390.38,260.69a2.75,2.75,0,1,0-2.75,2.64A2.7,2.7,0,0,0,390.38,260.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M390.38,254a2.75,2.75,0,1,0-2.75,2.64A2.69,2.69,0,0,0,390.38,254Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-403",
    x: 387.23,
    y: 250.62,
    width: 3.75,
    height: 19.97,
    rx: 1.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M390.2,250.62h0a.72.72,0,0,1,.78.64v18.68a.72.72,0,0,1-.78.65h0a.73.73,0,0,1-.78-.65V251.26A.73.73,0,0,1,390.2,250.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M383.71,271.44H386a1,1,0,0,1-1.12-.94V251a1,1,0,0,1,1.12-.93h-2.3c-.42,0-.76.63-.76,1.4V270C383,270.81,383.29,271.44,383.71,271.44Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-404",
    x: 382.95,
    y: 257.55,
    width: 8.03,
    height: 6.44
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-405",
    points: "433.28 291.65 391.46 291.65 391.46 296.77 433.28 296.77 475.11 296.77 475.11 291.65 433.28 291.65"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-74",
    width: 44,
    height: 99,
    transform: "translate(432.29 185.15)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAABjCAYAAADgiuK4AAAACXBIWXMAAAsSAAALEgHS3X78AAAE50lEQVR4XtWcS2wTRxzGfzO7dl4lfsbkZUIQFYp45FgJ9SEkRJUUqeqtUi8VUlVUKIdeQBwsJRdKRW8lob1x6BWp9AxV1QpCSx9SqBqqpiRyiBPHTpSkTfxIdnpYe7ETO1xamPkka707Y+vbT99//v8Zz1qMXh1V6UyaZ41EIiGe1qcWbBR88fko8XgvAL17e73Gzo5OGvwN3nm8Ow5Ae3sHUkoc5Xht67l1KrG8sgRAoVhAOQ6OUjiOg+M4KOXw8aVLylHueTTcRjqTJhwMc/bc2R1vxFalN3fH7tTtODw8rADSS/NUHreiuyPivff7ykeLaCiEtCRCCKQQCCHw+2wsS5LP5wHBzZtfMzg4wLWRa+r0B6frkx75bER1dbQrpRTP8zU0NKSCwYD69MoVNXp1VNXrZ9e9k2eMRCIhGvy2uv/jzxzpP1S3nzaEAc5fuCiikYjqO3igbh8JUPaxDnjn7bewpOXFzVZIpRNb4OTgCaSUNDY01myXeukLydkFeuL76rbLui3PCafeOyMejI8jZW1q2hEGuP7ldSzLqtkmXUPoZYvNjcIOCusWdcCZ999FSllzpNDSEv39h7GkRSwa29amJeFff/uLUDDCQnZ7FaklYaXgwfg4gu01kFSaBRy4dcXtb28jRA3CKHQbJAAYu3e3DmFN0RPvrk9YQ4F5Y+B4bcI6kgV48+TrCCH45PLlKoraFT9l5PJFAq1Bcvl81XWpKV+mZxcItIZoaqwuM7UNug/PfSRmkkmEqKaoLWGAG1/d2BZ4pcShpy/u/TC2nXCdvlrgxf37ahDWU1wAjh97xSyFB04cQwhRVRdrOw4DOMpd1goFQ941N9Npyvn3P5O0RXZXXdPaEucvXBQPJyaqfCxR2goMwK1vbiEqdNVaYYDv73xXrbCOM45KHDnUt8USmuPloy+RWXwyGdWe8N6e7u1BpzP6Dx+sSh5aJw5wC3khBD6f+6OJtlOkMoqbm4SDEYrFIuB5WF/ayyv/EGgN4ff7AQOCbiaVpamxyQs8LVcvK5FIJMTk5OQTwnrTdfHTL/crFAadLQzAo6lH3sKgtis/lXj4xwSySmHNkcvlzAk6gEDrLrOCru/Afm9BxQhLvPbq0S2jhOboiXdVEtbfFHv2dHsVm/blJcDaWh4hBNFw1IygyyytEAqEgZKHbbv277q6YCaVobmpxd0zZIKHlVLMzaUIBsJ6baGpB6UgOZNkcSVjhocTiYRYW1/Dsiz9J6FlzKfnsSzbDA+DW2K6ChuChYW0WYRTqZRrCTMMAfl8juxixpyg8ze4u2yNCTp/abusMR5+oaUZS0pzPByNhM0aJVqam0uJw4BJKEAwGMA2SeHdsWg5NZsBn8/netgMQ4Bt22SXsiaOw2bwxedz5xrGeLgt6j4jYoyHyzBG4TKMCbquznbAoKB7PDsHmGgJQwT2YIyHV1f/BgyyhG2XE4cZAnsPohij8OPZFID+W2jKEEISi8bMUXhqOkk6kzaH8PLKKmBQ0GWzi4BBiWMhkwUMShybjvvQtzEeBswaJTaKm6VRwgxHEAgGXYVNSRyAWeNwYFcrYFDQ5QsFAMTw8JBqtIrMpzNP+ch/D7/fh7vhWrlHVTJojWMsFmV9w4etFExNz+z0vf8LmpoayecLHqny3zGUb8A9p9SumE9naA138C97fxp1kjFhBgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-74",
    width: 37,
    height: 43,
    transform: "translate(436.29 203.15)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAArCAYAAAD/lEFzAAAACXBIWXMAAAsSAAALEgHS3X78AAACdUlEQVRYR82Yv07bUBSHv+s/cYggrkWQwojkSnSjOyw8SBjpBh2glEqRMCCVIhUzlK1I8ACs9AXgFXiEIjEgQyQoRLkd6DW2E8rSmvObzrnnXPuXL9dX9lVaa4yiKNK+X6fVmuPs7IxGo4HWGq01vV4vjYv532q2bedqrutwfPyDSsVlZeWjYoAcY8Z1XWq1Wlq4u7vj4uIi15z9Adn4qZrrutzf3+eMTkxM4Pt1kuSK3d1YLyws9hlTWuscoSAIBrr/1zo//6mPjo7odDosL3/I3dOKokgDzM+/K80QQLM5rmZnZwHY2fmaw24BBMErqtVqaYaMJiffKM/zuL7u5MYtgKmptwMnlaFWa65vzPL9OjMzM6VTMlpbW0MV7m4Nbi1PcRz3AbGKj/ZLSCnFxsZ6auTFSQGMjIzQ6z3CEUGqKBGkihJBynVdHMdOcxGkgiDI5SJIhWGIymxWIkiF4etcLoLU8PCwPFJLS0u5XASpOI6VOFJG5t1OBClA3poyGhqqAoJIeZ7Hzc0tIIiUbdvySI2OjqbrSgypMAzTWAypZnNcHqmxsUYaiyG1vr4hj9Tm5ma6e4ohBQ+7ehRFWgyprMSRAkFrysj367JIVSoVQBgp81Vj1Wo1pqenReAKw5AkucJyHIetrc/P9Zei09NT4M/Td3Jy8kz7/9fl5eXjqcvi4nsFsLf37cX+QqWUPjw8IEmuaLfbygK4vf1FkiRsb3/RWcdlaH//u47jndyYMluC+ZLw/XquwdTN4fygGB7eHLN5cf6gmm3bdLtdut0uAKurnxRkTBlFUaSrVQ+l1JMXLMaO4zxrur/+ML/dbvcdL/4GW7pUMnOEq8UAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-74",
    width: 32,
    height: 37,
    transform: "translate(438.29 206.15)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAlCAYAAAAjt+tHAAAACXBIWXMAAAsSAAALEgHS3X78AAABm0lEQVRYR+WYMY7aQBiFv0FgW4JFQqaygMobkKhYiYYpNtfYVNmWW9hI2expOAU9FFxnXgoLK95sQgP+izxpPPPs0cznpxnbMpIoikLee02nUwGSxK2L917ee+12ZWP86gDy3t9tcknMZjN575WmaRPgcvfXBrhV+ThXBwPtdqUu7Q7A4XD4e+8bK4SAc672rScQQmA4HNbeBCDLstqbADw+fqm9CcBisai9CcB6va599x9976LT6dTwrScgyS2Xy9q3DgBwPp/rtgnA7zIDKMvqcWwGEMcRYAjQ7/cB6CRJfKXrfZSmKWCYQJ7nAHSk+tXcqlarJ8AwgclkAkDXIgFJzjlnuw0vMlsDF/3fCZRlKdMEHh4GtgnEcWy7BkajkW0CeZ7bJrBaPdkm0Ov12v8qvkiSe3//qa5VAM45ee+rNRBFEZvNpnWU/X6Pk8TxeNR2u+X19Tvz+ZwkSQghIKlRR1EMVJxVcs32Z+c+u/78/BWAoigqAIC3tx8aj8cMBgOyLGv81QhBRFHvD6CPdQhCul4DvLx8cwC/AKtxz6yUFRguAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-395",
    x: 471.29,
    y: 200.53,
    width: 7.26,
    height: 1.84,
    rx: 0.65,
    transform: "translate(949.83 402.9) rotate(180)"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-121",
    width: 10,
    height: 24,
    transform: "translate(474.29 249.15)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAYCAYAAADDLGwtAAAACXBIWXMAAAsSAAALEgHS3X78AAAAy0lEQVQoU7XSPQ6CQBAF4Le7JP5UEELHPfQ6ehAKLkGn19E7AIWGllBiIPMsDGoMcSDRV+5+mezLjrleLzwcjhjLcrnAbrdHFEXGVlU1igCgbW/Isgwk6YnweZEkiXmHaZoSAOq6hu37HlrCMJwGAcCu1yvNAACsBob8FuZ5Pg0CEyc652bA95/5Cruu09y/YBD4mpvZerPZau4Bz+eT5h6waRrNwTkHz/dfZYbV/4y1Vn9jHMcwxhiQhIhQRFgUBUWEZVlyOCMJkrgDAylfDgYWD9kAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 475.58,
    y: 250.1,
    width: 8.03,
    height: 21.33,
    rx: 1.02,
    transform: "translate(959.19 521.54) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 475.58,
    y: 250.1,
    width: 8.03,
    height: 21.33,
    rx: 1.02,
    transform: "translate(959.19 521.54) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M476.19,267.43a2.75,2.75,0,1,1,2.75,2.64A2.69,2.69,0,0,1,476.19,267.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-402",
    d: "M476.19,260.69a2.75,2.75,0,1,1,2.75,2.64A2.7,2.7,0,0,1,476.19,260.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M476.19,254a2.75,2.75,0,1,1,2.75,2.64A2.69,2.69,0,0,1,476.19,254Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-406",
    x: 475.58,
    y: 250.62,
    width: 3.75,
    height: 19.97,
    rx: 1.28,
    transform: "translate(954.91 521.21) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M476.36,250.62h0a.72.72,0,0,0-.78.64v18.68a.72.72,0,0,0,.78.65h0a.72.72,0,0,0,.78-.65V251.26A.72.72,0,0,0,476.36,250.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M482.86,271.44h-2.31a1,1,0,0,0,1.12-.94V251a1,1,0,0,0-1.12-.93h2.31c.41,0,.75.63.75,1.4V270C483.61,270.81,483.27,271.44,482.86,271.44Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-404",
    x: 475.58,
    y: 257.55,
    width: 8.03,
    height: 6.44,
    transform: "translate(959.19 521.54) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-407",
    d: "M420.08,250.62a2.2,2.2,0,1,0,2.2-2.2A2.2,2.2,0,0,0,420.08,250.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-408",
    d: "M417.77,251.38h8.42a.74.74,0,0,0,.74-.73h0a.74.74,0,0,0-.74-.74h-8.42a.74.74,0,0,0-.73.74h0A.73.73,0,0,0,417.77,251.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-409",
    d: "M446.35,250.62a2.2,2.2,0,1,1-2.2-2.2A2.2,2.2,0,0,1,446.35,250.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-410",
    d: "M448.66,251.38h-8.43a.73.73,0,0,1-.73-.73h0a.74.74,0,0,1,.73-.74h8.43a.74.74,0,0,1,.73.74h0A.73.73,0,0,1,448.66,251.38Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-411",
    x: 439.98,
    y: 272.1,
    width: 27.07,
    height: 6.29,
    rx: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-412",
    d: "M466.6,278.56H440.43a.62.62,0,0,1-.62-.62v-5.38a.62.62,0,0,1,.62-.62H466.6a.61.61,0,0,1,.61.62v5.38A.61.61,0,0,1,466.6,278.56Zm-26.17-6.29a.29.29,0,0,0-.29.29v5.38a.29.29,0,0,0,.29.29H466.6a.29.29,0,0,0,.28-.29v-5.38a.29.29,0,0,0-.28-.29Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-413",
    x: 391.46,
    y: 283.31,
    width: 5.63,
    height: 8.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-414",
    x: 469.55,
    y: 283.31,
    width: 5.63,
    height: 8.34,
    transform: "translate(944.74 574.96) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-415",
    d: "M392.31,296.73h-5.16a1.44,1.44,0,0,1-1.41-1.09,124.32,124.32,0,0,1-2.26-16.38.5.5,0,0,1,.51-.55h7.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-416",
    d: "M392.31,296.73h-5.16a1.44,1.44,0,0,1-1.41-1.09,124.32,124.32,0,0,1-2.26-16.38.5.5,0,0,1,.51-.55h7.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-417",
    d: "M474.26,296.73h5.15a1.43,1.43,0,0,0,1.41-1.09,124.73,124.73,0,0,0,2.27-16.38.52.52,0,0,0-.52-.55H475.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-418",
    d: "M474.26,296.73h5.15a1.43,1.43,0,0,0,1.41-1.09,124.73,124.73,0,0,0,2.27-16.38.52.52,0,0,0-.52-.55H475.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M379.6,132.65c4.23,4.79,32,2.78,51.55,2.78s53.57,1.28,56.51-4.33-17.59-25.82-22.91-28.44-55.62-4-61-.73S375.53,128,379.6,132.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-323",
    d: "M379.73,132.6c4.17,4.76,32,2.74,51.43,2.74s53.48,1.32,56.38-4.26-17.61-25.73-22.9-28.34-55.42-4-60.73-.73S375.71,128,379.73,132.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-324",
    d: "M379.87,132.55c4.11,4.73,31.93,2.7,51.3,2.7s53.4,1.35,56.25-4.18-17.62-25.65-22.89-28.25-55.22-3.95-60.51-.73S375.9,128,379.87,132.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-325",
    d: "M380,132.51c4.06,4.68,31.89,2.66,51.18,2.66s53.31,1.38,56.13-4.12-17.65-25.56-22.9-28.15-55-3.94-60.28-.72S376.09,128,380,132.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-326",
    d: "M380.14,132.46c4,4.65,31.83,2.62,51.05,2.62s53.23,1.42,56-4.05-17.66-25.47-22.89-28-54.8-3.92-60.05-.72S376.28,127.94,380.14,132.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-327",
    d: "M380.27,132.41c3.94,4.62,31.78,2.58,50.92,2.58s53.15,1.45,55.89-4-17.69-25.39-22.9-28-54.58-3.91-59.82-.72S376.47,127.92,380.27,132.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-328",
    d: "M380.41,132.36c3.88,4.58,31.72,2.54,50.79,2.54s53.06,1.49,55.76-3.9-17.7-25.3-22.89-27.86-54.38-3.89-59.59-.72S376.66,127.9,380.41,132.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-329",
    d: "M380.54,132.31c3.82,4.56,31.67,2.51,50.67,2.51s53,1.52,55.63-3.83S469.12,105.77,464,103.22s-54.16-3.88-59.36-.71S376.84,127.89,380.54,132.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-330",
    d: "M380.67,132.26c3.76,4.52,31.63,2.47,50.55,2.47s52.89,1.55,55.51-3.76S469,105.84,463.84,103.3s-54-3.87-59.13-.71S377,127.87,380.67,132.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-331",
    d: "M380.81,132.21c3.7,4.49,31.57,2.43,50.42,2.43S484,136.23,486.61,131s-17.75-25-22.89-27.57-53.74-3.85-58.9-.71S377.21,127.85,380.81,132.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-332",
    d: "M380.94,132.17c3.64,4.45,31.52,2.38,50.3,2.38s52.72,1.63,55.25-3.61-17.77-25-22.88-27.48-53.54-3.84-58.68-.71S377.4,127.83,380.94,132.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-333",
    d: "M381.08,132.12c3.58,4.42,31.46,2.35,50.17,2.35s52.63,1.65,55.13-3.55-17.79-24.87-22.88-27.38-53.34-3.82-58.45-.71S377.59,127.81,381.08,132.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-334",
    d: "M381.21,132.07c3.53,4.38,31.42,2.31,50.05,2.31s52.55,1.69,55-3.47-17.81-24.79-22.88-27.29-53.12-3.81-58.22-.7S377.77,127.79,381.21,132.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-335",
    d: "M381.35,132c3.46,4.35,31.36,2.27,49.92,2.27s52.46,1.73,54.88-3.4-17.83-24.7-22.88-27.2-52.92-3.78-58-.69S378,127.77,381.35,132Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M381.48,132c3.41,4.32,31.31,2.23,49.79,2.23S483.66,136,486,130.87s-17.85-24.61-22.88-27.1-52.7-3.77-57.76-.69S378.15,127.75,381.48,132Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-336",
    d: "M381.61,131.92c3.35,4.29,31.26,2.2,49.67,2.2s52.3,1.79,54.63-3.26-17.86-24.53-22.87-27-52.5-3.76-57.53-.69S378.33,127.73,381.61,131.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-337",
    d: "M381.75,131.88C385,136.12,413,134,431.29,134s52.22,1.83,54.51-3.19-17.88-24.44-22.88-26.91-52.28-3.74-57.3-.69S378.52,127.71,381.75,131.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-338",
    d: "M381.88,131.83c3.23,4.21,31.16,2.11,49.42,2.11s52.13,1.86,54.38-3.12-17.9-24.36-22.87-26.81-52.08-3.73-57.07-.68S378.71,127.69,381.88,131.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-339",
    d: "M382,131.78c3.17,4.18,31.1,2.07,49.29,2.07s52,1.9,54.26-3-17.92-24.28-22.88-26.72-51.87-3.71-56.84-.68S378.9,127.67,382,131.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-340",
    d: "M382.15,131.73c3.12,4.14,31.05,2,49.17,2s52,1.93,54.13-3-17.94-24.19-22.87-26.62-51.66-3.7-56.62-.68S379.08,127.65,382.15,131.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-341",
    d: "M382.29,131.68c3,4.11,31,2,49,2s51.87,2,54-2.9-17.95-24.11-22.86-26.53-51.46-3.68-56.39-.68S379.27,127.63,382.29,131.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-342",
    d: "M382.42,131.63c3,4.08,30.94,2,48.92,2s51.79,2,53.88-2.83-18-24-22.87-26.43-51.24-3.67-56.16-.67S379.46,127.61,382.42,131.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-343",
    d: "M382.55,131.59c2.94,4,30.9,1.91,48.8,1.91s51.7,2,53.75-2.76-18-23.93-22.86-26.33-51-3.65-55.93-.67S379.65,127.59,382.55,131.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-344",
    d: "M382.69,131.54c2.88,4,30.84,1.88,48.66,1.88S483,135.48,485,130.73s-18-23.85-22.87-26.24-50.82-3.64-55.7-.67S379.83,127.57,382.69,131.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-345",
    d: "M382.82,131.49c2.83,4,30.79,1.84,48.54,1.84s51.54,2.1,53.51-2.62S466.84,107,462,104.57s-50.62-3.63-55.47-.67S380,127.55,382.82,131.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-346",
    d: "M383,131.44c2.76,3.94,30.73,1.8,48.41,1.8s51.45,2.13,53.38-2.55-18-23.67-22.86-26-50.4-3.61-55.24-.67S380.21,127.53,383,131.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-347",
    d: "M383.09,131.39c2.71,3.9,30.69,1.76,48.29,1.76s51.37,2.17,53.26-2.47-18.07-23.59-22.86-25.95-50.2-3.6-55-.66S380.4,127.51,383.09,131.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M383.23,131.34c2.65,3.87,30.63,1.72,48.16,1.72s51.28,2.21,53.13-2.4-18.08-23.5-22.86-25.85-50-3.58-54.78-.66S380.58,127.49,383.23,131.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-349",
    d: "M383.36,131.29c2.59,3.84,30.58,1.69,48,1.69s51.2,2.23,53-2.33-18.1-23.42-22.85-25.76-49.78-3.57-54.56-.66S380.77,127.46,383.36,131.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-350",
    d: "M383.49,131.25c2.54,3.79,30.53,1.64,47.92,1.64s51.11,2.27,52.88-2.26S466.17,107.3,461.44,105s-49.58-3.55-54.33-.66S381,127.44,383.49,131.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-351",
    d: "M383.63,131.2c2.47,3.76,30.47,1.6,47.79,1.6s51,2.31,52.75-2.19S466,107.37,461.32,105s-49.36-3.53-54.1-.65S381.15,127.42,383.63,131.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-352",
    d: "M383.76,131.15c2.42,3.73,30.43,1.56,47.67,1.56s50.94,2.34,52.63-2.11-18.16-23.16-22.85-25.48-49.16-3.52-53.87-.64S381.33,127.4,383.76,131.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-353",
    d: "M383.9,131.1c2.36,3.69,30.37,1.53,47.53,1.53s50.86,2.37,52.51-2-18.17-23.07-22.85-25.38-48.94-3.5-53.64-.64S381.52,127.38,383.9,131.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-354",
    d: "M384,131.05c2.3,3.66,30.32,1.49,47.41,1.49s50.78,2.41,52.38-2-18.19-23-22.84-25.28-48.74-3.49-53.41-.64S381.71,127.36,384,131.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-355",
    d: "M384.17,131c2.24,3.63,30.26,1.45,47.28,1.45s50.69,2.44,52.26-1.9-18.21-22.9-22.85-25.19-48.52-3.47-53.18-.64S381.9,127.34,384.17,131Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-356",
    d: "M384.3,131c2.19,3.58,30.21,1.4,47.16,1.4s50.6,2.48,52.13-1.83-18.23-22.81-22.84-25.09-48.32-3.46-52.95-.63S382.08,127.32,384.3,131Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-357",
    d: "M384.43,130.91c2.13,3.55,30.17,1.37,47,1.37s50.52,2.51,52-1.76-18.25-22.73-22.85-25-48.11-3.44-52.72-.63S382.27,127.3,384.43,130.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-358",
    d: "M384.57,130.86c2.07,3.51,30.11,1.33,46.91,1.33s50.43,2.54,51.88-1.69-18.27-22.64-22.84-24.9-47.9-3.43-52.5-.63S382.46,127.28,384.57,130.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-359",
    d: "M384.7,130.81c2,3.48,30.06,1.29,46.79,1.29s50.35,2.58,51.75-1.62-18.28-22.55-22.83-24.8-47.7-3.41-52.27-.63S382.65,127.26,384.7,130.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-360",
    d: "M384.84,130.76c2,3.45,30,1.25,46.66,1.25s50.26,2.62,51.63-1.54S464.82,108,460.29,105.76s-47.48-3.4-52-.63S382.84,127.23,384.84,130.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-361",
    d: "M385,130.71c1.9,3.41,30,1.22,46.54,1.22s50.18,2.64,51.5-1.48-18.32-22.38-22.83-24.61-47.28-3.39-51.81-.62S383,127.21,385,130.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-362",
    d: "M385.11,130.66c1.84,3.38,29.9,1.18,46.4,1.18s50.1,2.68,51.39-1.4-18.34-22.31-22.84-24.52-47.06-3.37-51.58-.62S383.21,127.19,385.11,130.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-363",
    d: "M385.24,130.62c1.78,3.33,29.85,1.13,46.28,1.13s50,2.72,51.26-1.33S464.42,108.2,460,106s-46.86-3.36-51.35-.62S383.4,127.17,385.24,130.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-364",
    d: "M385.37,130.57c1.73,3.3,29.8,1.09,46.16,1.09s49.93,2.75,51.13-1.26-18.37-22.13-22.83-24.32-46.65-3.34-51.12-.62S383.59,127.15,385.37,130.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-365",
    d: "M385.51,130.52c1.67,3.27,29.74,1.06,46,1.06s49.84,2.78,51-1.19-18.4-22-22.83-24.23-46.44-3.33-50.89-.61S383.78,127.13,385.51,130.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-366",
    d: "M385.64,130.47c1.62,3.23,29.7,1,45.91,1s49.76,2.82,50.88-1.12-18.41-22-22.83-24.13-46.23-3.31-50.66-.61S384,127.11,385.64,130.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-367",
    d: "M385.78,130.42c1.55,3.2,29.64,1,45.78,1s49.67,2.85,50.75-1.05-18.43-21.87-22.82-24-46-3.3-50.44-.61S384.15,127.09,385.78,130.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-368",
    d: "M385.91,130.37c1.5,3.16,29.59.94,45.66.94s49.58,2.89,50.63-1-18.45-21.79-22.82-24-45.82-3.28-50.21-.6S384.34,127.06,385.91,130.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-369",
    d: "M386.05,130.33c1.44,3.12,29.53.9,45.53.9s49.5,2.91,50.5-.91-18.46-21.7-22.82-23.85-45.6-3.26-50-.6S384.53,127,386.05,130.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M386.18,130.28c1.39,3.08,29.48.86,45.41.86s49.41,3,50.38-.83-18.49-21.62-22.82-23.76-45.4-3.25-49.75-.59S384.72,127,386.18,130.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-371",
    d: "M386.31,130.23c1.33,3.05,29.44.82,45.29.82s49.33,3,50.25-.76-18.5-21.53-22.82-23.66-45.18-3.23-49.52-.59S384.91,127,386.31,130.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-372",
    d: "M386.45,130.18c1.27,3,29.38.78,45.15.78s49.25,3,50.13-.69-18.52-21.44-22.81-23.56-45-3.22-49.29-.59S385.1,127,386.45,130.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-373",
    d: "M386.58,130.13c1.22,3,29.33.74,45,.74s49.17,3.06,50-.61-18.54-21.36-22.82-23.47-44.77-3.2-49.06-.59S385.29,127,386.58,130.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-374",
    d: "M386.72,130.08c1.16,2.95,29.27.71,44.9.71s49.08,3.09,49.88-.55S462.94,109,458.69,106.87s-44.56-3.19-48.83-.59S385.48,126.93,386.72,130.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M386.85,130c1.1,2.91,29.23.67,44.78.67s49,3.12,49.76-.48S462.81,109,458.57,107s-44.35-3.18-48.6-.58S385.67,126.91,386.85,130Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-376",
    d: "M387,130c1,2.87,29.17.62,44.65.62s48.91,3.16,49.63-.4-18.6-21.1-22.81-23.18-44.14-3.16-48.38-.58S385.85,126.89,387,130Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-377",
    d: "M387.12,129.94c1,2.83,29.12.58,44.53.58s48.82,3.2,49.5-.33-18.61-21-22.8-23.08-43.94-3.15-48.15-.58S386,126.87,387.12,129.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-378",
    d: "M387.25,129.89c.94,2.8,29.07.55,44.41.55s48.74,3.22,49.38-.26-18.63-20.93-22.81-23-43.72-3.13-47.92-.58S386.23,126.84,387.25,129.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-379",
    d: "M387.39,129.84c.88,2.76,29,.51,44.28.51s48.65,3.26,49.25-.19-18.65-20.84-22.8-22.89-43.52-3.12-47.69-.57S386.43,126.82,387.39,129.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-380",
    d: "M387.52,129.79c.83,2.73,29,.47,44.16.47s48.56,3.3,49.13-.12S462.14,109.39,458,107.35s-43.3-3.1-47.46-.57S386.62,126.8,387.52,129.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-381",
    d: "M387.66,129.74c.77,2.69,28.91.43,44,.43s48.49,3.33,49,0-18.69-20.67-22.8-22.7-43.1-3.09-47.23-.57S386.81,126.78,387.66,129.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-382",
    d: "M387.79,129.7c.72,2.65,28.86.39,43.9.39s48.4,3.36,48.88,0-18.7-20.58-22.8-22.6-42.89-3.07-47-.57S387,126.75,387.79,129.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-383",
    d: "M387.93,129.65c.66,2.61,28.8.35,43.77.35s48.32,3.4,48.76.1-18.73-20.5-22.8-22.51S415,104.53,410.89,107,387.19,126.73,387.93,129.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-384",
    d: "M388.06,129.6c.61,2.58,28.75.31,43.65.31s48.23,3.43,48.63.17-18.74-20.41-22.8-22.41-42.47-3-46.54-.56S387.38,126.71,388.06,129.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-385",
    d: "M388.19,129.55c.56,2.54,28.71.27,43.53.27s48.15,3.47,48.5.24-18.75-20.32-22.79-22.32-42.26-3-46.32-.55S387.57,126.69,388.19,129.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-386",
    d: "M388.33,129.5c.5,2.51,28.65.24,43.4.24s48.06,3.5,48.38.31-18.78-20.25-22.79-22.23-42.06-3-46.09-.55S387.76,126.67,388.33,129.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-387",
    d: "M388.46,129.45c.45,2.47,28.6.2,43.28.2s48,3.53,48.25.38S461.2,109.87,457.2,107.9s-41.84-3-45.86-.55S388,126.64,388.46,129.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-388",
    d: "M388.6,129.4c.39,2.44,28.54.16,43.15.16s47.89,3.57,48.13.45-18.82-20.07-22.79-22-41.64-3-45.63-.55S388.15,126.62,388.6,129.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-389",
    d: "M388.73,129.36c.34,2.39,28.5.11,43,.11s47.8,3.6,48,.53S460.93,110,457,108.06s-41.42-3-45.4-.54S388.34,126.6,388.73,129.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-390",
    d: "M388.87,129.31c.28,2.36,28.44.08,42.89.08s47.73,3.63,47.88.59-18.85-19.9-22.78-21.84-41.22-3-45.17-.54S388.53,126.58,388.87,129.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-391",
    d: "M389,129.26c.24,2.32,28.39,0,42.77,0s47.64,3.67,47.76.67-18.87-19.82-22.79-21.75-41-2.94-44.94-.54S388.73,126.56,389,129.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-392",
    d: "M389.13,129.21c.19,2.29,28.34,0,42.65,0s47.55,3.7,47.63.74-18.89-19.73-22.78-21.65-40.8-2.92-44.71-.54S388.92,126.53,389.13,129.21Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-419",
    cx: 394.3,
    cy: 129.95,
    rx: 13.7,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-420",
    cx: 472.75,
    cy: 129.95,
    rx: 13.7,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-421",
    d: "M485.12,68.41a276.37,276.37,0,0,0-8.83-62.65,6.24,6.24,0,0,0-5.81-4.57S456,0,432.73,0c-20.61,0-35.07,1.2-35.07,1.2a6.24,6.24,0,0,0-5.81,4.57A276.39,276.39,0,0,0,383,68.43c-.87,35.54,3.13,45.67,3.13,45.67H482S486,104,485.12,68.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-395",
    d: "M481.38,120.71H466.53a.3.3,0,0,1-.31-.18l-1.19-7h16.66v6.93C481.69,120.62,481.55,120.71,481.38,120.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-395",
    d: "M401.19,120.71H386.34c-.17,0-.31-.09-.31-.2v-6.93h16.66l-1.19,7A.3.3,0,0,1,401.19,120.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-422",
    d: "M467.28,111.53h12.16a0,0,0,0,1,0,0v16.66a1.77,1.77,0,0,1-1.77,1.77H469a1.77,1.77,0,0,1-1.77-1.77V111.53A0,0,0,0,1,467.28,111.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-423",
    d: "M388.5,111.53h12.16a0,0,0,0,1,0,0v16.66a1.77,1.77,0,0,1-1.77,1.77h-8.62a1.77,1.77,0,0,1-1.77-1.77V111.53A0,0,0,0,1,388.5,111.53Z"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-121",
    width: 50,
    height: 9,
    transform: "translate(383.29 72.15)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAJCAYAAABwgn/fAAAACXBIWXMAAAsSAAALEgHS3X78AAAAoklEQVQ4T9WTsQ7CIBRF73MlLPxIran1/4fyAdbGhtEOLCxsbM9JI8RIrVrbk9wEyH0kJwHSuuEQAqpqDyklYaUQM/PjwTBcYIxBWe6glAKAVchR4hFtAMBai74/o64PEEIACxVLRZ4RFZxzaNvj4sTGiKREA957dN0JRbH9rxgzf5oIrZvbMjf31WQLb+bO3EJTntYYfnLpKza5wkQIM/+VK+RIZ3gdZtgAAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-424",
    d: "M434.08,78.62A3.66,3.66,0,1,1,437.74,75,3.66,3.66,0,0,1,434.08,78.62Zm0-7.1A3.45,3.45,0,1,0,437.52,75,3.45,3.45,0,0,0,434.08,71.52Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-425",
    d: "M389,57.06c1.29-.59,20.16,19.66,20.16,21.21S392,75.88,390.85,74.69,387.78,57.6,389,57.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-426",
    d: "M389.23,57.4c1.22-.59,19.6,19.18,19.54,20.65s-16.07-2.22-17.22-3.41S388.07,58,389.23,57.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-427",
    d: "M389.49,57.75c1.16-.6,19,18.68,18.92,20.08s-15-2-16.16-3.24S388.36,58.33,389.49,57.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-428",
    d: "M389.76,58.09c1.09-.6,18.47,18.2,18.3,19.52s-14-1.87-15.11-3.07S388.65,58.7,389.76,58.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-429",
    d: "M390,58.43c1-.6,17.92,17.72,17.68,18.95s-12.91-1.69-14.05-2.88S388.94,59.07,390,58.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-430",
    d: "M390.29,58.78c1-.6,17.35,17.23,17.06,18.38s-11.87-1.52-13-2.71S389.23,59.44,390.29,58.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-431",
    d: "M390.55,59.12c.9-.59,16.79,16.75,16.44,17.82s-10.81-1.34-11.93-2.54S389.52,59.81,390.55,59.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-432",
    d: "M390.82,59.47c.83-.6,16.23,16.26,15.82,17.25s-9.77-1.17-10.88-2.36S389.82,60.18,390.82,59.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-433",
    d: "M391.09,59.81c.76-.59,15.66,15.78,15.19,16.69s-8.71-1-9.82-2.19S390.11,60.56,391.09,59.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-434",
    d: "M391.35,60.16c.71-.59,15.1,15.29,14.58,16.12s-7.67-.82-8.77-2S390.41,60.93,391.35,60.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-435",
    d: "M391.62,60.5c.64-.57,14.54,14.81,13.95,15.55s-6.61-.64-7.71-1.84S390.7,61.31,391.62,60.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-436",
    d: "M391.88,60.85c.59-.57,14,14.32,13.34,15s-5.57-.47-6.66-1.66S391,61.69,391.88,60.85Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M375.63,53h3.81c1.1,0,2-.58,2-1.29V42.55c0-.78-1-1.41-2.17-1.41h-3.69a1.09,1.09,0,0,0-1,.46,11.43,11.43,0,0,0-1.16,5.21,15.22,15.22,0,0,0,1.2,5.71A1,1,0,0,0,375.63,53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M375.65,53h3.67c1.11,0,2-.58,2-1.3v-9c0-.77-1-1.4-2.16-1.4H375.6a1.06,1.06,0,0,0-1,.45,11.63,11.63,0,0,0-1.13,5.16,15.24,15.24,0,0,0,1.16,5.64A1,1,0,0,0,375.65,53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M375.67,52.88h3.54c1.1,0,2-.58,2-1.3v-8.9c0-.77-1-1.4-2.16-1.4h-3.43a1,1,0,0,0-.95.45,11.68,11.68,0,0,0-1.1,5.11,15.15,15.15,0,0,0,1.13,5.55A1,1,0,0,0,375.67,52.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M375.69,52.81h3.4c1.11,0,2-.59,2-1.31V42.75c0-.77-1-1.4-2.15-1.4h-3.31a1,1,0,0,0-.94.45,11.92,11.92,0,0,0-1.06,5.05,15.19,15.19,0,0,0,1.09,5.48A1,1,0,0,0,375.69,52.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M375.71,52.74H379c1.12,0,2-.59,2-1.31V42.81c0-.76-1-1.39-2.15-1.39h-3.17a1,1,0,0,0-.93.45,11.86,11.86,0,0,0-1,5,15.29,15.29,0,0,0,1.06,5.4A1,1,0,0,0,375.71,52.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M375.72,52.67h3.14c1.11,0,2-.59,2-1.31V42.88c0-.77-1-1.39-2.14-1.39h-3.05a1,1,0,0,0-.92.44,12.25,12.25,0,0,0-1,5,15.1,15.1,0,0,0,1,5.32A1,1,0,0,0,375.72,52.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M375.74,52.59h3c1.12,0,2-.58,2-1.31V43c0-.77-1-1.39-2.14-1.39h-2.92a1,1,0,0,0-.91.44,12.37,12.37,0,0,0-1,4.89,15,15,0,0,0,1,5.24A1,1,0,0,0,375.74,52.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M375.76,52.52h2.87c1.12,0,2-.58,2-1.31V43c0-.76-.95-1.37-2.12-1.37h-2.8a.94.94,0,0,0-.89.43,12.47,12.47,0,0,0-.95,4.84,15,15,0,0,0,1,5.16A.93.93,0,0,0,375.76,52.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M375.78,52.45h2.73c1.12,0,2-.59,2-1.31V43.08c0-.76-1-1.37-2.12-1.37h-2.67a.93.93,0,0,0-.88.43,12.62,12.62,0,0,0-.91,4.78,14.89,14.89,0,0,0,.93,5.08A.92.92,0,0,0,375.78,52.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M375.8,52.38h2.59c1.13,0,2-.59,2-1.32V43.15c0-.76-.94-1.37-2.11-1.37h-2.55a.89.89,0,0,0-.86.43,12.77,12.77,0,0,0-.89,4.72,15.11,15.11,0,0,0,.9,5A.91.91,0,0,0,375.8,52.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M375.81,52.31h2.47c1.13,0,2-.59,2-1.32V43.21c0-.75-.94-1.36-2.11-1.36h-2.42a.9.9,0,0,0-.85.42,13.08,13.08,0,0,0-.85,4.68,15.21,15.21,0,0,0,.86,4.92A.89.89,0,0,0,375.81,52.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M375.83,52.24h2.33c1.13,0,2-.59,2-1.32V43.28c0-.75-.94-1.36-2.1-1.36h-2.3a.89.89,0,0,0-.84.42,13.52,13.52,0,0,0-.82,4.62A15.14,15.14,0,0,0,375,51.8.89.89,0,0,0,375.83,52.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M375.85,52.17h2.2c1.13,0,2.05-.59,2.05-1.33V43.35c0-.75-.94-1.36-2.1-1.36h-2.16a.85.85,0,0,0-.83.42,13.44,13.44,0,0,0-.8,4.57,14.89,14.89,0,0,0,.81,4.76A.85.85,0,0,0,375.85,52.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M375.87,52.1h2.06c1.14,0,2.06-.6,2.06-1.33V43.41c0-.74-.94-1.35-2.09-1.35h-2a.84.84,0,0,0-.82.42,13.68,13.68,0,0,0-.76,4.51,14.9,14.9,0,0,0,.77,4.68A.83.83,0,0,0,375.87,52.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M375.89,52h1.92c1.14,0,2.06-.6,2.06-1.34V43.48c0-.75-.93-1.35-2.08-1.35h-1.91a.83.83,0,0,0-.81.42,14.25,14.25,0,0,0-.73,4.46,15.29,15.29,0,0,0,.74,4.6A.83.83,0,0,0,375.89,52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M375.9,52h1.8c1.14,0,2.06-.6,2.06-1.34V43.55c0-.75-.93-1.35-2.07-1.35H375.9a.81.81,0,0,0-.79.41,14.37,14.37,0,0,0-.7,4.41,15.35,15.35,0,0,0,.7,4.52A.8.8,0,0,0,375.9,52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M375.92,51.89h1.66c1.15,0,2.07-.6,2.07-1.34V43.61c0-.74-.92-1.34-2.07-1.34h-1.66a.79.79,0,0,0-.78.41,15,15,0,0,0-.67,4.35,15.55,15.55,0,0,0,.67,4.45A.79.79,0,0,0,375.92,51.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M377.47,46.19c-.14-.46,1.66,6.42,3.32,6.15.91-.14.21-10.28-.51-10.67s-3.54-.61-4.13-.14S377.65,46.78,377.47,46.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M377.54,46c-.13-.42,1.57,6,3.15,5.79.87-.14.23-9.65-.44-10s-3.34-.6-3.91-.15S377.71,46.5,377.54,46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M377.61,45.72c-.12-.37,1.48,5.67,3,5.44.83-.13.25-9-.37-9.39s-3.14-.58-3.7-.17S377.77,46.22,377.61,45.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M377.68,45.49c-.11-.33,1.4,5.29,2.8,5.08.81-.12.28-8.39-.3-8.75s-2.93-.57-3.47-.18S377.83,45.94,377.68,45.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M377.75,45.26c-.11-.29,1.31,4.91,2.63,4.71.77-.11.3-7.75-.23-8.1a5.2,5.2,0,0,0-3.25-.2C376.38,42,377.88,45.65,377.75,45.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M377.82,45c-.1-.25,1.22,4.53,2.46,4.35.73-.1.33-7.12-.17-7.46a4.75,4.75,0,0,0-3-.21C376.58,42,377.94,45.37,377.82,45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M377.89,44.8c-.09-.21,1.13,4.15,2.29,4,.69-.1.35-6.49-.1-6.82a4.42,4.42,0,0,0-2.8-.23C376.79,42,378,45.09,377.89,44.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M378,44.57c-.08-.17,1,3.77,2.12,3.63.65-.09.37-5.86,0-6.18a4,4,0,0,0-2.58-.24C377,42,378.06,44.8,378,44.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M378,44.33c-.07-.12,1,3.4,2,3.27.61-.07.39-5.22,0-5.53a3.57,3.57,0,0,0-2.35-.26C377.2,42.05,378.12,44.52,378,44.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M378.1,44.1c-.06-.08.87,3,1.77,2.91.58-.07.42-4.6.11-4.89a3.12,3.12,0,0,0-2.14-.27C377.41,42.06,378.19,44.24,378.1,44.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M378.17,43.87c-.05,0,.78,2.64,1.6,2.55.54-.06.44-4,.17-4.24a2.74,2.74,0,0,0-1.91-.3C377.61,42.06,378.25,44,378.17,43.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M378.24,43.64c-.05,0,.69,2.26,1.43,2.18.51,0,.46-3.33.24-3.59a2.29,2.29,0,0,0-1.69-.31C377.82,42.07,378.29,43.68,378.24,43.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M378.31,43.41s.61,1.88,1.26,1.82c.47,0,.49-2.7.31-2.95a1.89,1.89,0,0,0-1.47-.32C378,42.07,378.35,43.4,378.31,43.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M378.38,43.17c0,.09.52,1.51,1.09,1.47s.51-2.07.37-2.31A1.47,1.47,0,0,0,378.6,42C378.23,42.08,378.4,43.11,378.38,43.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M378.45,42.94c0,.13.43,1.13.92,1.11s.53-1.44.44-1.67-.67-.41-1-.35S378.47,42.83,378.45,42.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M378.52,42.71c0,.17.34.76.74.74s.56-.8.51-1-.46-.4-.8-.37S378.53,42.55,378.52,42.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M378.59,42.48c0,.21.25.38.57.38s.58-.17.58-.38-.26-.38-.58-.38S378.59,42.27,378.59,42.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-437",
    d: "M378.41,53.36l5.25,2.06.56-6.56s-5.59-2.62-6.78-2.34a1.66,1.66,0,0,0-.72.55A4,4,0,0,0,378.41,53.36Z"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-121",
    width: 30,
    height: 18,
    transform: "translate(382.29 71.15)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAASCAYAAABM8m7ZAAAACXBIWXMAAAsSAAALEgHS3X78AAACT0lEQVRIS72UTU/qQBSGn2lLRyj9EixiWIALXLrz//8AE91JwsIaYkBMhEIrMqHO3Uiv5IJBL/e+q9Mz0/ejnTlCa02aphrAtm1s2xb8B1iz2Uzf3d3hui7z+RwppS6Xy1SrVaSU1Ot1gIObEb1eT0dRRJqmhdhyucSyLPr9PsvlEs/zcByHUqmE7/tUq9W/NlIIu66LZVkCYLVaaSEEQgiSJME0TQzDIMsy4jjGMAw8z8P3fU5OTjBN89tGxO3trb68vCyed+zTk8kEgDAMAZhMJoWR4+NjoiiiVqshhNjLhOj1errVauE4Duz5L/M817PZjCAIAFgsFoxGI4bDIfV6nUajQRAEX3IVn/ojyV7CW6DXxdPTEw8PD/i+z/n5OaVSaSunIaXc1v8uBCDyPMe2ba6uroiiiOvra0ajUWFq44XBYPD5+vw08Qbm87leH8jhcEiapnQ6nY3bYFiWxWKxQCn1Fde34LquqFQqAqDT6dBqtbi5uWE6nRbpDcdxcByHcrm8m+mHODo6EnmeA9DtdonjuFgzXNcVcRzz+voKnw7JoWCapgjDcD2OGY/HGsAAaDabJEnCarX6muXnEGEYcnZ2xsvLC/AhfHp6KsbjMUopkiQ5eOo1giDgYxBpY91st9sMBgMAlFL/QlxkWYbv+0ynUwrhWq0mAB4fHwHIskwfOn2lUqHZbPL29obQepP7+flZ39/f0263kVLy/v5Ov9/fQfUb+4xorTVSShqNxp/C6z1xHJMkSdFQSm2Qr+ttvV21UgrP87i4uBC/AORv7hXG6OCqAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-438",
    d: "M410.1,88.15H391.31c-4.07,0-6.63-3.07-8.08-7.88a50.54,50.54,0,0,1-.66-6.25c0-.83.57-1.47,1.22-1.37,4.62.74,20,3.52,24.66,8.37,1.46,1.51,2.14,4.29,2.43,5.9A1,1,0,0,1,410.1,88.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-439",
    d: "M391.31,86.19c-3.4,0-5.42-2.58-6.63-6.62a39.74,39.74,0,0,1-.51-4.88c9.64,1.57,19.91,4.34,23.3,7.85a8.29,8.29,0,0,1,1.65,3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-440",
    d: "M402.25,86.29a3.19,3.19,0,1,1,3-3.18A3,3,0,0,1,402.25,86.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-441",
    d: "M404.08,83.11a1.83,1.83,0,1,1-1.83-1.74A1.79,1.79,0,0,1,404.08,83.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-442",
    d: "M392.67,86.29a4.92,4.92,0,1,1,5.12-4.92A5,5,0,0,1,392.67,86.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M396.37,81.37a3.76,3.76,0,0,1-7.41,0c0-1.72,1.66-3.11,3.71-3.11A3.44,3.44,0,0,1,396.37,81.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-443",
    d: "M388,77.45a2.05,2.05,0,1,1-4.05,0,2.07,2.07,0,1,1,4.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M385.19,82.74a16,16,0,0,1-2.09-9.87,1.44,1.44,0,0,0-.53,1.15,50.54,50.54,0,0,0,.66,6.25c1.45,4.81,4,7.88,8.08,7.88H410.1a.71.71,0,0,0,.5-.25c-.09,0-12.61.22-20.45-1.25A7.78,7.78,0,0,1,385.19,82.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-444",
    d: "M384,72.68a11,11,0,0,0,2.91,6.54c2.86,3.09,22.88,7.13,23,6.7a11.59,11.59,0,0,0-1.9-5.3C402.88,76.07,388.67,73.44,384,72.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-445",
    d: "M384.9,73.53c0,.58,14.47,3.9,18.4,5.72s5.12,4.07,5.49,3.86-1.73-3.3-5.1-4.85S384.9,72.72,384.9,73.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M390.85,76.71a7.76,7.76,0,0,1,3.61.45,9.23,9.23,0,0,1,2.85,2.09,4.83,4.83,0,0,0-2.61-2.42C393.45,76.31,390.91,76.39,390.85,76.71Z"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-74",
    width: 4,
    height: 20,
    transform: "translate(386.29 55.15)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAUCAYAAACqJ5zlAAAACXBIWXMAAAsSAAALEgHS3X78AAAA00lEQVQYV13PP0tCcRjF8W83QW0J3bR3EDo1SIJTi5i9rqglhzsJ0hQ0RC+gcAmCpuoF1GZo0MXoj6b399zjcMmfdcYP5/Dw0OuGOjsNJQlJBINhxFa5xG8CALPkL8zj+B/MHZ2TjpYAkMvmfGM1AcDr2zuFzaKH78kP60HGw8fXlIfH+3QjiV43VLt1IElpYzKdcd2/8pONfJbd2o6HJBH7zT0PzhnVyvYKmPEyirg4v1QGIHZGNP7k+WmYnpXE8dGhAC1/cWY06jX/nHPGze3d2gJy42Dj5aVt3wAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-121",
    width: 52,
    height: 9,
    transform: "translate(432.29 72.15)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAAJCAYAAAB9nA+YAAAACXBIWXMAAAsSAAALEgHS3X78AAAAnElEQVQ4T2P8//8/wzAAcE+w4FM1iAHWWDhx4jgD4xCJIayOPHv2DAMPDy+Duro6I0Ll//+DEWMFx44d/U9ILyGD6YWxAmI8gI4HOsnBLf/79y/DqVMnGcTFxRmUlJQRSYhEMFAeglt6795dBhEREQY+Pn6yPYEMGP8PkI+OHz/GYGhoxMDBwUEVj8DAgHjo3bu3DEJCwlT1CAwAAIBbcL8WQCGJAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-446",
    d: "M457,80.5H410.9l2.43,8.72a3.09,3.09,0,0,0,3,2.27l35.32,0a3.08,3.08,0,0,0,3-2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-447",
    d: "M480.6,55.4s-1.19-21.27-5.13-33h-82.8c-3.94,11.77-5.13,33-5.13,33s34,1.6,45.3,1.61C444.79,57,480.6,55.4,480.6,55.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-448",
    d: "M479.18,54.46s-1.16-19.13-5-29.71H432.6v0H393.94c-3.82,10.58-5,29.71-5,29.71s32.9,1.69,43.88,1.7C444.43,56.19,479.18,54.46,479.18,54.46Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-425",
    d: "M479.18,57C477.89,56.45,459,76.7,459,78.26s17.12-2.1,18.27-3.3S480.36,57.59,479.18,57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-426",
    d: "M478.91,57.39c-1.22-.6-19.59,19.17-19.54,20.65s16.07-2,17.22-3.15S480.07,58,478.91,57.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-427",
    d: "M478.65,57.73c-1.16-.6-19,18.69-18.92,20.08s15-1.8,16.16-3S479.78,58.32,478.65,57.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-428",
    d: "M478.38,58.08c-1.09-.6-18.47,18.2-18.3,19.51s14-1.65,15.11-2.85S479.49,58.69,478.38,58.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-429",
    d: "M478.12,58.42c-1-.6-17.91,17.72-17.68,19s12.92-1.51,14.05-2.7S479.2,59.05,478.12,58.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-430",
    d: "M477.85,58.77c-1-.6-17.35,17.23-17.06,18.38s11.87-1.36,13-2.56S478.91,59.42,477.85,58.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-431",
    d: "M477.59,59.11c-.9-.6-16.79,16.75-16.44,17.82s10.82-1.21,11.94-2.41S478.62,59.8,477.59,59.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-432",
    d: "M477.32,59.45c-.83-.59-16.23,16.27-15.82,17.26s9.77-1.07,10.89-2.26S478.32,60.17,477.32,59.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-433",
    d: "M477.06,59.8c-.77-.59-15.67,15.77-15.2,16.68s8.72-.91,9.82-2.11S478,60.54,477.06,59.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-434",
    d: "M476.79,60.14c-.71-.58-15.1,15.29-14.58,16.12s7.67-.77,8.77-2S477.73,60.92,476.79,60.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-435",
    d: "M476.53,60.49c-.65-.58-14.55,14.8-14,15.55s6.62-.62,7.71-1.81S477.44,61.3,476.53,60.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-436",
    d: "M476.26,60.83c-.59-.57-14,14.32-13.34,15s5.57-.47,6.66-1.67S477.14,61.68,476.26,60.83Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M492.51,53H488.7c-1.1,0-2-.57-2-1.29V42.53c0-.77,1-1.4,2.17-1.4h3.68a1.1,1.1,0,0,1,1,.45,11.51,11.51,0,0,1,1.16,5.21,15.29,15.29,0,0,1-1.2,5.72A1.06,1.06,0,0,1,492.51,53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M492.49,52.93h-3.67c-1.11,0-2-.58-2-1.29v-9c0-.77,1-1.4,2.16-1.4h3.56a1.09,1.09,0,0,1,1,.45,11.73,11.73,0,0,1,1.12,5.16,15.29,15.29,0,0,1-1.16,5.64A1.05,1.05,0,0,1,492.49,52.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M492.47,52.86h-3.54c-1.1,0-2-.58-2-1.3V42.67c0-.78,1-1.4,2.16-1.4h3.43a1,1,0,0,1,1,.45,11.67,11.67,0,0,1,1.1,5.1,15.16,15.16,0,0,1-1.13,5.56A1,1,0,0,1,492.47,52.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M492.45,52.79h-3.4c-1.11,0-2-.58-2-1.3V42.73c0-.77,1-1.39,2.15-1.39h3.31a1,1,0,0,1,.94.44,12,12,0,0,1,1.06,5.06,15.07,15.07,0,0,1-1.09,5.47A1,1,0,0,1,492.45,52.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M492.44,52.72h-3.27c-1.12,0-2-.58-2-1.3V42.8c0-.77,1-1.39,2.15-1.39h3.18a1,1,0,0,1,.92.44,11.88,11.88,0,0,1,1,5,15.34,15.34,0,0,1-1.06,5.4A1,1,0,0,1,492.44,52.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M492.42,52.65h-3.14c-1.11,0-2-.58-2-1.31V42.87c0-.77,1-1.39,2.14-1.39h3.06a1,1,0,0,1,.91.44,12.19,12.19,0,0,1,1,4.94,15.23,15.23,0,0,1-1,5.32A1,1,0,0,1,492.42,52.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M492.4,52.58h-3c-1.12,0-2-.59-2-1.31V42.93c0-.76.95-1.38,2.13-1.38h2.92a1,1,0,0,1,.91.44,12.32,12.32,0,0,1,1,4.89,15,15,0,0,1-1,5.24A1,1,0,0,1,492.4,52.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M492.38,52.51h-2.87c-1.12,0-2-.59-2-1.31V43c0-.76.95-1.38,2.12-1.38h2.8a.94.94,0,0,1,.89.44,12.22,12.22,0,0,1,.95,4.83,14.94,14.94,0,0,1-1,5.16A.93.93,0,0,1,492.38,52.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M492.36,52.44h-2.73c-1.12,0-2-.59-2-1.32v-8c0-.76.95-1.38,2.12-1.38h2.67a1,1,0,0,1,.88.43,12.73,12.73,0,0,1,.91,4.79,15,15,0,0,1-.93,5.08A.93.93,0,0,1,492.36,52.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M492.35,52.37h-2.6c-1.13,0-2-.59-2-1.32V43.13c0-.75,1-1.37,2.11-1.37h2.55a.93.93,0,0,1,.87.43,12.84,12.84,0,0,1,.88,4.73,15.17,15.17,0,0,1-.9,5A.92.92,0,0,1,492.35,52.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M492.33,52.3h-2.47c-1.12,0-2-.59-2-1.33V43.2c0-.76.94-1.37,2.11-1.37h2.42a.9.9,0,0,1,.85.43,13,13,0,0,1,.86,4.67,15.22,15.22,0,0,1-.87,4.93A.9.9,0,0,1,492.33,52.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M492.31,52.23H490c-1.13,0-2.05-.6-2.05-1.33V43.27c0-.76.94-1.37,2.1-1.37h2.3a.88.88,0,0,1,.84.43A13.22,13.22,0,0,1,494,47a15.25,15.25,0,0,1-.83,4.84A.87.87,0,0,1,492.31,52.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M492.29,52.16H490.1c-1.14,0-2.06-.6-2.06-1.33v-7.5c0-.75.94-1.36,2.1-1.36h2.17a.88.88,0,0,1,.83.43,13.69,13.69,0,0,1,.79,4.56,15.19,15.19,0,0,1-.8,4.76A.86.86,0,0,1,492.29,52.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M492.27,52.09h-2.06c-1.13,0-2-.6-2-1.34V43.4c0-.75.93-1.35,2.08-1.35h2.05a.84.84,0,0,1,.81.41,13.76,13.76,0,0,1,.76,4.52,15,15,0,0,1-.77,4.68A.83.83,0,0,1,492.27,52.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M492.26,52h-1.93c-1.14,0-2.06-.6-2.06-1.34V43.47c0-.75.93-1.35,2.08-1.35h1.91a.84.84,0,0,1,.81.41A14.31,14.31,0,0,1,493.8,47a15,15,0,0,1-.74,4.6A.81.81,0,0,1,492.26,52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M492.24,51.94h-1.8c-1.14,0-2.06-.59-2.06-1.33V43.53c0-.74.93-1.34,2.07-1.34h1.79a.81.81,0,0,1,.79.41,14.24,14.24,0,0,1,.71,4.41,15.39,15.39,0,0,1-.71,4.52A.81.81,0,0,1,492.24,51.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M492.22,51.87h-1.66c-1.14,0-2.07-.6-2.07-1.34V43.6c0-.74.93-1.34,2.07-1.34h1.66a.79.79,0,0,1,.78.41,14.9,14.9,0,0,1,.67,4.35,15.47,15.47,0,0,1-.67,4.44A.79.79,0,0,1,492.22,51.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M490.67,46.17c.14-.45-1.66,6.43-3.32,6.16-.91-.15-.21-10.28.51-10.68s3.54-.61,4.13-.13S490.49,46.77,490.67,46.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M490.6,45.94c.13-.41-1.57,6.05-3.15,5.8-.87-.14-.23-9.65.44-10s3.34-.6,3.92-.16S490.44,46.49,490.6,45.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M490.53,45.71c.12-.37-1.48,5.67-3,5.43-.84-.12-.26-9,.36-9.38s3.14-.59,3.7-.17S490.38,46.2,490.53,45.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M490.46,45.48c.12-.33-1.39,5.28-2.8,5.07-.8-.12-.28-8.39.3-8.74a5.6,5.6,0,0,1,3.47-.19C492,42,490.32,45.92,490.46,45.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M490.39,45.25c.11-.29-1.31,4.9-2.63,4.71-.77-.11-.3-7.76.23-8.1a5.13,5.13,0,0,1,3.25-.2C491.76,42,490.26,45.64,490.39,45.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M490.32,45c.1-.24-1.22,4.53-2.46,4.36-.73-.11-.32-7.13.17-7.46a4.76,4.76,0,0,1,3-.22C491.56,42,490.2,45.36,490.32,45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M490.25,44.78c.09-.2-1.13,4.15-2.29,4-.69-.09-.35-6.49.1-6.81a4.29,4.29,0,0,1,2.8-.23C491.35,42,490.14,45.07,490.25,44.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M490.18,44.55c.08-.16-1,3.77-2.12,3.63-.65-.08-.37-5.86,0-6.17a4,4,0,0,1,2.58-.25C491.15,42,490.08,44.79,490.18,44.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M490.11,44.32c.07-.13-.95,3.39-1.94,3.27-.62-.08-.4-5.23,0-5.53a3.53,3.53,0,0,1,2.36-.26C490.94,42,490,44.51,490.11,44.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M490,44.09c.06-.09-.87,3-1.77,2.91-.58-.07-.42-4.6-.11-4.89a3.13,3.13,0,0,1,2.14-.27C490.74,42,490,44.22,490,44.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M490,43.86s-.78,2.63-1.6,2.54c-.54-.06-.44-4-.17-4.24a2.69,2.69,0,0,1,1.91-.29C490.53,42.05,489.89,43.94,490,43.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M489.9,43.62c.05,0-.69,2.27-1.43,2.19-.5-.05-.46-3.33-.24-3.6a2.29,2.29,0,0,1,1.69-.3C490.32,42.05,489.85,43.66,489.9,43.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M489.83,43.39s-.6,1.89-1.26,1.83c-.47,0-.48-2.7-.31-3a1.94,1.94,0,0,1,1.47-.32C490.12,42.06,489.79,43.38,489.83,43.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M489.76,43.16c0,.08-.52,1.51-1.09,1.47s-.5-2.07-.37-2.32a1.5,1.5,0,0,1,1.24-.33C489.91,42.07,489.74,43.1,489.76,43.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M489.69,42.93c0,.13-.43,1.13-.92,1.1s-.53-1.43-.44-1.67.67-.41,1-.35S489.68,42.82,489.69,42.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M489.62,42.7c0,.17-.34.75-.74.74s-.56-.8-.51-1,.46-.39.8-.36S489.62,42.54,489.62,42.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M489.55,42.46c0,.22-.25.39-.57.39s-.58-.17-.58-.39.26-.38.58-.38S489.55,42.25,489.55,42.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-449",
    d: "M489.73,53.35l-5.25,2-.56-6.55s5.59-2.62,6.78-2.34a1.51,1.51,0,0,1,.72.54A4,4,0,0,1,489.73,53.35Z"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-121",
    width: 30,
    height: 18,
    transform: "translate(456.29 71.15)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAASCAYAAABM8m7ZAAAACXBIWXMAAAsSAAALEgHS3X78AAAB8UlEQVRIS72TQWvqUBBGT+y1aBPUhdC6qLhQBPfu4v/fieJWUKS2KkFjco1BjfMWNqmt9mGr730wm5uZe+ab3DFEhP8g0VoDYFmWAaD+mv57SRiGiEgSAKPRiHK5LEqpm4AliqJPkBjk+z7L5ZIgCPA8D9u2Wa1WZDKZX4NFa41pmglEa43rugRBgNYay7IolUrUajUAA0BExHEcLMv6ETgZXzabRWvNeDwmDEM8z6NSqfD8/Mzd3Z3x3QVvb29kMhngsn8sURSx3+8BcByHyWSCaZo0Gg14d3OJoiji4eEB+B4s8bgAXNdlOp3iui71ep1ms3kx7Jy01mfBstlsABgOh8xmMwqFAo1G4yoYHO5rtVrAqWMBmM/n9Pt9bNumUqlcDTwj4xgsk8kEz/PY7XbYtn1TYBiGksvlkhcf7534vi+9Xk/edbKX18ZoNJLFYpHcn4o7CoKAfD4PP3ilP5DM53OUOhqwyMFtu91Ourl1dDqdT27l2PH9/T38A7ciIqlUikKh8OlcwWFPn56ezhZeI8dx5OXlhWq1Gh8lxoxutyvL5TLer1s5ll6vRzabTaDb7ZZ0Ov0B9n1f1us1g8HgpNowLuvjOG+/32OaJsVikcfHxyTla41SSlEsFnl9ff367VfabrcopTBNMz462/0f5+GiYRopYTwAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-450",
    d: "M458,88.14h18.79c4.07,0,6.63-3.07,8.08-7.88a50.66,50.66,0,0,0,.66-6.26c0-.82-.57-1.46-1.22-1.36-4.62.73-20,3.52-24.66,8.37-1.45,1.51-2.14,4.29-2.43,5.9C457.15,87.54,457.53,88.14,458,88.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-451",
    d: "M476.83,86.18c3.4,0,5.42-2.59,6.64-6.62a44.62,44.62,0,0,0,.51-4.89c-9.65,1.58-19.92,4.35-23.31,7.85A8.46,8.46,0,0,0,459,86.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-452",
    d: "M465.89,86.28a3.2,3.2,0,1,0-3-3.19A3,3,0,0,0,465.89,86.28Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-453",
    cx: 465.89,
    cy: 83.09,
    rx: 1.82,
    ry: 1.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-454",
    d: "M475.48,86.28a4.92,4.92,0,1,0-5.13-4.92A5,5,0,0,0,475.48,86.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M471.77,81.36a3.76,3.76,0,1,0,3.7-3.12A3.45,3.45,0,0,0,471.77,81.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-455",
    d: "M480.16,77.44a2.05,2.05,0,1,0,4,0,2.07,2.07,0,1,0-4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M483,82.72a16,16,0,0,0,2.1-9.86,1.44,1.44,0,0,1,.52,1.14,50.66,50.66,0,0,1-.66,6.26c-1.44,4.81-4,7.88-8.08,7.88H458a.69.69,0,0,1-.5-.26c.09,0,12.61.23,20.45-1.24A7.77,7.77,0,0,0,483,82.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-456",
    d: "M484.17,72.67a10.9,10.9,0,0,1-2.91,6.53c-2.85,3.1-22.87,7.13-23,6.71a11.45,11.45,0,0,1,1.91-5.3C465.26,76.06,479.47,73.42,484.17,72.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-445",
    d: "M483.25,73.52c0,.57-14.47,3.89-18.41,5.72s-5.12,4.07-5.49,3.85,1.73-3.29,5.1-4.85S483.25,72.7,483.25,73.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M477.29,76.7a7.62,7.62,0,0,0-3.61.45,9.26,9.26,0,0,0-2.84,2.09,4.83,4.83,0,0,1,2.6-2.43C474.69,76.29,477.23,76.37,477.29,76.7Z"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-74",
    width: 4,
    height: 20,
    transform: "translate(477.29 55.15)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAUCAYAAACqJ5zlAAAACXBIWXMAAAsSAAALEgHS3X78AAAAvElEQVQYV1XPvQ7BUBiH8eec2ogmUo1vicEiBhFiM3FZTfQaxB0Qd8IdIGGRpkM1krKQaI+BqPOOvzz/4RVKKQAW84XabLZIvhfHMcAfJDGe5+nF4/nQ4XaL/icvgkugF2EYppAkika9mgJApVzSoWgVdBgOejo06zUyAK7rKtuyMc1sWuRzJtfo/ikAjqcTGEkKq/WS/WEnfhPbMoHv+4YhmU7GABhSSiWlYNTv0mp3ZtJxHBGFPmf/AsAbBydFUr3I2LIAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-457",
    points: "455.26 86.86 412.67 86.86 411.79 83.69 456.15 83.69 455.26 86.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-458",
    points: "456.15 83.69 411.79 83.69 410.9 80.51 457.03 80.51 456.15 83.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-459",
    d: "M453.89,90H414.05a.65.65,0,0,1-.64-.49l-.74-2.68h42.59l-.75,2.7A.64.64,0,0,1,453.89,90Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-460",
    d: "M457,80.5H410.9l2.43,8.72a3.09,3.09,0,0,0,3,2.27l35.32,0a3.08,3.08,0,0,0,3-2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-461",
    d: "M402.69.86c-3.23.19-5,.34-5,.34a6.24,6.24,0,0,0-5.81,4.57A276.39,276.39,0,0,0,383,68.43c-.76,31,2.19,42.69,3,45.15h16.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-462",
    d: "M476.29,5.76a6.24,6.24,0,0,0-5.81-4.57S468.71,1,465.42.85V113.58h16.74c.76-2.43,3.72-14.08,3-45.17A276.37,276.37,0,0,0,476.29,5.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-463",
    d: "M450.09,101.25h-32a5.55,5.55,0,0,1-5.55-5.55h43.13A5.54,5.54,0,0,1,450.09,101.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-464",
    d: "M484.83,92.83H383.31a.7.7,0,0,0-.7.74c.09,1.79.44,6.83,1.56,14.33.33,2.23.73,4.06,1,5.14a1.37,1.37,0,0,0,1.34,1h95.14A1.37,1.37,0,0,0,483,113c.26-1.08.66-2.9,1-5.13,1.12-7.51,1.46-12.54,1.56-14.34A.7.7,0,0,0,484.83,92.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-465",
    d: "M408.83,107.8H396.61a3.64,3.64,0,0,1-3.31-2.14l-1.42-3.19H404a3.48,3.48,0,0,1,3.11,1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-466",
    d: "M418.05,101.24h32a5.55,5.55,0,0,0,5.55-5.55H412.5A5.56,5.56,0,0,0,418.05,101.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-467",
    d: "M459.31,107.79h12.22a3.63,3.63,0,0,0,3.31-2.15l1.42-3.18H464.15a3.48,3.48,0,0,0-3.11,1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-468",
    d: "M454.61,98.88a5.53,5.53,0,0,0,1-3.18H412.5a5.6,5.6,0,0,0,1,3.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-469",
    d: "M418.05,101.24h32a5.55,5.55,0,0,0,5.55-5.55H412.5A5.56,5.56,0,0,0,418.05,101.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-470",
    d: "M484.83,92.83h-6.62v21.26h3.43A1.37,1.37,0,0,0,483,113c.26-1.08.66-2.9,1-5.13,1.12-7.51,1.46-12.54,1.56-14.34A.7.7,0,0,0,484.83,92.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-471",
    d: "M389.35,92.84h-6a.7.7,0,0,0-.7.74c.09,1.79.44,6.83,1.56,14.33.33,2.23.73,4.06,1,5.14a1.37,1.37,0,0,0,1.34,1h2.85Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-411",
    x: 419.1,
    y: 104.66,
    width: 29.73,
    height: 6.29,
    rx: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-412",
    d: "M448.38,111.11H419.55a.61.61,0,0,1-.61-.62v-5.38a.61.61,0,0,1,.61-.62h28.83a.62.62,0,0,1,.62.62v5.38A.62.62,0,0,1,448.38,111.11Zm-28.83-6.29a.28.28,0,0,0-.28.29v5.38a.28.28,0,0,0,.28.29h28.83a.29.29,0,0,0,.29-.29v-5.38a.29.29,0,0,0-.29-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-472",
    d: "M392.64,22.37l-4.34-1.71a.47.47,0,0,0-.61.28l-.31.81a.77.77,0,0,0,.38,1,9.28,9.28,0,0,0,2.72.91A3.38,3.38,0,0,0,392.64,22.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-473",
    d: "M475.33,22.37l4.35-1.71a.47.47,0,0,1,.61.28l.31.81a.77.77,0,0,1-.39,1,9.21,9.21,0,0,1-2.71.91A3.38,3.38,0,0,1,475.33,22.37Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-474"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-475",
    d: "M387.76,22.71v35.8h92.89V22.71ZM457,38.78a2.48,2.48,0,0,1-2.47,2.48h-39a2.48,2.48,0,0,1-2.48-2.48V31a2.48,2.48,0,0,1,2.48-2.48h39A2.48,2.48,0,0,1,457,31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-476",
    d: "M468.18,45.19a2.66,2.66,0,0,0-2.63-2.3h-1.89V42a2.82,2.82,0,0,0-.85-5.51h-6.23a2.82,2.82,0,0,0-.84,5.51v.87h-1.9a2.65,2.65,0,0,0-2.62,2.3L449,61.56h21.35Zm-11.35-3h5.73v.73h-5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-476",
    d: "M431.15,45.19a2.66,2.66,0,0,0-2.63-2.3h-1.89V42a2.82,2.82,0,0,0-.85-5.51h-6.23a2.82,2.82,0,0,0-.84,5.51v.87h-1.9a2.65,2.65,0,0,0-2.62,2.3L412,61.56h21.35Zm-11.35-3h5.74v.73H419.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-476",
    d: "M410.57,45.19a2.66,2.66,0,0,0-2.63-2.3h-1.89V42a2.82,2.82,0,0,0-.85-5.51H399a2.82,2.82,0,0,0-.84,5.51v.87h-1.89a2.65,2.65,0,0,0-2.63,2.3l-2.2,16.37h21.35Zm-11.35-3H405v.73h-5.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-476",
    d: "M459.7,73.53a12,12,0,1,1,12-12A12.05,12.05,0,0,1,459.7,73.53Zm0-22a10,10,0,1,0,10,10A10,10,0,0,0,459.7,51.52Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-477",
    points: "471.77 24.75 475.48 54.64 456.15 55.5 455.63 24.75 471.77 24.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-478",
    points: "436.77 24.75 411.13 24.77 408.83 55.5 436.77 56.14 436.77 24.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-479",
    points: "406.57 24.77 403.47 55.41 392.34 54.65 397.31 24.77 406.57 24.77"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVanDamage);
export default __webpack_public_path__ + "static/media/van_damage.756528904484222b41f81cee6edf63cc.svg";
export { ForwardRef as ReactComponent };